var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitalization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-104.9 -160.002 1100.42 579.137",
    width: "1100.42px",
    height: "579.137px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m831.84 502.25c27.12 15.65 27.12 41.04 0 56.69c-27.12 15.65-71.08 15.66-98.19 0c-27.12-15.65-27.12-41.04 0-56.69c27.12-15.66 71.08-15.66 98.19 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m970.3 462.1l-13.63 7.97c-1.14 0.66-2.87 0.73-3.86 0.16l-42.23-24.34l-14.55 8.51c-1.14 0.66-2.87 0.73-3.86 0.16l-115.2-67.16c-0.99-0.57-0.87-1.57 0.28-2.23l14.55-8.51l-63.7-37.02c-0.99-0.57-0.87-1.57 0.28-2.23l13.63-7.97c1.14-0.66 2.87-0.73 3.86-0.16l224.71 130.6c0.99 0.57 0.87 1.57-0.28 2.23z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1159.52 406.95l-140.85 80.85c-1.66 0.96-4.55 0.84-6.46-0.27l-14.12-8.15c-1.91-1.1-2.12-2.77-0.46-3.73l140.85-80.85c1.66-0.96 4.55-0.84 6.46 0.27l14.12 8.15c1.91 1.1 2.12 2.77 0.46 3.73z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1047.6 411.26l-15.04 8.69c-1.66 0.96-4.55 0.84-6.46-0.27l-16.48-9.49c-1.91-1.1-2.19-1.93-0.53-2.88l15.97-9.3c1.66-0.96 3.69-1.07 5.6 0.04l16.48 9.49c1.91 1.1 2.12 2.77 0.46 3.73z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1067.96 390.16l-15.04 8.69c-1.66 0.96-4.55 0.84-6.46-0.27l-16.48-9.49c-1.91-1.1-2.19-1.93-0.53-2.88l15.97-9.3c1.66-0.96 3.69-1.07 5.6 0.04l16.48 9.49c1.91 1.1 2.12 2.77 0.46 3.73z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m984.15 510.88l-15.04 8.69c-1.66 0.96-4.55 0.84-6.46-0.27l-16.48-9.49c-1.91-1.1-2.19-1.93-0.53-2.88l15.97-9.3c1.66-0.96 3.69-1.07 5.6 0.04l16.48 9.49c1.91 1.1 2.12 2.77 0.46 3.73z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1147.63 466.44l-15.04 8.69c-1.66 0.96-4.55 0.84-6.46-0.27l-16.48-9.49c-1.91-1.1-2.19-1.93-0.53-2.88l15.97-9.3c1.66-0.96 3.69-1.07 5.6 0.04l16.48 9.49c1.91 1.1 2.12 2.77 0.46 3.73z"
  })), /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.s0 { fill: #117aca } \n\t\t.s1 { fill: #150035 } \n\t\t.s2 { fill: #ffffff } \n\t\t.s3 { fill: #39a1ff } \n\t\t.s4 { fill: #1a0e33 } \n\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "matrix(1, 0, 0, 1, -223.040054, -210.305542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m662.88 329.52v84.89h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-2.97 1.71-8.14 1.5-11.57-0.48l-12.37-7.14c-1.78-1.03-2.71-2.33-2.81-3.58h-0.01l-0.02-84.83c0-0.47 0.38-0.85 0.84-0.85l41.09-0.06c0.47 0 0.85 0.38 0.85 0.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m641.83 428.04c-2.49 0-5.09-0.61-7.17-1.81l-12.37-7.14c-1.61-0.93-2.71-2.11-3.18-3.41h-0.26l-0.01-1.27l-0.02-84.83c0-1.17 0.95-2.11 2.11-2.11l41.09-0.06c1.17 0 2.12 0.95 2.12 2.11v86.16h-0.15c-0.32 1.16-1.18 2.18-2.47 2.93l-14.03 8.1c-1.54 0.89-3.56 1.33-5.67 1.33zm-20.45-13.82l0.01 0.1c0.06 0.87 0.86 1.81 2.17 2.57l12.37 7.14c3.02 1.74 7.73 1.96 10.3 0.48l14.03-8.1c0.65-0.38 1.41-1.01 1.34-1.91l-0.1-1.36h0.1v-83.2l-40.25 0.06l0.02 84.22z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m662.88 329.56v84.89h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-1.03 0.6-2.34 0.94-3.74 1.08v-97.99l18.91-0.03c0.47 0 0.85 0.38 0.85 0.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m660.89 331.84l-14.03 8.1c-2.97 1.71-8.14 1.5-11.57-0.48l-12.37-7.14c-3.42-1.98-3.8-4.97-0.83-6.68l14.03-8.1c2.97-1.71 8.14-1.5 11.57 0.48l12.37 7.14c3.42 1.98 3.8 4.97 0.83 6.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m641.83 342.37c-2.49 0-5.09-0.61-7.17-1.81l-12.37-7.14c-2.2-1.27-3.47-3.05-3.47-4.87c0-1.6 0.94-3.02 2.64-4l14.03-8.1c3.37-1.94 9.01-1.73 12.84 0.48l12.37 7.14c2.2 1.27 3.47 3.05 3.47 4.87c0 1.6-0.94 3.02-2.64 4l-14.03 8.1c-1.54 0.89-3.56 1.33-5.67 1.33zm-0.69-24.71c-1.66 0-3.23 0.32-4.38 0.98l-14.03 8.1c-0.62 0.36-1.37 0.97-1.37 1.8c0 0.88 0.82 1.89 2.2 2.68l12.37 7.14c3.02 1.74 7.73 1.96 10.3 0.48l14.03-8.1c0.62-0.36 1.37-0.97 1.37-1.8c0-0.88-0.82-1.89-2.2-2.68l-12.37-7.14c-1.67-0.97-3.87-1.46-5.93-1.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m637.89 425.73h-2.54v-85.61h2.54v85.61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m659.05 415.46h-1.95v-78.76h1.95v78.76z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m634.14 402.69v41.99h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-2.97 1.71-8.14 1.5-11.57-0.48l-12.37-7.14c-1.78-1.03-2.71-2.33-2.81-3.58h-0.01l-0.02-41.93c0-0.47 0.38-0.85 0.84-0.85l41.09-0.06c0.47 0 0.85 0.38 0.85 0.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m613.09 458.31c-2.48 0-5.09-0.61-7.17-1.81l-12.37-7.14c-1.61-0.93-2.71-2.11-3.18-3.41h-0.26l-0.01-1.27l-0.02-41.93c0-1.17 0.95-2.11 2.11-2.11l41.09-0.06c1.17 0 2.12 0.95 2.12 2.11v43.26h-0.15c-0.33 1.16-1.18 2.18-2.47 2.93l-14.03 8.1c-1.54 0.89-3.56 1.33-5.67 1.33zm-20.45-13.82l0.01 0.1c0.06 0.87 0.86 1.81 2.17 2.57l12.37 7.14c3.02 1.74 7.73 1.96 10.3 0.48l14.03-8.1c0.65-0.38 1.41-1.01 1.34-1.91l-0.1-1.36h0.11v-40.3l-40.25 0.06l0.02 41.32z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m634.14 402.73v41.99h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-1.03 0.6-2.34 0.94-3.74 1.08v-55.09l18.91-0.03c0.47 0 0.85 0.38 0.85 0.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m632.15 405.01l-14.03 8.1c-2.97 1.71-8.14 1.5-11.57-0.48l-12.37-7.14c-3.42-1.98-3.8-4.97-0.83-6.68l14.03-8.1c2.97-1.71 8.14-1.5 11.57 0.48l12.37 7.14c3.42 1.98 3.8 4.97 0.83 6.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m613.09 415.53c-2.48 0-5.09-0.61-7.17-1.81l-12.37-7.14c-2.2-1.27-3.47-3.05-3.47-4.88c0-1.6 0.94-3.02 2.64-4l14.03-8.1c3.37-1.94 9-1.73 12.84 0.48l12.37 7.14c2.2 1.27 3.47 3.05 3.47 4.87c0 1.6-0.94 3.02-2.64 4l-14.03 8.1c-1.54 0.89-3.56 1.33-5.67 1.33zm-0.69-24.71c-1.66 0-3.23 0.32-4.38 0.98l-14.03 8.1c-0.62 0.36-1.37 0.97-1.37 1.8c0 0.88 0.82 1.89 2.2 2.68l12.37 7.14c3.02 1.74 7.73 1.96 10.3 0.48l14.03-8.1c0.62-0.36 1.37-0.97 1.37-1.81c0-0.88-0.82-1.89-2.2-2.68l-12.37-7.14c-1.67-0.97-3.87-1.46-5.93-1.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m609.15 456h-2.54v-42.71h2.54v42.71z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m630.3 445.73h-1.95v-35.86h1.95v35.86z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m689.2 444.62v12.74h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-2.97 1.71-8.14 1.5-11.57-0.48l-12.37-7.14c-1.78-1.03-2.71-2.33-2.81-3.58h-0.01l-0.02-12.68c0-0.47 0.38-0.85 0.84-0.85l41.09-0.06c0.47 0 0.85 0.38 0.85 0.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m668.14 470.99c-2.49 0-5.09-0.61-7.16-1.81l-12.37-7.14c-1.61-0.93-2.71-2.11-3.18-3.41h-0.26l-0.01-1.27l-0.02-12.68c0-1.17 0.95-2.12 2.11-2.12l41.09-0.06c1.17 0 2.12 0.95 2.12 2.11v14.01h-0.15c-0.33 1.16-1.18 2.18-2.47 2.93l-14.03 8.1c-1.54 0.89-3.57 1.33-5.67 1.33zm-20.45-13.82l0.01 0.1c0.06 0.87 0.86 1.81 2.17 2.57l12.37 7.14c3.01 1.74 7.73 1.96 10.3 0.48l14.03-8.1c0.65-0.38 1.41-1.01 1.34-1.91l-0.1-1.36h0.11v-11.05l-40.25 0.06l0.01 12.07z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m689.2 444.66v12.74h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-1.03 0.6-2.34 0.94-3.74 1.08v-25.84l18.91-0.03c0.47 0 0.85 0.38 0.85 0.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m687.21 446.94l-14.03 8.1c-2.97 1.71-8.14 1.5-11.57-0.48l-12.37-7.14c-3.42-1.98-3.8-4.97-0.83-6.68l14.03-8.1c2.97-1.71 8.14-1.5 11.57 0.48l12.37 7.14c3.42 1.98 3.8 4.97 0.83 6.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m668.15 457.47c-2.49 0-5.09-0.61-7.17-1.81l-12.37-7.14c-2.2-1.27-3.47-3.05-3.47-4.87c0-1.6 0.94-3.02 2.64-4l14.03-8.1c3.37-1.95 9-1.73 12.84 0.48l12.37 7.14c2.2 1.27 3.47 3.05 3.47 4.87c0 1.6-0.94 3.02-2.64 4l-14.03 8.1c-1.54 0.89-3.57 1.33-5.67 1.33zm-0.69-24.71c-1.66 0-3.23 0.32-4.38 0.98l-14.03 8.1c-0.62 0.36-1.37 0.97-1.37 1.8c0 0.88 0.82 1.89 2.2 2.68l12.37 7.14c3.02 1.74 7.74 1.96 10.3 0.48l14.03-8.1c0.62-0.36 1.37-0.97 1.37-1.8c0-0.88-0.82-1.89-2.2-2.68l-12.37-7.14c-1.67-0.96-3.87-1.46-5.93-1.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m664.21 468.68h-2.54v-13.46h2.54v13.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m685.36 458.41h-1.95v-6.61h1.95v6.61z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m335.48 501.28l37.26-3.07c0 0 0.01 0 0.01 0l5.45 3.69c0 0 0.01 0 0.01 0c8.15 0.66 15.98 2.73 22.2 6.17c2.2 1.22 4.09 2.55 5.71 3.96c0 0 0.01 0 0.02 0l6.69-1.2c0.01 0 0.02 0.01 0.02 0.02l0.02 14.1l-0.02 0.01c-0.01 5.97-3.94 11.95-11.82 16.51c-15.81 9.16-41.46 9.2-57.3 0.09c-1.82-1.05-3.41-2.18-4.82-3.36c0 0-0.01-0.01-0.01-0.02l-0.02-14.08c0-0.01 0.01-0.02 0.02-0.02l17.71-3.17c0.02 0 0.02-0.03 0-0.04l-21.12-5.5c-0.01 0-0.01-0.01-0.01-0.02l-0.02-14.07c0-0.01 0.01-0.02 0.02-0.02z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m413.88 524.96l-0.02 0.62l-0.02 0.01c-0.27 6.38-4.62 12.32-12.31 16.77c-16.06 9.31-42.22 9.34-58.31 0.09c-1.78-1.02-3.45-2.19-5.06-3.55l-0.28-0.31l-0.02-15.34l14.12-2.53l-16.84-4.39l-0.68-0.26l-0.02-14.74l-0.02-0.92l38.19-3.22l0.39-0.04l5.54 3.76c8.52 0.72 16.24 2.89 22.35 6.27c1.99 1.1 3.82 2.35 5.52 3.77l6.18-1.11l0.48-0.11l0.79 0.6l0.02 14.6zm-77.41-22.75l0.02 12.39l20.39 5.31l0.78 0.23l-0.07 1.63l-17.7 3.15l0.01 12.79c1.33 1.09 2.78 2.08 4.32 2.97c15.53 8.93 40.78 8.9 56.29-0.09c7.29-4.22 11.31-9.78 11.32-15.64l0-12.92l-5.45 0.97l-0.53 0.13l-0.41-0.35c-1.63-1.42-3.49-2.71-5.54-3.84c-5.92-3.28-13.46-5.37-21.92-6.07l-5.53-3.65l-36 2.96z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m372.27 510.87l-36.78-9.59c-0.01 0-0.02-0.02-0.01-0.03c2.56-3.26 6.4-6.26 11.72-8.69c15.72-7.17 38.76-6.58 53.19 1.41c16.4 9.08 16.62 24.14 0.62 33.41c-15.81 9.16-41.46 9.2-57.3 0.09c-1.82-1.04-3.4-2.17-4.8-3.35c-0.01-0.01-0.01-0.03 0.01-0.03l33.36-13.18c0.02-0.01 0.02-0.03 0-0.04z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m413.86 510.7c0.06 6.67-4.32 12.91-12.35 17.56c-16.06 9.31-42.22 9.35-58.31 0.09c-1.77-1.02-3.43-2.18-4.96-3.46l-0.45-0.4l0.24-1.14l31.05-12.27l-33.93-8.85l-0.52-0.2l-0.26-1.02l0.31-0.4c2.82-3.58 6.89-6.61 12.09-8.98c16.1-7.34 39.35-6.72 54.1 1.45c4.57 2.53 8.02 5.56 10.21 8.9c1.79 2.73 2.74 5.67 2.77 8.71zm-41.33-0.81l0.73 0.19l0.08 1.5l-32.45 12.82c1.05 0.79 2.16 1.52 3.33 2.19c15.53 8.94 40.78 8.9 56.29-0.09c7.37-4.27 11.4-9.87 11.34-15.78c-0.06-6-4.3-11.63-11.94-15.86c-14.24-7.88-36.71-8.47-52.28-1.38c-4.31 1.96-7.78 4.38-10.35 7.21l35.26 9.19z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m338.99 524.06l33.3-13.16c0.01-0.01 0.03 0.01 0.02 0.02l-11.46 22.41l0 0c-6.27-1.06-12.19-3.01-17.14-5.86c-1.79-1.03-3.35-2.14-4.74-3.3c-0.04-0.03-0.03-0.1 0.02-0.12z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m361.41 534.46l-0.73-0.13c-6.55-1.11-12.6-3.18-17.48-5.98c-1.75-1.01-3.39-2.15-4.89-3.4l-0.45-0.43l0.22-1.17l33.78-13.35l0.7-0.32l0.96 1.1l-12.12 23.69zm-17.2-7.86c4.5 2.59 10.04 4.52 16.08 5.61l9.92-19.4l-29.33 11.59c1.05 0.79 2.16 1.52 3.33 2.19z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m372.28 510.98c0.01-0.02 0.05-0.01 0.05 0l0.04 23.3l0 0c-3.88 0.01-7.76-0.32-11.51-0.96l11.43-22.34z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m346.42 529v13.89c-2.23-0.68-5.71-3.23-7.94-4.96l0.41-13.81l7.54 4.88z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m373.38 535.29l-1.01 0c-3.92 0.01-7.85-0.32-11.68-0.97l-1.36-0.23l12.05-23.57l0.37-0.74l1.59 0.41l0.04 25.1zm-2.03-2.03l-0.03-18.19l-8.93 17.47c2.95 0.44 5.96 0.68 8.96 0.72z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m372.29 534.32l-0.03-23.26c0-0.02 0.04-0.02 0.05 0l8.18 22.76c-2.7 0.32-5.44 0.5-8.19 0.5l0 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m381.86 534.67l-1.26 0.15c-2.78 0.34-5.58 0.51-8.31 0.51l-1.01 0l-0.04-24.26l0.01-0.87l1.72-0.28l8.89 24.75zm-2.77-1.72l-5.82-16.19l0.02 16.54c1.91-0.03 3.85-0.15 5.79-0.35z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m361.89 547.44l-2.02 0l-0.02-14.12l2.02 0l0.02 14.12z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m405.67 538.89l-2.02 0l-0.02-14.12l2.02 0l0.02 14.12z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m401.12 542.21l-2.02 0l-0.02-14.12l2.02 0l0.02 14.12z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m345.25 518l-2.02 0l-0.02-14.12l2.02 0l0.02 14.12z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m351.63 551.39c-7.89-1.48-14.03-5.65-16.99-8.01c-1.74-1.38-2.83-3.46-3.01-5.7l-0.37-4.7l2.02-0.16l0.37 4.7c0.14 1.68 0.96 3.24 2.25 4.28c2.81 2.24 8.64 6.21 16.1 7.61l-0.37 1.99z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m363.85 553.45l-7.58-1.06l0.28-2l7.58 1.06l-0.28 2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m372.61 482.88c-7.99-0.71-15.27 1.72-15.35 1.74l-0.65-1.92c0.31-0.11 7.74-2.59 16.18-1.84l-0.18 2.01z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m354.59 485.61l-5.85 2.3l-0.74-1.88l5.85-2.3l0.74 1.88z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m298.88 480.95l-51.85-30.23l1.2-2.06l51.85 30.23c5.47 3.18 12.29 3.25 17.82 0.17l1.16 2.08c-3.07 1.71-6.49 2.57-9.92 2.57c-3.56 0-7.11-0.92-10.26-2.76z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m321.3 477.21c0.18-0.16 4.45-3.93 1.42-8.68l2.01-1.28c3.3 5.17 0.22 9.95-1.87 11.76l-1.56-1.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m228.84 422.79c-25.05 14.46-65.67 14.46-90.72 0c-12.52-7.23-18.79-16.71-18.79-26.18c0 0 0-0.01 0-0.01l0.02-10.9l2.56 0.5c2.92-5.78 8.32-11.23 16.21-15.79c12.13-7 29.47-19.61 45.36-19.83c16.93-0.24 32.44 12.37 45.36 19.83c7.89 4.55 13.28 10 16.21 15.77l2.57-0.49v10.34l-0.01 0c0.26 9.67-5.99 19.38-18.77 26.76zm-11.7-45.62c-18.59-10.73-48.73-10.73-67.32 0c-18.59 10.73-18.59 28.14 0 38.87c9.3 5.37 20.73-1.54 32.91-1.54c12.18 0 25.12 6.91 34.41 1.54c18.59-10.73 18.59-28.14 0-38.87z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m137.53 423.82c-12.5-7.22-19.38-16.88-19.39-27.23l0.02-12.35l3.11 0.61c3.19-5.83 8.79-11.16 16.26-15.48c2.1-1.21 4.36-2.6 6.74-4.05c11.47-7.02 25.74-15.75 39.2-15.94c0.16 0 0.32 0 0.49 0c13.65 0 26.22 7.95 37.32 14.98c2.85 1.8 5.55 3.51 8.16 5.02c7.46 4.31 13.06 9.64 16.25 15.47l3.12-0.6l0 12.02c0.15 10.47-6.71 20.24-19.37 27.55c-12.67 7.32-29.31 10.97-45.95 10.97c-16.64 0-33.29-3.66-45.96-10.97zm108.89-36.69l-2.03 0.39l-0.41-0.8c-2.89-5.72-8.34-11-15.74-15.28c-2.65-1.53-5.36-3.25-8.24-5.07c-10.83-6.85-23.09-14.61-36.06-14.61c-0.15 0-0.3 0-0.45 0c-12.8 0.18-26.77 8.72-37.99 15.59c-2.4 1.47-4.67 2.86-6.79 4.08c-7.41 4.28-12.85 9.56-15.74 15.29l-0.41 0.81l-2.02-0.4l-0.02 9.46c0 9.45 6.46 18.38 18.19 25.15c24.68 14.25 64.84 14.25 89.52 0c11.97-6.91 18.42-16.04 18.17-25.69l-0.02-0.96l0.03-0.01v-7.96zm-50.34 30.39c-4.41-0.9-8.97-1.84-13.35-1.84c-4.43 0-8.81 0.95-13.05 1.87c-7.33 1.59-14.24 3.1-20.46-0.49c-9.38-5.41-14.54-12.68-14.54-20.47c0-7.79 5.16-15.05 14.54-20.47c18.89-10.91 49.63-10.91 68.52 0c9.38 5.41 14.54 12.68 14.54 20.47c0 7.79-5.16 15.05-14.54 20.47c-2.82 1.63-5.89 2.21-9.14 2.21c-3.95 0-8.17-0.87-12.52-1.76zm0.48-2.34c7.47 1.53 14.52 2.97 19.99-0.18c8.61-4.97 13.35-11.51 13.35-18.4c0-6.9-4.74-13.43-13.35-18.4c-18.23-10.52-47.9-10.52-66.13 0c-8.61 4.97-13.35 11.51-13.35 18.4c0 6.9 4.74 13.43 13.35 18.4c5.41 3.12 11.6 1.78 18.76 0.22c4.36-0.95 8.86-1.93 13.55-1.93c4.62 0 9.3 0.96 13.83 1.89z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m228.84 411.25c-25.05 14.46-65.67 14.46-90.72 0c-25.05-14.46-25.05-37.91 0-52.38c25.05-14.46 65.67-14.46 90.72 0c25.05 14.46 25.05 37.91 0 52.38zm-11.7-45.62c-18.59-10.73-48.73-10.73-67.32 0c-18.59 10.73-18.59 28.14 0 38.87c18.59 10.73 48.73 10.73 67.32 0c18.59-10.73 18.59-28.14 0-38.87z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m137.53 412.28c-12.5-7.22-19.38-16.88-19.38-27.22c0-10.34 6.88-20.01 19.38-27.22c25.34-14.63 66.57-14.63 91.91 0c12.5 7.22 19.38 16.88 19.38 27.22c0 10.34-6.88 20-19.38 27.22c-12.67 7.32-29.31 10.97-45.95 10.97c-16.64 0-33.29-3.66-45.96-10.97zm1.19-52.38c-11.73 6.77-18.19 15.71-18.19 25.16c0 9.45 6.46 18.38 18.19 25.16c24.68 14.25 64.85 14.25 89.52 0c11.73-6.77 18.19-15.71 18.19-25.16c0-9.45-6.46-18.38-18.19-25.16c-12.34-7.12-28.55-10.69-44.76-10.69c-16.21 0-32.42 3.56-44.76 10.69zm10.5 45.62c-9.38-5.41-14.54-12.68-14.54-20.47c0-7.79 5.16-15.05 14.54-20.47c18.89-10.91 49.63-10.91 68.52 0c9.38 5.41 14.54 12.68 14.54 20.47c0 7.79-5.16 15.05-14.54 20.47c-9.45 5.45-21.85 8.18-34.26 8.18c-12.41 0-24.81-2.73-34.26-8.18zm67.33-38.87c-18.23-10.52-47.9-10.52-66.13 0c-8.61 4.97-13.35 11.51-13.35 18.4c0 6.9 4.74 13.43 13.35 18.4c18.23 10.53 47.9 10.52 66.13 0c8.61-4.97 13.35-11.51 13.35-18.4c0-6.9-4.74-13.43-13.35-18.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m208.7 418.98h1.83v11.36h-1.83v-11.36z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m129.98 406.72h1.84v11.36h-1.84v-11.36z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m145.59 415.25h1.83v11.36h-1.83v-11.36z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m208.7 362.12h1.83v11.36h-1.83v-11.36z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m158.63 361.16h1.83v11.36h-1.83v-11.36z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m194.08 394.65c-11.39 6.58-29.87 6.58-41.26 0c-11.39-6.58-11.39-17.24 0-23.82c11.39-6.58 29.87-6.58 41.26 0c11.39 6.58 11.39 17.24 0 23.82z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m308.19 473.22c-0.2 0.35-0.65 0.47-1.01 0.27l-84.14-48.13c-0.18-0.19-0.3-0.47-0.3-0.87v-8.02c0-0.92 0.56-1.99 1.25-2.39l7.33-4.23c0.2-0.11 0.46-0.14 0.78-0.07l84.14 48.14c0.36 0.2 0.48 0.66 0.27 1.02l-8.33 14.29z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m306.6 474.52l-84.14-48.13l-0.27-0.21c-0.29-0.3-0.63-0.84-0.63-1.69v-8.02c0-1.34 0.8-2.82 1.85-3.43l7.34-4.24c0.64-0.37 1.41-0.24 1.62-0.2l0.18 0.04l84.3 48.23c0.45 0.26 0.77 0.68 0.91 1.18c0.13 0.5 0.06 1.03-0.2 1.47l-8.34 14.29c-0.36 0.61-1.01 0.96-1.67 0.96c-0.33 0-0.65-0.08-0.95-0.25zm-74.81-63.56l-7.19 4.15c-0.26 0.15-0.66 0.79-0.66 1.36l-0.03 8.01l83.48 47.75l7.88-13.51l-83.48-47.76z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m316.13 469.71l-7.33 4.23c-0.69 0.4-1.25-0.02-1.25-0.95v-8.02c0-0.92 0.56-1.99 1.25-2.39l7.33-4.23c0.69-0.4 1.25 0.02 1.25 0.95v8.02c0 0.92-0.56 1.99-1.25 2.39z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m307.38 475.04c-0.65-0.38-1.03-1.12-1.03-2.05v-8.02c0-1.35 0.8-2.82 1.85-3.43l7.33-4.24c0.67-0.39 1.41-0.42 2.01-0.07c0.65 0.38 1.03 1.12 1.03 2.05v8.02c0 1.34-0.8 2.82-1.85 3.43l-7.34 4.24c-0.36 0.21-0.73 0.31-1.09 0.31c-0.32 0-0.63-0.08-0.92-0.25zm8.15-6.36c0.27-0.15 0.66-0.79 0.66-1.36l-0.02-7.62l-6.78 3.92c-0.26 0.15-0.66 0.79-0.66 1.36l0.02 7.62l6.78-3.91z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m307.54 467.67v5.33l-84.79-48.51v-5.44l84.79 48.62z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m229.73 418.63l0.91-1.59l43.74 25.02l-0.91 1.59l-43.74-25.02z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m281.78 448.65l0.91-1.59l14.49 8.29l-0.91 1.59l-14.49-8.29z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m173.31 405.78l0.29-1.81c29.97 4.73 44.22-11.14 44.36-11.3l1.38 1.2c-0.13 0.15-11.44 12.81-34.9 12.81c-3.45 0-7.16-0.27-11.13-0.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m202.28 397.6c11.24-4.58 13.9-12.73 13.93-12.81l1.75 0.54c-0.11 0.37-2.9 9.05-14.99 13.97l-0.69-1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m140.98 390.9c2.16-4.01 5.49-7.42 9.9-10.13l0.96 1.57c-4.14 2.53-7.25 5.71-9.25 9.43l-1.62-0.87z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m221.83 422.1h1.83v3.42h-1.83v-3.42z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m175.67 385.68c-1.75 1.42-0.3 3.43-0.02 3.77c0.01 0.02-0.02 0.04-0.05 0.03c-0.6-0.16-4.07-1-6.53 0.01c-0.03 0.01-0.07-0.01-0.05-0.03c1.74-1.42 0.27-3.44-0.01-3.78c-0.01-0.02 0.02-0.04 0.05-0.03c0.61 0.16 4.1 1.01 6.56 0c0.03-0.01 0.07 0.01 0.05 0.03z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m166.22 380.22c-1.75 1.42-0.3 3.43-0.02 3.77c0.01 0.02-0.02 0.04-0.05 0.03c-0.6-0.16-4.07-1-6.53 0.01c-0.03 0.01-0.07-0.01-0.05-0.03c1.74-1.42 0.27-3.44-0.01-3.79c-0.01-0.02 0.02-0.04 0.05-0.03c0.61 0.16 4.1 1.01 6.56 0c0.03-0.01 0.07 0.01 0.05 0.03z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m185.17 380.19c-1.75 1.42-0.3 3.43-0.03 3.77c0.01 0.02-0.02 0.04-0.05 0.03c-0.6-0.16-4.07-1-6.53 0.01c-0.03 0.01-0.07-0.01-0.05-0.03c1.74-1.42 0.27-3.44-0.01-3.79c-0.01-0.02 0.02-0.04 0.05-0.03c0.61 0.16 4.1 1.01 6.56 0c0.03-0.01 0.07 0.01 0.05 0.03z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m175.71 374.73c-1.75 1.42-0.3 3.43-0.03 3.77c0.01 0.02-0.02 0.04-0.05 0.03c-0.6-0.16-4.07-1-6.53 0.01c-0.03 0.01-0.07-0.01-0.05-0.03c1.74-1.42 0.27-3.44-0.01-3.79c-0.01-0.02 0.02-0.04 0.05-0.03c0.61 0.16 4.1 1.01 6.56 0c0.03-0.01 0.07 0.01 0.05 0.03z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m662.33 304.1l-4.69-5.46c-0.03-0.03-0.04-0.07-0.04-0.12l0.44-5.8c0-0.01 0-0.01 0-0.02l1.82-8.45c0.03-0.13 0.19-0.17 0.28-0.07l11.44 13.88c0.06 0.07 0.04 0.18-0.04 0.24l-9.01 5.82c-0.07 0.04-0.16 0.03-0.21-0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m662.44 305.13c-0.31 0-0.62-0.13-0.84-0.38l-4.98-5.79v-0.53l0.43-5.78l1.97-9.2l0.71-0.27c0.41-0.1 0.86 0.04 1.14 0.38l11.72 14.22l-0.03 0.56c-0.05 0.32-0.23 0.61-0.51 0.78l-9 5.82c-0.19 0.12-0.41 0.18-0.62 0.18zm-3.85-6.87l4 4.66l7.64-4.94l-9.78-11.88l-1.47 6.8l-0.39 5.35z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m701.05 269.81v32.41c0 1.3-0.44 2.22-1.14 2.69l-8.32 5.01c-0.12 0.07-0.28 0.01-0.33-0.12l-5.54-14.77c-0.02-0.05-0.05-0.09-0.1-0.12l-13.26-7.66c-0.33 0.14-0.38 0.16-0.71 0.3c-0.6 3.36 1.35 7.64 2.39 9.6c0.2 0.39 0 0.69-0.31 0.48c-7.88-5.38-9.65-13.13-9.97-14.98c-0.16-0.22-0.29-0.41-0.45-0.63l-6.41-3.7c-2.42-1.4-4.4-4.83-4.4-7.63v-17.55c0-0.06-0.02-0.12-0.06-0.16l-10.05-10.62c-0.1-0.11-0.08-0.29 0.05-0.36l8.41-5.04c0.75-0.32 1.73-0.23 2.81 0.4l42.99 24.82c2.42 1.4 4.4 4.83 4.4 7.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m691.47 310.92c-0.14 0-0.28-0.02-0.41-0.07l-0.42-0.15l-0.29-0.56l-5.44-14.52l-12.38-7.14c-0.17 3.02 1.57 6.7 2.37 8.23c0.32 0.61 0.24 1.29-0.21 1.69c-0.41 0.37-1.02 0.39-1.51 0.06c-7.83-5.35-9.86-12.88-10.34-15.4l-0.2-0.28l-6.22-3.59c-2.74-1.58-4.89-5.3-4.89-8.47v-17.25l-9.84-10.41c-0.26-0.27-0.37-0.64-0.32-1c0.05-0.37 0.27-0.69 0.59-0.87l8.39-5.03c1.2-0.52 2.5-0.36 3.8 0.39l42.99 24.82c2.74 1.58 4.89 5.3 4.89 8.47v32.41c0 1.58-0.56 2.82-1.57 3.5l-8.36 5.03c-0.2 0.11-0.41 0.17-0.62 0.17zm-19.05-24.76l14 8.08l0.22 0.47l5.21 13.91l7.55-4.54c0.42-0.28 0.67-0.95 0.67-1.85v-32.41c0-2.45-1.79-5.56-3.91-6.78l-42.99-24.82c-0.75-0.44-1.44-0.55-1.94-0.34l-7.5 4.5l9.68 10.23l0.06 0.55v17.55c0 2.45 1.79 5.56 3.91 6.78l6.72 3.98l0.62 1.03c0.23 1.32 1.57 7.52 7.25 12.55c-0.93-2.29-1.73-5.16-1.29-7.66l0.09-0.52l1.64-0.71z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m692.49 274.82v32.54c0 2.73-1.92 3.84-4.29 2.48l-27.81-16.06c-0.16-0.09-0.32-0.05-0.35 0.12c-0.81 3.41 1.24 7.92 2.32 9.95c0.2 0.39 0 0.69-0.31 0.48c-7.97-5.44-9.69-13.31-9.98-15.04c-0.03-0.2-0.17-0.42-0.33-0.51l-6.63-3.83c-2.37-1.37-4.29-4.69-4.29-7.43v-32.54c0-2.73 1.92-3.84 4.29-2.48l43.1 24.88c2.37 1.37 4.29 4.69 4.29 7.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m690.12 311.4c-0.76 0-1.57-0.24-2.4-0.72l-26.88-15.52c-0.17 3 1.56 6.67 2.38 8.23c0.32 0.61 0.24 1.29-0.21 1.68c-0.41 0.37-1.02 0.39-1.51 0.06c-8.19-5.6-10.05-13.74-10.37-15.59l-6.51-3.76c-2.68-1.55-4.77-5.18-4.77-8.27v-32.54c0-1.69 0.62-2.97 1.74-3.62c1.12-0.65 2.55-0.54 4 0.3l43.1 24.88c2.68 1.55 4.78 5.18 4.78 8.27v32.54c0 1.69-0.62 2.97-1.74 3.62c-0.49 0.28-1.03 0.42-1.6 0.42zm-29.89-18.64c0.22 0 0.44 0.06 0.65 0.18l27.81 16.06c0.82 0.47 1.57 0.58 2.06 0.3c0.49-0.28 0.77-0.98 0.77-1.93v-32.54c0-2.38-1.74-5.39-3.8-6.58l-43.1-24.88c-0.82-0.47-1.57-0.58-2.05-0.3c-0.49 0.28-0.77 0.99-0.77 1.93v32.54c0 2.38 1.74 5.39 3.8 6.58l6.63 3.83c0.41 0.24 0.72 0.7 0.81 1.19c0.22 1.32 1.53 7.55 7.26 12.61c-0.98-2.42-1.81-5.48-1.2-8.07l0.11-0.48l0.57-0.34c0.15-0.06 0.3-0.09 0.46-0.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m690.66 268.71l-1.01-1.67l7.51-4.56l1.01 1.67l-7.51 4.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m650.46 245.65l-1.01-1.67l7.51-4.56l1.01 1.67l-7.51 4.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m693.02 277.53l-1.04-1.65l8.28-5.24l1.04 1.65l-8.28 5.24z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m701.05 302.81l-0.28 2.02l-8.28 4.54v-28.22l8.55-5.18v26.84z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m655.16 228.93l-1.94-0.16l0.78-9.39l1.94 0.16l-0.78 9.39z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m647.04 230.05l-4.36-9.94l1.79-0.78l4.36 9.94l-1.79 0.78z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m641.96 233.81l-7.87-4.45l0.96-1.7l7.87 4.45l-0.96 1.7z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m669.71 291.97c-0.54 0-1.15-0.2-1.87-0.62c-1.02-0.59-1.83-1.36-2.41-2.28c-0.59-0.93-0.88-1.98-0.88-3.09c0-1.22 0.35-2.01 1.04-2.36c0.68-0.34 1.58-0.18 2.74 0.49c1.03 0.6 1.84 1.37 2.39 2.3c0.56 0.93 0.84 1.96 0.84 3.06c0 1.22-0.37 2-1.09 2.33c-0.24 0.11-0.49 0.16-0.77 0.16zm-3.35-7.55c-0.13 0-0.24 0.02-0.33 0.07c-0.42 0.21-0.5 0.93-0.5 1.49c0 0.93 0.25 1.79 0.74 2.57c0.49 0.79 1.19 1.45 2.07 1.96c0.76 0.44 1.37 0.59 1.74 0.41c0.34-0.16 0.52-0.65 0.52-1.45c0-0.92-0.24-1.78-0.7-2.56c-0.47-0.78-1.16-1.44-2.05-1.95c-0.61-0.35-1.12-0.53-1.49-0.53zm4.23-0.52l-5.42-3.13v-1.72c0-1.21 0.22-2.1 0.67-2.72c0.46-0.64 1.26-1.04 2.38-1.21c0.86-0.13 1.27-0.33 1.46-0.47c0.08-0.06 0.32-0.24 0.32-0.88c0-0.36-0.15-0.74-0.45-1.13c-0.33-0.43-0.76-0.8-1.29-1.11c-1.37-0.79-3-1.15-4.85-1.1l-0.36 0.01l-2.34-6.64l0.63-0.05c2.49-0.2 5.12 0.48 7.81 2.04c2.21 1.27 3.96 2.86 5.22 4.71c1.27 1.87 1.92 3.82 1.92 5.79c0 1.46-0.31 2.58-0.93 3.34c-0.62 0.76-1.6 1.26-2.91 1.46c-1.29 0.22-1.61 0.41-1.68 0.46c-0.13 0.1-0.2 0.32-0.2 0.64v1.7zm-4.44-3.69l3.47 2v-0.01c0-0.63 0.19-1.1 0.57-1.4c0.23-0.18 0.67-0.42 2.13-0.66c1.07-0.17 1.85-0.55 2.31-1.12c0.47-0.58 0.71-1.49 0.71-2.72c0-1.77-0.59-3.54-1.75-5.25c-1.18-1.73-2.83-3.21-4.9-4.41c-2.28-1.32-4.49-1.99-6.6-1.94l1.68 4.75c1.92-0.06 3.57 0.4 5.01 1.23c0.64 0.37 1.17 0.83 1.58 1.36c0.43 0.57 0.65 1.15 0.65 1.72c0 0.75-0.24 1.31-0.71 1.66c-0.41 0.31-1.04 0.53-1.91 0.66c-0.85 0.12-1.43 0.4-1.73 0.82c-0.32 0.44-0.49 1.16-0.49 2.14v1.15z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m663.17 278.21v-1.44c0-1.09 0.19-1.9 0.58-2.43c0.39-0.53 1.07-0.87 2.05-1.01c0.78-0.12 1.34-0.3 1.69-0.56c0.34-0.26 0.51-0.68 0.51-1.27c0-0.47-0.18-0.94-0.55-1.43c-0.37-0.48-0.84-0.9-1.43-1.24c-1.46-0.84-3.16-1.23-5.11-1.16l-2.01-5.7c2.4-0.19 4.91 0.46 7.52 1.97c2.15 1.24 3.84 2.76 5.06 4.56c1.22 1.8 1.84 3.64 1.84 5.52c0 1.35-0.27 2.36-0.82 3.03c-0.55 0.67-1.42 1.1-2.61 1.29c-1.01 0.17-1.65 0.36-1.9 0.56c-0.26 0.2-0.38 0.54-0.38 1.02v0.85l-4.44-2.56zm-0.62 5.49c0-1.02 0.26-1.67 0.77-1.93c0.52-0.26 1.28-0.1 2.28 0.48c0.96 0.56 1.7 1.27 2.22 2.13c0.52 0.86 0.77 1.8 0.77 2.81c0 1.01-0.27 1.64-0.8 1.89c-0.54 0.25-1.27 0.1-2.19-0.43c-0.95-0.55-1.7-1.26-2.24-2.12c-0.54-0.86-0.81-1.81-0.81-2.83z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m232.2 251.91h-2.39v-153.07h2.39v153.07z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m232.2 282.13h-2.39v-21.71h2.39v21.71z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m601.32 261.22c0.07-0.84 1.49-20.64-17.79-29.25l0.97-2.18c20.86 9.31 19.21 31.41 19.2 31.53v70.32h-2.39l0.01-70.42z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m601.36 340.28h2.39v23.7h-2.39v-23.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m305.01 398.47l13.02 0.27c0.23 0 0.46-0.05 0.65-0.17l49.84-28.78c3.06-1.77 7.68-1.96 10.33-0.43l113.06 65.28c0.07 0.04 0.15 0.08 0.23 0.1l37.53 12.61c0.51 0.17 0.86 0.65 0.86 1.19l-0.01 9.43c0.32 1.33-0.51 2.81-2.45 3.93l-62.3 35.97c-3.06 1.77-7.68 1.96-10.33 0.43l-149.96-86.58c-1.21-0.7-1.77-1.64-1.76-2.62l0-9.38c0-0.7 0.58-1.27 1.28-1.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m454.84 499.34l-149.96-86.58c-1.53-0.89-2.37-2.19-2.35-3.65v-9.39c0-0.66 0.26-1.28 0.73-1.75c0.47-0.46 1.03-0.78 1.76-0.7l13.05 0.26l49.84-28.78c3.44-1.99 8.5-2.17 11.52-0.43l113.07 65.28l37.53 12.61c1 0.34 1.67 1.27 1.67 2.32l-0.01 9.3c0.37 1.87-0.76 3.77-3.05 5.09l-62.3 35.97c-1.86 1.08-4.2 1.63-6.43 1.63c-1.89 0-3.71-0.39-5.09-1.2zm-85.72-128.51l-49.84 28.78c-0.38 0.22-0.76 0.4-1.28 0.33l-13.01-0.27l-0.08 9.46c-0.01 0.74 0.63 1.26 1.16 1.57l149.96 86.58c2.27 1.32 6.46 1.12 9.14-0.43l62.3-35.97c1.37-0.79 2.09-1.79 1.89-2.62l-0.07-9.77l-37.54-12.61c-0.15-0.05-0.3-0.12-0.44-0.2l-113.06-65.27c-1.01-0.58-2.41-0.87-3.88-0.87c-1.83 0-3.78 0.44-5.26 1.3zm-64.12 28.84l0.01-1.19l-0.02 1.19l0.02 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m306.22 395.43l62.3-35.97c3.06-1.76 7.68-1.96 10.33-0.43l149.96 86.58c2.65 1.53 2.32 4.2-0.74 5.96l-62.3 35.97c-3.06 1.76-7.68 1.96-10.33 0.43l-149.96-86.58c-2.65-1.53-2.32-4.2 0.74-5.96z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m454.84 489l-149.96-86.58c-1.54-0.89-2.38-2.17-2.38-3.62c0-1.65 1.14-3.26 3.13-4.41l62.3-35.97c3.44-1.98 8.5-2.17 11.52-0.43l149.96 86.58c1.54 0.89 2.38 2.17 2.38 3.62c0 1.65-1.14 3.26-3.13 4.41l-62.3 35.97c-1.86 1.07-4.2 1.62-6.43 1.62c-1.89 0-3.71-0.39-5.09-1.2zm-85.72-128.51l-62.3 35.97c-1.21 0.7-1.93 1.57-1.93 2.34c0 0.72 0.65 1.24 1.19 1.56l149.96 86.58c2.28 1.31 6.46 1.12 9.14-0.43l62.3-35.97c1.21-0.7 1.93-1.57 1.93-2.34c0-0.72-0.65-1.24-1.19-1.56l-149.96-86.58c-1.01-0.58-2.41-0.87-3.88-0.87c-1.83 0-3.78 0.44-5.26 1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m459.04 489.72h1.83v8.89h-1.83v-8.89z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m522.85 454.3h1.83v8.89h-1.83v-8.89z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m309.51 404.54h1.83v8.89h-1.83v-8.89z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m241.91 58.5c-0.12-0.16-0.07-0.39 0.11-0.49l11.12-6.17c0.6-0.46 1.42-0.49 2.34 0.04l336.13 194.07c1.81 1.05 3.29 3.86 3.29 6.28v257.21c0 1.21-0.37 2.09-0.96 2.54l-11.72 6.5l-11.68-14.06l4.59-2.01l-319.65-184.55c-1.81-1.05-3.29-3.86-3.29-6.28v-239.13l-10.28-13.94z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m568.61 503.96l3.88-1.7l-317.61-183.37c-2.18-1.26-3.88-4.47-3.88-7.31v-238.74l-10.04-13.62c-0.26-0.35-0.36-0.8-0.27-1.23c0.09-0.43 0.37-0.8 0.75-1.01l10.97-6.07c1.02-0.79 2.35-0.81 3.67-0.05l336.13 194.07c2.18 1.26 3.88 4.47 3.88 7.31v257.21c0 1.55-0.51 2.79-1.58 3.59l-12.59 6.98l-13.32-16.04zm-314.89-451.07l-10.26 5.7l9.93 13.47v239.52c0 2 1.23 4.4 2.69 5.25l321.69 185.73l-5.3 2.32l10.03 12.09l10.72-5.93c0.24-0.18 0.49-0.69 0.49-1.59v-257.21c0-2-1.23-4.4-2.69-5.25l-336.13-194.07c-0.18-0.11-0.41-0.21-0.65-0.21c-0.16 0-0.34 0.05-0.51 0.18z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m240.44 318.1v-257.21c0-2.42 1.47-3.53 3.29-2.48l336.13 194.07c1.81 1.05 3.29 3.86 3.29 6.28v257.21c0 2.42-1.47 3.53-3.29 2.48l-336.13-194.07c-1.81-1.05-3.29-3.86-3.29-6.28z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m579.27 519.47l-336.13-194.07c-2.18-1.26-3.88-4.47-3.88-7.31v-257.21c0-1.71 0.63-3.06 1.73-3.69c0.98-0.57 2.17-0.51 3.34 0.17l336.13 194.07c2.18 1.26 3.88 4.47 3.88 7.31v257.21c0 1.71-0.63 3.05-1.73 3.69c-0.44 0.26-0.93 0.38-1.44 0.38c-0.61 0-1.26-0.19-1.9-0.56zm-337.09-460.21c-0.25 0.14-0.54 0.66-0.54 1.63v257.21c0 2 1.23 4.4 2.69 5.25l336.13 194.07c0.19 0.11 0.67 0.35 0.96 0.17c0.25-0.14 0.54-0.65 0.54-1.62v-257.21c0-2-1.23-4.4-2.69-5.25l-336.13-194.07c-0.14-0.08-0.44-0.23-0.71-0.23c-0.09 0-0.18 0.02-0.25 0.06z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m243.25 317.73v-254.85c0-0.71 0.43-1.04 0.96-0.73l335.16 193.5c0.53 0.31 0.96 1.13 0.96 1.84v254.85c0 0.71-0.43 1.04-0.96 0.73l-335.16-193.5c-0.53-0.31-0.96-1.13-0.96-1.84z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m578.78 514.11l-335.16-193.5l0 0c-0.9-0.52-1.56-1.73-1.56-2.88v-254.85c0-0.81 0.34-1.47 0.93-1.81c0.56-0.32 1.22-0.3 1.82 0.05l335.15 193.5c0.91 0.52 1.56 1.73 1.56 2.88v254.85c0 0.81-0.34 1.47-0.93 1.81c-0.26 0.15-0.55 0.23-0.85 0.23c-0.33 0-0.66-0.09-0.98-0.28zm-334.33-196.38c0 0.34 0.24 0.73 0.37 0.81l334.33 193.03v-254.07c0-0.34-0.24-0.73-0.37-0.81l-334.33-193.03v254.07z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m240.44 318.4v-14.71l342.71 197.86v14.71c0 2.25-1.58 3.16-3.53 2.04l-335.64-193.78c-1.95-1.13-3.53-3.86-3.53-6.12z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m579.02 519.33l-335.64-193.78c-2.31-1.34-4.13-4.48-4.13-7.15v-16.78l344.5 198.89l0.6 0.34v15.4c0 1.51-0.6 2.72-1.63 3.32c-0.46 0.26-0.97 0.39-1.51 0.39c-0.7 0-1.44-0.21-2.18-0.64zm-337.38-213.58v12.65c0 1.84 1.34 4.16 2.93 5.08l335.64 193.78c0.54 0.31 1.03 0.4 1.3 0.25c0.27-0.16 0.44-0.63 0.44-1.25v-14.03l-340.32-196.48z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m389.64 400.28l0.92-1.59l43.4 25.06l-0.92 1.59l-43.4-25.06z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m582.77 254.35l11.52-6.91l1.23 2.04l-11.52 6.91l-1.23-2.04z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m262.15 68.39l11.51-6.91l1.23 2.04l-11.51 6.91l-1.23-2.04z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m582.77 498.05l11.52-6.91l1.23 2.05l-11.52 6.91l-1.23-2.05z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m495.32 471.95l0.92-1.59l7.28 4.24l-0.92 1.59l-7.28-4.24z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m457.19 482.61l-129.13-73.65l1.18-2.07l129.13 73.65c1.41 0.81 3.14 0.78 4.51-0.07l13.05-8.04l1.25 2.03l-13.05 8.04c-1.09 0.67-2.33 1.01-3.57 1.01c-1.16 0-2.33-0.3-3.38-0.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m314.79 401.49c-1.02-0.57-1.63-1.6-1.64-2.76c-0.01-1.16 0.58-2.21 1.59-2.8l13.33-7.81l1.2 2.06l-13.33 7.81c-0.37 0.22-0.4 0.57-0.4 0.71c0 0.14 0.05 0.5 0.42 0.7l9.57 5.34l-1.16 2.08l-9.57-5.33z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m583.4 489.2l11.51-6.91l1.23 2.05l-11.51 6.91l-1.23-2.05z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m269.57 72.58l11.51-6.91l1.23 2.04l-11.51 6.91l-1.23-2.04z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m583.37 266.6l11.51-6.91l1.23 2.04l-11.51 6.91l-1.23-2.04z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m343.67 205.73l-0.86-0.8l0.14-0.59l13.38-43.7l1.14 1.05c9.26 8.55 17.55 20.05 23.34 32.37l0.49 1.04l-37.63 10.64zm13.61-41.55l-11.95 39.02l33.22-9.37c-5.42-11.2-12.9-21.64-21.27-29.66z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m354.62 251.18c0.01 0.01 0.01 0.02 0 0.03c-8.93 6.76-22.48 6.13-37.44-3.8c-22.12-14.68-39.96-45.81-41.39-72.19c-1.69-31.19 19.03-44.34 44.83-29.45c0.01 0.01 0.02 0.02 0.02 0.03v51.87l33.98 53.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m340.72 256.99c-7.39 0-15.7-2.86-24.24-8.53c-22.47-14.91-40.5-46.37-41.96-73.18c-0.84-15.59 3.96-27.78 13.17-33.44c8.95-5.5 20.87-4.5 33.56 2.82l0.63 0.37l0.02 0.76v51.5l34.45 54.26l-1.03 0.72c-4.17 3.16-9.13 4.73-14.6 4.73zm-40.16-116.11c-4.25 0-8.14 1.04-11.54 3.12c-8.4 5.16-12.76 16.51-11.97 31.15c1.41 26.09 18.97 56.7 40.83 71.21c13.42 8.91 26.11 10.53 35.03 4.52l-33.55-52.84v-51.52c-6.69-3.74-13.07-5.63-18.81-5.63z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m328 193.39c-0.01 0.02-0.03 0-0.03-0.02v-51.76c4.5 2.6 8.84 5.87 12.93 9.66l-12.9 42.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m332.8 201.33l12.92-42.19c9.35 8.64 17.42 19.95 23.12 32.07l-36.01 10.16c-0.01 0-0.03-0.02-0.02-0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m332.41 202.8l-1.08-1.18l0.29-0.76l13.47-44.02l1.48 1.37c9.28 8.58 17.6 20.11 23.4 32.46l0.64 1.35l-38.21 10.78zm13.92-41.33l-11.65 38.06l32.37-9.13c-5.31-10.89-12.59-21.06-20.71-28.93z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m348.9 337.35l-14.24-8.22v-49.31l14.24 8.22v49.31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m350.16 339.55l-16.77-9.68v-52.24l16.77 9.68v52.24zm-14.24-11.15l11.7 6.75v-46.38l-11.7-6.75v46.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m369.51 349.26l-14.24-8.22v-66.1l14.24 8.22v66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m370.78 351.45l-16.77-9.68v-69.02l16.77 9.68v69.03zm-14.24-11.15l11.7 6.75v-63.17l-11.7-6.76v63.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m554.95 456.32l-14.24-8.22v-33.05l14.24 8.22v33.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m556.22 458.51l-16.77-9.68v-35.98l16.77 9.68v35.98zm-14.24-11.15l11.7 6.75v-30.12l-11.7-6.75v30.12z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m390.13 361.16l-14.24-8.22v-86.94l14.24 8.22v86.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m391.4 363.36l-16.77-9.68v-89.87l16.77 9.68v89.87zm-14.24-11.15l11.7 6.75v-84.02l-11.7-6.76v84.02z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m410.74 373.06l-14.24-8.22v-66.1l14.24 8.22v66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m412.01 375.26l-16.77-9.68v-69.03l16.77 9.68v69.03zm-14.24-11.15l11.7 6.75v-63.17l-11.7-6.75v63.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m513.55 432.42l-14.24-8.22v-86.94l14.24 8.22v86.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m514.82 434.62l-16.77-9.68v-89.87l16.77 9.68v89.87zm-14.24-11.15l11.7 6.75v-84.02l-11.7-6.75v84.02z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m534.17 444.32l-14.24-8.22v-66.1l14.24 8.22v66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m535.44 446.52l-16.77-9.68v-69.02l16.77 9.68v69.03zm-14.24-11.15l11.7 6.76v-63.17l-11.7-6.75v63.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m328.12 325.36l-14.24-8.22v-25.44l14.24 8.22v25.44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m329.39 327.55l-16.77-9.68v-28.36l16.77 9.68v28.36zm-14.24-11.15l11.7 6.75v-22.51l-11.7-6.76v22.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m431.36 384.97l-14.24-8.22v-103.16l14.24 8.22v103.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m432.63 387.16l-16.77-9.68v-106.09l16.77 9.68v106.09zm-14.24-11.15l11.7 6.75v-100.23l-11.7-6.76v100.23z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m451.68 396.51l-14.24-8.22v-93.91l14.24 8.22v93.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m452.94 398.71l-16.77-9.68v-96.84l16.77 9.68v96.84zm-14.24-11.15l11.7 6.75v-90.98l-11.7-6.76v90.98z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m472.29 408.42l-14.24-8.22v-74.29l14.24 8.22v74.29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m473.56 410.61l-16.77-9.68v-77.21l16.77 9.68v77.21zm-14.23-11.15l11.7 6.76v-71.36l-11.7-6.75v71.36z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m492.91 420.32l-14.24-8.22v-60.72l14.24 8.22v60.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m494.18 422.52l-16.77-9.68v-63.64l16.77 9.68v63.64zm-14.23-11.15l11.7 6.75v-57.79l-11.7-6.75v57.79z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m532.09 310.81c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m523.48 305.84c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m514.87 300.87c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m506.25 295.89c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m497.64 290.92c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m489.03 285.95c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m480.42 280.98c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m471.81 276.01c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m463.2 271.03c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m454.59 266.06c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m557.92 325.72c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m549.31 320.75c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m540.7 315.78c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m532.09 300.82c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m523.48 295.85c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m514.87 290.88c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m506.25 285.91c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m497.64 280.94c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m489.03 275.97c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m480.42 270.99c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m471.81 266.02c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m463.2 261.05c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m454.59 256.08c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m557.92 315.74c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m549.31 310.77c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m540.7 305.8c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m532.09 290.84c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m523.48 285.87c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m514.87 280.9c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m506.25 275.92c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m497.64 270.95c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m489.03 265.98c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m480.42 261.01c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m471.81 256.04c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m463.2 251.06c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m454.59 246.09c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m557.92 305.75c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m549.31 300.78c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m540.7 295.81c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m532.09 280.85c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m523.48 275.88c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m514.87 270.91c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m506.25 265.94c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m497.64 260.97c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m489.03 256c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m480.42 251.02c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m471.81 246.05c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m463.2 241.08c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m454.59 236.11c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m557.92 295.77c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m549.31 290.8c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m540.7 285.83c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m532.09 270.87c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m523.48 265.9c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m514.87 260.93c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m506.25 255.95c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m497.64 250.98c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m489.03 246.01c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m480.42 241.04c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m471.81 236.07c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m463.2 231.1c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m454.59 226.12c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m557.92 285.78c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m549.31 280.81c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m540.7 275.84c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m532.09 260.88c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m523.48 255.91c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m514.87 250.94c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m506.25 245.97c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m497.64 241c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m489.03 236.03c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m480.42 231.05c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m471.81 226.08c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m463.2 221.11c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m454.59 216.14c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m557.92 275.8c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m549.31 270.83c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m540.7 265.86c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m532.09 250.9c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m523.48 245.93c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m514.87 240.96c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m506.25 235.98c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m497.64 231.01c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m489.03 226.04c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m480.42 221.07c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m471.81 216.1c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m463.2 211.13c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m454.59 206.15c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m445.97 261.09c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m437.36 256.12c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m428.75 251.15c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m420.14 246.18c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m445.97 251.11c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m437.36 246.13c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m428.75 241.16c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m420.14 236.19c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m445.97 241.12c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m437.36 236.15c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m428.75 231.18c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m420.14 226.21c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m445.97 231.14c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m437.36 226.16c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m428.75 221.19c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m420.14 216.22c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m445.97 221.15c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m437.36 216.18c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m428.75 211.21c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m420.14 206.24c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m445.97 211.17c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m437.36 206.2c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m428.75 201.22c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m420.14 196.25c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m445.97 201.18c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m437.36 196.21c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m428.75 191.24c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m420.14 186.27c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m557.92 265.81c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m549.31 260.84c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m540.7 255.87c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m295.36 301.8c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m295.36 291.82c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m295.36 281.83c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m295.36 271.85c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m295.36 261.86c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m286.75 296.83c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m278.13 291.86c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m269.52 286.89c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m260.91 281.92c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m286.75 286.85c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m278.13 281.87c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m269.52 276.9c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m260.91 271.93c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m286.75 276.86c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m278.13 271.89c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m269.52 266.92c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m260.91 261.95c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m286.75 266.88c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m278.13 261.9c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m269.52 256.93c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m260.91 251.96c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m286.75 256.89c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m278.13 251.92c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m269.52 246.95c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m260.91 241.98c0.33 2.4 2.57 4.76 2.96 5.16c0.02 0.02 0.02 0.05 0 0.05c-0.4-0.06-2.64-0.29-2.96 1.73c0 0.03-0.04 0.01-0.04-0.03c-0.33-2.4-2.59-4.76-2.99-5.17c-0.02-0.02-0.02-0.05 0-0.05c0.4 0.06 2.66 0.3 2.99-1.72c0-0.03 0.04-0.01 0.04 0.03z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m205.24 239.22v61.49h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-2.97 1.71-8.15 1.5-11.57-0.48l-12.37-7.14c-1.78-1.03-2.71-2.33-2.81-3.58h-0.01l-0.02-61.43c0-0.47 0.38-0.85 0.84-0.85l41.09-0.06c0.47 0 0.85 0.38 0.85 0.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m184.18 314.34c-2.49 0-5.09-0.61-7.16-1.81l-12.37-7.14c-1.61-0.93-2.71-2.11-3.18-3.41h-0.26l-0.01-1.27l-0.02-61.43c0-1.17 0.95-2.11 2.11-2.11l41.09-0.06c0.63 0.03 1.1 0.22 1.5 0.62c0.4 0.4 0.62 0.93 0.62 1.5v62.76h-0.15c-0.32 1.16-1.18 2.19-2.47 2.93l-14.03 8.1c-1.54 0.89-3.57 1.33-5.67 1.33zm20.2-77.23c0 0 0 0 0 0h0l0 0zm-40.65 63.4l0.01 0.11c0.06 0.87 0.86 1.81 2.17 2.57l12.37 7.14c3.01 1.74 7.73 1.96 10.3 0.48l14.03-8.1c0.65-0.38 1.41-1.01 1.34-1.91l-0.1-1.36h0.11v-59.8l-40.25 0.06l0.02 60.81z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m205.24 239.26v61.49h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-1.03 0.6-2.34 0.94-3.74 1.08v-74.59l18.91-0.03c0.47 0 0.85 0.38 0.85 0.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m203.25 241.54l-14.03 8.1c-2.97 1.71-8.15 1.5-11.57-0.48l-12.37-7.14c-3.42-1.98-3.8-4.97-0.83-6.68l14.03-8.1c2.97-1.71 8.14-1.5 11.57 0.48l12.37 7.14c3.42 1.98 3.8 4.97 0.83 6.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m184.18 252.06c-2.49 0-5.09-0.61-7.17-1.81l-12.37-7.14c-2.2-1.27-3.47-3.05-3.47-4.88c0-1.6 0.94-3.02 2.64-4l14.03-8.1c3.37-1.94 9-1.73 12.84 0.48l12.37 7.14c2.2 1.27 3.47 3.05 3.47 4.88c0 1.6-0.94 3.02-2.64 4l-14.03 8.1c-1.54 0.89-3.56 1.33-5.67 1.33zm-0.69-24.71c-1.66 0-3.23 0.32-4.38 0.98l-14.03 8.1c-0.62 0.36-1.37 0.97-1.37 1.8c0 0.88 0.82 1.89 2.2 2.68l12.37 7.14c3.02 1.74 7.73 1.96 10.3 0.48l14.03-8.1c0.62-0.36 1.37-0.97 1.37-1.8c0-0.88-0.82-1.89-2.2-2.68l-12.37-7.14c-1.67-0.97-3.86-1.46-5.92-1.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m180.24 312.03h-2.53v-62.21h2.53v62.21z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m201.4 301.76h-1.95v-55.36h1.95v55.36z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m179.45 300.71v18.59h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-2.97 1.71-8.15 1.5-11.57-0.48l-12.37-7.14c-1.78-1.03-2.71-2.33-2.81-3.58h-0.01l-0.02-18.53c0-0.47 0.38-0.85 0.84-0.85l41.09-0.06c0.47 0 0.85 0.38 0.85 0.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m158.4 332.93c-2.49 0-5.09-0.61-7.17-1.81l-12.37-7.14c-1.61-0.93-2.71-2.11-3.18-3.41h-0.26l-0.01-1.27l-0.02-18.53c0-1.16 0.95-2.11 2.11-2.11l41.09-0.06c0 0 0 0 0 0c0.56 0 1.09 0.22 1.49 0.62c0.4 0.4 0.62 0.93 0.62 1.5v19.86h-0.15c-0.32 1.16-1.18 2.18-2.47 2.93l-14.03 8.1c-1.54 0.89-3.56 1.33-5.67 1.33zm-20.45-13.82l0.01 0.1c0.06 0.87 0.86 1.81 2.17 2.57l12.37 7.14c3.02 1.74 7.73 1.96 10.3 0.48l14.03-8.1c0.65-0.38 1.41-1.01 1.34-1.91l-0.1-1.36h0.11v-16.9l-40.25 0.06l0.01 17.92z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m179.45 300.75v18.59h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-1.03 0.6-2.34 0.94-3.74 1.08v-31.69l18.91-0.03c0.47 0 0.85 0.38 0.85 0.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m177.47 303.03l-14.03 8.1c-2.97 1.71-8.15 1.5-11.57-0.48l-12.37-7.14c-3.42-1.98-3.8-4.97-0.83-6.68l14.03-8.1c2.97-1.71 8.14-1.5 11.57 0.48l12.37 7.14c3.42 1.98 3.8 4.97 0.83 6.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m158.4 313.55c-2.49 0-5.09-0.61-7.17-1.81l-12.37-7.14c-2.2-1.27-3.47-3.05-3.47-4.88c0-1.6 0.94-3.02 2.64-4l14.03-8.1c3.37-1.94 9-1.73 12.84 0.48l12.37 7.14c2.2 1.27 3.47 3.05 3.47 4.88c0 1.6-0.94 3.02-2.64 4l-14.03 8.1c-1.54 0.89-3.56 1.33-5.67 1.33zm-0.69-24.71c-1.66 0-3.23 0.32-4.38 0.98l-14.03 8.1c-0.62 0.36-1.37 0.97-1.37 1.8c0 0.88 0.82 1.89 2.2 2.68l12.37 7.14c3.02 1.74 7.74 1.96 10.3 0.48l14.03-8.1c0.62-0.36 1.37-0.97 1.37-1.8c0-0.88-0.82-1.89-2.2-2.68l-12.37-7.14c-1.67-0.97-3.87-1.46-5.93-1.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m154.46 330.62h-2.53v-19.31h2.53v19.31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m175.62 320.35h-1.95v-12.46h1.95v12.46z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m298.03 508.95v36.14h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-2.97 1.71-8.15 1.5-11.57-0.48l-12.37-7.14c-1.78-1.03-2.71-2.33-2.81-3.58h-0.01l-0.02-36.08c0-0.47 0.38-0.85 0.84-0.85l41.09-0.06c0.47 0 0.85 0.38 0.85 0.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m276.98 558.72c-2.49 0-5.09-0.61-7.17-1.81l-12.37-7.14c-1.61-0.93-2.71-2.11-3.18-3.41h-0.26l-0.01-1.27l-0.02-36.08c0-1.17 0.95-2.11 2.11-2.11l41.09-0.06c0.59 0.06 1.1 0.22 1.5 0.62c0.4 0.4 0.62 0.93 0.62 1.5v37.41h-0.15c-0.32 1.16-1.18 2.18-2.47 2.93l-14.03 8.1c-1.54 0.89-3.56 1.33-5.67 1.33zm-20.45-13.82l0.01 0.1c0.06 0.87 0.86 1.81 2.17 2.57l12.37 7.14c3.02 1.74 7.73 1.96 10.3 0.48l14.03-8.1c0.65-0.38 1.41-1.01 1.35-1.91l-0.1-1.36h0.1v-34.45l-40.25 0.06l0.02 35.47z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m298.03 508.99v36.14h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-1.03 0.6-2.34 0.94-3.74 1.08v-49.24l18.91-0.03c0.47 0 0.85 0.38 0.85 0.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m296.05 511.27l-14.03 8.1c-2.97 1.71-8.15 1.5-11.57-0.48l-12.37-7.14c-3.42-1.98-3.8-4.97-0.83-6.68l14.03-8.1c2.97-1.71 8.14-1.5 11.57 0.48l12.37 7.14c3.42 1.98 3.8 4.97 0.83 6.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m276.98 521.8c-2.49 0-5.09-0.61-7.17-1.81l-12.37-7.14c-2.2-1.27-3.47-3.05-3.47-4.87c0-1.6 0.94-3.02 2.64-4l14.03-8.1c3.37-1.94 9-1.73 12.84 0.48l12.37 7.14c2.2 1.27 3.47 3.05 3.47 4.88c0 1.6-0.94 3.02-2.64 4l-14.03 8.1c-1.54 0.89-3.56 1.33-5.67 1.33zm-0.69-24.71c-1.66 0-3.23 0.32-4.38 0.98l-14.03 8.1c-0.62 0.36-1.37 0.97-1.37 1.81c0 0.88 0.82 1.89 2.2 2.68l12.37 7.14c3.02 1.74 7.73 1.96 10.3 0.48l14.03-8.1c0.62-0.36 1.37-0.96 1.37-1.8c0-0.88-0.82-1.89-2.2-2.68l-12.37-7.14c-1.67-0.97-3.87-1.46-5.93-1.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m273.04 556.41h-2.54v-36.86h2.54v36.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m294.2 546.15h-1.95v-30.01h1.95v30.01z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m270.39 544.72v12.74h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-2.97 1.71-8.14 1.5-11.57-0.48l-12.37-7.14c-1.78-1.03-2.71-2.33-2.81-3.58h-0.01l-0.01-12.68c0-0.47 0.38-0.85 0.84-0.85l41.09-0.06c0.47 0 0.85 0.38 0.85 0.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m249.34 571.09c-2.49 0-5.09-0.61-7.17-1.81l-12.37-7.14c-1.61-0.93-2.71-2.11-3.18-3.41h-0.26l-0.01-1.27l-0.02-12.68c0-1.17 0.95-2.12 2.11-2.12l41.09-0.06c1.17 0 2.12 0.95 2.12 2.11v14.01h-0.15c-0.32 1.16-1.18 2.18-2.47 2.93l-14.03 8.1c-1.54 0.89-3.57 1.33-5.67 1.33zm-20.45-13.82l0.01 0.1c0.06 0.87 0.86 1.81 2.17 2.57l12.37 7.14c3.01 1.74 7.73 1.96 10.3 0.48l14.03-8.1c0.65-0.38 1.41-1.01 1.35-1.91l-0.1-1.36h0.11v-11.05l-40.25 0.06l0.01 12.07z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m270.39 544.76v12.74h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-1.03 0.6-2.34 0.94-3.74 1.08v-25.84l18.91-0.03c0.47 0 0.85 0.38 0.85 0.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m268.4 547.04l-14.03 8.1c-2.97 1.71-8.14 1.5-11.57-0.48l-12.37-7.14c-3.42-1.98-3.8-4.97-0.83-6.68l14.03-8.1c2.97-1.71 8.14-1.5 11.57 0.48l12.37 7.14c3.42 1.98 3.8 4.97 0.83 6.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m249.34 557.56c-2.49 0-5.09-0.61-7.17-1.81l-12.37-7.14c-2.2-1.27-3.47-3.05-3.47-4.87c0-1.6 0.94-3.02 2.64-4l14.03-8.1c3.36-1.94 9-1.73 12.84 0.48l12.37 7.14c2.2 1.27 3.47 3.05 3.47 4.87c0 1.6-0.94 3.02-2.64 4l-14.03 8.1c-1.54 0.89-3.56 1.33-5.67 1.33zm-0.69-24.71c-1.66 0-3.23 0.32-4.37 0.98l-14.03 8.1c-0.62 0.36-1.37 0.97-1.37 1.8c0 0.88 0.82 1.89 2.2 2.68l12.37 7.14c3.02 1.74 7.73 1.96 10.3 0.48l14.03-8.1c0.62-0.36 1.37-0.96 1.37-1.8c0-0.88-0.82-1.89-2.2-2.68l-12.37-7.14c-1.67-0.96-3.87-1.46-5.93-1.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m245.4 568.78h-2.54v-13.46h2.54v13.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m266.56 558.51h-1.95v-6.61h1.95v6.61z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m544.24 152.79v12.74h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-2.97 1.71-8.14 1.5-11.57-0.48l-12.37-7.14c-1.78-1.03-2.71-2.33-2.81-3.58h-0.01l-0.01-12.68c0-0.47 0.38-0.85 0.84-0.85l41.09-0.06c0.47 0 0.85 0.38 0.85 0.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m523.19 179.16c-2.49 0-5.09-0.61-7.17-1.81l-12.37-7.14c-1.61-0.93-2.71-2.11-3.18-3.41h-0.26l-0.01-1.27l-0.02-12.68c0-1.17 0.95-2.11 2.11-2.12l41.09-0.06c0 0 0 0 0 0c0.56 0 1.09 0.22 1.49 0.62c0.4 0.4 0.62 0.93 0.62 1.5v14.01h-0.15c-0.33 1.16-1.18 2.19-2.47 2.93l-14.03 8.1c-1.54 0.89-3.56 1.33-5.67 1.33zm-20.45-13.82l0.01 0.1c0.06 0.87 0.86 1.81 2.18 2.57l12.37 7.14c3.02 1.74 7.74 1.96 10.3 0.48l14.03-8.1c0.65-0.38 1.41-1.01 1.34-1.91l-0.1-1.36h0.11v-11.05l-40.25 0.06l0.01 12.07z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m544.24 152.83v12.74h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-1.03 0.6-2.34 0.94-3.74 1.08v-25.84l18.91-0.03c0.47 0 0.85 0.38 0.85 0.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m542.25 155.11l-14.03 8.1c-2.97 1.71-8.14 1.5-11.57-0.48l-12.37-7.14c-3.42-1.98-3.8-4.97-0.83-6.68l14.03-8.1c2.97-1.71 8.14-1.5 11.57 0.48l12.37 7.14c3.42 1.98 3.8 4.97 0.83 6.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m523.19 165.64c-2.49 0-5.09-0.61-7.17-1.81l-12.37-7.14c-2.2-1.27-3.47-3.05-3.47-4.88c0-1.6 0.94-3.02 2.64-4l14.03-8.1c3.37-1.94 9-1.73 12.84 0.48l12.37 7.14c2.2 1.27 3.47 3.05 3.47 4.88c0 1.6-0.94 3.02-2.64 4l-14.03 8.1c-1.54 0.89-3.56 1.33-5.67 1.33zm-0.69-24.71c-1.66 0-3.23 0.32-4.37 0.98l-14.03 8.1c-0.62 0.36-1.37 0.97-1.37 1.8c0 0.88 0.82 1.88 2.2 2.68l12.37 7.14c3.02 1.74 7.74 1.96 10.3 0.48l14.03-8.1c0.62-0.36 1.37-0.97 1.37-1.8c0-0.88-0.82-1.89-2.2-2.68l-12.37-7.14c-1.67-0.97-3.86-1.46-5.93-1.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m519.25 176.85h-2.54v-13.46h2.54v13.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m540.4 166.59h-1.95v-6.61h1.95v6.61z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m520.7 525.16v12.74h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-2.97 1.71-8.14 1.5-11.57-0.48l-12.37-7.14c-1.78-1.03-2.71-2.33-2.81-3.58h-0.01l-0.02-12.68c0-0.47 0.38-0.85 0.84-0.85l41.09-0.06c0.47 0 0.85 0.38 0.85 0.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m499.65 551.53c-2.49 0-5.09-0.61-7.17-1.81l-12.37-7.14c-1.61-0.93-2.71-2.11-3.18-3.41h-0.26l-0.01-1.27l-0.02-12.68c0-1.16 0.94-2.11 2.11-2.12l41.09-0.06c0 0 0.01 0 0.01 0c0.56 0 1.09 0.22 1.49 0.62c0.4 0.4 0.62 0.93 0.62 1.5v14.01h-0.15c-0.33 1.16-1.18 2.18-2.47 2.93l-14.03 8.1c-1.54 0.89-3.57 1.33-5.67 1.33zm-20.45-13.82l0.01 0.1c0.06 0.87 0.86 1.81 2.17 2.57l12.37 7.14c3.02 1.74 7.74 1.96 10.3 0.48l14.03-8.1c0.65-0.38 1.41-1.01 1.34-1.91l-0.1-1.36h0.11v-11.05l-40.25 0.06l0.01 12.07z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m520.7 525.2v12.74h-0.01c0.08 1.16-0.55 2.28-1.97 3.1l-14.03 8.1c-1.03 0.6-2.34 0.94-3.74 1.08v-25.84l18.91-0.03c0.47 0 0.85 0.38 0.85 0.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m518.72 527.48l-14.03 8.1c-2.97 1.71-8.14 1.5-11.57-0.48l-12.37-7.14c-3.42-1.98-3.8-4.97-0.83-6.68l14.03-8.1c2.97-1.71 8.15-1.5 11.57 0.48l12.37 7.14c3.42 1.98 3.8 4.97 0.83 6.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m499.65 538c-2.49 0-5.09-0.61-7.17-1.81l-12.37-7.14c-2.2-1.27-3.47-3.05-3.47-4.87c0-1.6 0.94-3.02 2.64-4l14.03-8.1c3.37-1.95 9.01-1.73 12.84 0.48l12.37 7.14c2.2 1.27 3.47 3.05 3.47 4.88c0 1.6-0.94 3.02-2.64 4l-14.03 8.1c-1.54 0.89-3.57 1.33-5.67 1.33zm-0.69-24.71c-1.66 0-3.23 0.32-4.38 0.98l-14.03 8.1c-0.62 0.36-1.37 0.97-1.37 1.81c0 0.88 0.82 1.89 2.2 2.68l12.37 7.14c3.02 1.74 7.74 1.96 10.3 0.48l14.03-8.1c0.62-0.36 1.37-0.97 1.37-1.8c0-0.88-0.82-1.89-2.2-2.68l-12.37-7.14c-1.67-0.97-3.86-1.46-5.92-1.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m495.71 549.22h-2.54v-13.46h2.54v13.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m516.87 538.95h-1.95v-6.61h1.95v6.61z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m161.36 202.13l-4.69-5.46c-0.03-0.03-0.04-0.07-0.04-0.12l0.44-5.8c0-0.01 0-0.01 0-0.02l1.82-8.45c0.03-0.13 0.19-0.17 0.28-0.07l11.44 13.88c0.06 0.07 0.04 0.18-0.04 0.24l-9.01 5.82c-0.07 0.04-0.16 0.03-0.21-0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m161.48 203.16c-0.32 0-0.64-0.14-0.86-0.4l-4.96-5.77l0-0.53l0.44-5.78l1.97-9.2l0.71-0.27c0.42-0.1 0.86 0.04 1.15 0.38l11.72 14.22l-0.03 0.56c-0.05 0.32-0.23 0.6-0.5 0.78l-9.01 5.82c-0.19 0.12-0.4 0.18-0.62 0.18zm-3.85-6.87l4.01 4.66l7.64-4.93l-9.78-11.88l-1.47 6.8l-0.4 5.35z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m200.09 167.84v32.41c0 1.3-0.44 2.22-1.14 2.69l-8.32 5.01c-0.12 0.07-0.28 0.01-0.33-0.12l-5.54-14.78c-0.02-0.05-0.05-0.09-0.1-0.12l-13.26-7.66c-0.33 0.14-0.38 0.16-0.71 0.3c-0.6 3.36 1.35 7.64 2.39 9.6c0.2 0.39 0 0.69-0.31 0.48c-7.88-5.38-9.65-13.13-9.97-14.98c-0.16-0.22-0.29-0.41-0.45-0.63l-6.41-3.7c-2.42-1.4-4.4-4.83-4.4-7.63v-17.55c0-0.06-0.02-0.12-0.06-0.16l-10.04-10.62c-0.1-0.11-0.08-0.29 0.05-0.36l8.41-5.04c0.75-0.32 1.73-0.23 2.81 0.4l42.99 24.82c2.42 1.4 4.4 4.83 4.4 7.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m190.73 209.02l-0.63-0.14c-0.33-0.12-0.6-0.38-0.72-0.71l-5.44-14.52l-12.37-7.14c-0.17 3.02 1.57 6.7 2.38 8.23c0.32 0.61 0.24 1.29-0.21 1.69c-0.41 0.37-1.02 0.39-1.51 0.05c-7.84-5.35-9.86-12.88-10.34-15.4l-0.2-0.28l-6.23-3.59c-2.74-1.58-4.89-5.3-4.89-8.47v-17.25l-9.84-10.41c-0.25-0.27-0.37-0.64-0.32-1c0.05-0.37 0.27-0.69 0.59-0.87l8.39-5.03c1.19-0.52 2.5-0.36 3.79 0.39l42.99 24.82c2.74 1.58 4.89 5.3 4.89 8.47v32.41c0 1.57-0.56 2.82-1.57 3.5l-8.76 5.27zm-19.27-24.83l13.99 8.08l0.22 0.45l5.22 13.93l7.55-4.54c0.42-0.28 0.67-0.95 0.67-1.85v-32.41c0-2.45-1.79-5.56-3.91-6.78l-42.99-24.82c-0.75-0.43-1.44-0.56-1.93-0.34l-7.5 4.5l9.68 10.23l0.06 0.55v17.55c0 2.45 1.79 5.56 3.92 6.78l6.72 3.98l0.62 1.03c0.23 1.32 1.57 7.52 7.25 12.55c-0.93-2.29-1.73-5.16-1.29-7.66l0.09-0.52l1.64-0.71z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m191.53 172.85v32.54c0 2.73-1.92 3.84-4.29 2.48l-27.81-16.06c-0.16-0.09-0.32-0.05-0.35 0.12c-0.81 3.41 1.24 7.92 2.32 9.95c0.2 0.39 0 0.69-0.31 0.48c-7.97-5.44-9.69-13.31-9.98-15.04c-0.03-0.2-0.17-0.42-0.33-0.51l-6.63-3.83c-2.37-1.37-4.29-4.69-4.29-7.43v-32.54c0-2.73 1.92-3.84 4.29-2.48l43.1 24.88c2.37 1.37 4.29 4.69 4.29 7.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m189.16 209.43c-0.76 0-1.57-0.24-2.4-0.72l-26.88-15.52c-0.17 3 1.56 6.67 2.37 8.23c0.32 0.61 0.24 1.29-0.21 1.69c-0.41 0.37-1.02 0.39-1.51 0.06c-8.18-5.59-10.04-13.74-10.37-15.58l-6.51-3.76c-2.68-1.55-4.77-5.18-4.77-8.27v-32.54c0-1.69 0.62-2.97 1.74-3.62c1.12-0.65 2.55-0.54 4.01 0.3l43.1 24.88c2.68 1.55 4.77 5.18 4.77 8.27v32.54c0 1.69-0.62 2.97-1.74 3.62c-0.49 0.28-1.03 0.42-1.6 0.42zm-29.89-18.64c0.22 0 0.44 0.06 0.65 0.18l27.81 16.06c0.82 0.47 1.57 0.58 2.06 0.3c0.49-0.28 0.77-0.99 0.77-1.93v-32.54c0-2.38-1.74-5.39-3.8-6.58l-43.1-24.89c-0.82-0.47-1.57-0.58-2.06-0.3c-0.49 0.28-0.77 0.99-0.77 1.93v32.54c0 2.38 1.74 5.39 3.8 6.58l6.63 3.83c0.41 0.24 0.72 0.7 0.81 1.19c0.22 1.32 1.53 7.55 7.26 12.61c-0.99-2.42-1.81-5.48-1.2-8.07l0.11-0.48l0.56-0.34c0.15-0.06 0.31-0.1 0.47-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m189.7 166.74l-1.01-1.67l7.51-4.56l1.01 1.67l-7.51 4.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m149.5 143.68l-1.01-1.67l7.51-4.56l1.01 1.67l-7.51 4.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m192.05 175.57l-1.04-1.65l8.28-5.24l1.04 1.65l-8.28 5.24z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m200.09 200.85l-0.28 2.02l-8.28 4.54v-28.22l8.55-5.18v26.84z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m154.2 126.96l-1.94-0.16l0.77-9.39l1.94 0.16l-0.77 9.39z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m146.08 128.08l-4.36-9.94l1.79-0.78l4.36 9.94l-1.79 0.78z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m140.99 131.84l-7.87-4.45l0.96-1.7l7.87 4.45l-0.96 1.7z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m170.4 191.06l-5.46-3.15v-2.69c-1.49-1.32-2.84-2.99-3.93-4.86l-2.03 0.18l-2.55-6.58l2.12-0.19c-0.17-0.9-0.24-1.67-0.24-2.4c0-0.83 0.1-1.61 0.32-2.44l-2.08-2.59l2.88-4.09l2.18 2.71c0.98-0.46 2.11-0.59 3.34-0.37v-2.95l5.46 3.15v2.69c1.49 1.32 2.83 2.99 3.93 4.86l2.03-0.18l2.55 6.58l-2.12 0.19c0.17 0.9 0.24 1.67 0.24 2.4c0 0.83-0.1 1.61-0.32 2.44l2.08 2.59l-2.87 4.09l-2.18-2.71c-0.98 0.46-2.12 0.58-3.34 0.37v2.95zm-4-4l2.54 1.47v-2.32l0.94 0.28c1.42 0.43 2.68 0.33 3.65-0.29l0.55-0.36l1.76 2.18l1.12-1.6l-1.87-2.32l0.11-0.37c0.25-0.82 0.36-1.58 0.36-2.39c0-0.83-0.12-1.75-0.38-2.9l-0.18-0.81l1.83-0.16l-1.45-3.74l-1.88 0.17l-0.23-0.41c-1.11-2-2.53-3.76-4.1-5.1l-0.26-0.22v-2.52l-2.54-1.47v2.32l-0.94-0.28c-1.42-0.43-2.69-0.33-3.65 0.3l-0.55 0.36l-1.76-2.19l-1.13 1.6l1.87 2.32l-0.11 0.37c-0.25 0.82-0.36 1.58-0.36 2.39c0 0.83 0.12 1.75 0.38 2.9l0.18 0.81l-1.83 0.16l1.45 3.74l1.88-0.17l0.23 0.42c1.11 2 2.53 3.76 4.09 5.1l0.26 0.22v2.52zm2.88-5.35c-0.3 0-0.61-0.05-0.93-0.14c-3.05-0.91-5.58-5.31-4.85-8.4c0.2-0.82 0.64-1.45 1.28-1.82c0.64-0.37 1.41-0.44 2.22-0.2c3.04 0.91 5.58 5.31 4.85 8.4c-0.2 0.82-0.64 1.45-1.28 1.82c-0.39 0.22-0.82 0.34-1.29 0.34zm-0.51-1.54c0.41 0.13 0.78 0.1 1.07-0.06c0.28-0.16 0.49-0.47 0.59-0.89c0.55-2.31-1.57-5.98-3.85-6.66c-0.42-0.12-0.78-0.1-1.07 0.06c-0.28 0.16-0.49 0.47-0.59 0.89c-0.55 2.31 1.57 5.98 3.84 6.66z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m173.1 180.72l1.97 2.45l-2 2.85l-1.95-2.43c-1.13 0.73-2.6 0.88-4.26 0.38v2.61l-4-2.31v-2.61c-1.66-1.41-3.13-3.26-4.26-5.3l-1.95 0.17l-2-5.16l1.97-0.18c-0.23-1.04-0.4-2.07-0.4-3.06c0-0.99 0.16-1.83 0.4-2.6l-1.97-2.45l2-2.85l1.95 2.43c1.13-0.73 2.6-0.88 4.26-0.38v-2.61l4 2.31v2.61c1.66 1.41 3.13 3.26 4.26 5.3l1.95-0.17l2 5.16l-1.97 0.18c0.23 1.04 0.4 2.07 0.4 3.06c0 0.99-0.16 1.83-0.4 2.6zm-4.78-4.56c0.64-2.7-1.69-6.74-4.35-7.53c-1.25-0.37-2.27 0.22-2.57 1.49c-0.64 2.7 1.69 6.74 4.35 7.53c1.25 0.37 2.27-0.22 2.57-1.49z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m655.78 564.84l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m658.34 566.2l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m660.66 567.65l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m663.26 568.98l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m665.41 570.48l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m667.97 571.84l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m670.28 573.29l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m672.89 574.63l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m675.21 576.08l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m677.8 577.44l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m680.12 578.89l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m682.73 580.22l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m684.88 581.72l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m687.43 583.08l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m689.75 584.53l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m692.35 585.87l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m694.67 587.32l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m621.63 545.25l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m624.24 546.58l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m626.39 548.08l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m628.94 549.44l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m631.26 550.89l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m633.86 552.22l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m636.18 553.68l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m638.78 555.03l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m641.1 556.49l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m643.7 557.82l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m645.85 559.32l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m648.41 560.68l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m650.73 562.13l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m653.33 563.46l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m655.65 564.92l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m728.76 606.96l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m731.31 608.32l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m733.63 609.77l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m736.24 611.1l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m738.38 612.6l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m740.94 613.96l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m743.26 615.41l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m745.86 616.75l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m748.18 618.2l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m750.78 619.56l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m753.1 621.01l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m755.7 622.34l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m757.85 623.84l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m760.41 625.2l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m762.72 626.65l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m765.33 627.99l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m767.65 629.44l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m697.21 588.7l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m699.36 590.2l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m701.92 591.56l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m704.23 593.01l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m706.84 594.35l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m709.16 595.8l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m711.75 597.15l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m714.07 598.61l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m716.68 599.94l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m718.83 601.44l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m721.38 602.8l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m723.7 604.25l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m726.3 605.58l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m728.62 607.03l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m772.39 453.39l-31.56-29.74c-0.01-0.01-0.01-0.02 0.01-0.03c9.9-3.42 21.18-4.99 32.35-4.71c0.01 0 0.02 0.01 0.02 0.02l-0.79 34.45c0 0.01-0.02 0.02-0.03 0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m772.24 454.33l-0.39-0.33l-31.94-30.1l0.24-0.94l0.46-0.13c9.79-3.39 21.09-5.04 32.59-4.74l0.36 0.01l0.49 0.56l-0.05 0.38l-0.83 34.9l-0.94 0.38zm-29.89-30.37l29.29 27.6l0.73-31.86c-10.58-0.18-20.89 1.28-30.02 4.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m772.41 467.8l0.79-34.46c0-0.01 0.01-0.02 0.02-0.02c14.41 0.37 28.63 3.83 39.42 10.37c0 0.01 0 0.02 0 0.03l-40.2 24.08c-0.01 0.01-0.02 0-0.02-0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m772.4 468.76l-0.84-0.54l0.04-0.5l0.8-35.19l0.81-0.02c15.19 0.39 29.33 4.12 39.84 10.49l0.39 0.24v0.92l-0.4 0.26l-40.65 24.34zm1.59-34.6l-0.74 32.21l37.81-22.65c-9.96-5.71-23.04-9.08-37.08-9.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m772.42 467.8l40.2-24.07c0.01-0.01 0.02 0 0.02 0.01v29.03c0 0.01 0 0.01-0.01 0.01l-40.16 22.53c-0.01 0.01-0.02 0-0.02-0.01l-0.04-27.48c0-0.01 0-0.01 0.01-0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m772.48 496.24l-0.83-0.45l-0.01-0.49l-0.04-27.99l0.46-0.24l40.56-24.29l0.83 0.48l0.01 0.48v29.44l-0.33 0.26l-40.65 22.81zm0.75-27.98l0.04 25.67l38.57-21.64v-27.16l-38.61 23.12z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m828.71 517.87l-0.05 0.43c-0.5 8.17-6.1 15.82-16.9 22.06c-7.73 4.46-17.1 7.4-26.99 8.82c-0.01 0-0.01-0.01-0.02-0.01l-12.14-31.3l-0.13 0l0.07-34.38c0-0.01 0.01-0.02 0.02-0.02l56.16-1.04c0.01 0 0.02 0.01 0.02 0.02v26.67c0.03 0.47 0.02 3.39-0.04 8.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m784.6 550.02l-0.49-0.29l-0.12-0.27l-11.93-30.76l-0.4 0.01l0.08-36.04l57.8-1.07l0.02 0.84v26.65c0.04 0.85-0.03 7.96-0.04 8.78l-0.05 0.51c-0.52 8.58-6.5 16.44-17.3 22.67c-7.55 4.36-16.99 7.44-27.29 8.92l-0.29 0.04zm-11.3-32.64l0.08 0.19l11.91 30.7c9.85-1.48 18.86-4.46 26.08-8.63c10.3-5.95 16-13.35 16.49-21.4l0.05-0.47c0.03-3.14 0.06-8.11 0.04-8.61l0-0.05v-25.86l-54.57 1.01l-0.07 33.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m811.74 540.36c-7.73 4.46-17.1 7.4-26.99 8.82c-0.01 0-0.02 0-0.02-0.01l-0.08-0.21l0.08-34.04c0 0 0 0 0 0l3.22-10.12c0 0 0 0 0 0c0.09-0.07 19.44-15.05 28.72-22.13c0 0 0.01 0 0.01 0l12.03-0.22c0.01 0 0.02 0.01 0.02 0.02v26.67c0.03 0.47 0.02 3.39-0.04 8.75l-0.05 0.43c-0.5 8.17-6.1 15.82-16.9 22.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m784.23 550.07l-0.4-1.11l0.08-34.2l0.06-0.15l3.13-9.85l-0.05-0.22l0.31-0.31c0.24-0.19 19.54-15.14 28.8-22.2l0.3-0.17l0.2 0l12.84-0.24l0.02 0.84v26.67c0.04 0.66-0.03 7.93-0.04 8.76l-0.05 0.48c-0.53 8.62-6.51 16.47-17.3 22.69c-7.55 4.36-16.98 7.44-27.28 8.92l-0.63 0.09zm1.31-35.02l-0.08 33.2c9.8-1.5 18.71-4.46 25.87-8.6c10.3-5.95 16-13.35 16.49-21.4l0.05-0.47c0.03-3.14 0.06-8.11 0.04-8.61l0-25.91l-10.96 0.2c-8.82 6.74-26.24 20.22-28.3 21.81l-3.11 9.76z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m772.54 483.46l40.22-24.09c0 0 0.01 0 0.02 0c21.6 13.12 21.27 33.86-1.03 46.74c-7.73 4.46-17.1 7.4-26.99 8.82c-0.01 0-0.01 0-0.02-0.01l-12.19-31.43c0-0.01 0-0.01 0.01-0.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m784.19 515.83l-0.23-0.65l-12.29-31.67l0.21-0.59l0.24-0.15l40.6-24.32l0.42 0.2c10.7 6.49 16.5 15.01 16.4 24.02c-0.1 9.16-6.28 17.73-17.39 24.15c-7.55 4.36-16.99 7.44-27.29 8.92l-0.67 0.1zm-10.65-32.01l11.72 30.22c9.86-1.48 18.86-4.46 26.08-8.62c10.59-6.12 16.48-14.2 16.58-22.76c0.09-8.3-5.28-16.21-15.15-22.33l-39.22 23.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m784.64 536.17v13.12l0.01 0.04c0 0.01 0 0.01-0.01 0.01c-19.08 2.73-40.1-0.21-55.01-8.82c-11.37-6.56-17.03-15.17-16.99-23.77l0-13.28c0-0.01 0-0.01 0.01-0.01l15.16-9.2c0.59-0.37 1.19-0.74 1.81-1.1c0 0 0.01 0 0.02 0l1.9 1.1c0 0 0 0 0.01 0h2.51l0.02 1.46l38.38 22.16c0 0 0 0.01 0.01 0.01l2.37 6.11c0 0 0 0 0 0l9.81 12.17c0 0 0 0.01 0 0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m770.48 551.16c-15.3 0-30.06-3.47-41.25-9.94c-11.26-6.5-17.43-15.2-17.39-24.48v-13.77l0.46-0.24l15.11-9.17c0.59-0.37 1.19-0.74 1.82-1.11l0.19-0.11h0.43l1.92 1.1h3.09l0.03 1.8l38.15 22.06l0.12 0.12l0.07 0.17l2.31 5.95l0.12 0.17l9.81 12.12l0 0.35v12.97l0.08 0.23l-0.38 0.72l-0.41 0.06c-4.75 0.68-9.54 1.01-14.27 1.01zm-57.02-47.24v12.83c-0.04 8.68 5.85 16.87 16.58 23.07c13.97 8.07 34.53 11.42 53.8 8.82v-12.18l-9.81-12.17v-0.13l-2.21-5.71l-38.53-22.25l-0.02-1.12h-1.9l-0.18-0.09l-1.54-0.89c-0.47 0.28-0.93 0.56-1.39 0.85l-14.79 8.97z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m751.47 519.6h20.88l1.54 3.98c0 0 0 0 0 0l6.34 7.86v17.91c-9.56 1.01-19.47 0.63-28.76-1.14v-28.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m769.75 550.71c-6.24 0-12.48-0.57-18.42-1.7l-0.66-0.13v-30.1h22.25l1.7 4.38l6.44 7.98v18.93l-0.73 0.08c-3.49 0.37-7.03 0.55-10.57 0.55zm-17.46-3.18c8.74 1.6 18.09 1.97 27.13 1.08v-16.89l-6.34-7.86v-0.13l-1.29-3.32h-19.51v27.12z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m733.34 517.78h10.47v28.48c-3.68-1.11-7.19-2.46-10.47-4.05v-24.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m744.63 547.35l-1.05-0.32c-3.77-1.14-7.34-2.52-10.59-4.1l-0.46-0.22v-25.75h12.1v30.39zm-10.47-5.66c2.75 1.31 5.72 2.47 8.85 3.46v-26.57h-8.85v23.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m784.64 536.16c-19.08 2.73-40.1-0.21-55.01-8.82c-22.65-13.08-22.65-34.28-0.01-47.36c0 0 0.01 0 0.02 0l42.82 24.72c0 0 0 0.01 0.01 0.01l12.2 31.44c0 0.01 0 0.02-0.01 0.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m770.48 537.98c-15.3 0-30.06-3.47-41.25-9.94c-11.22-6.48-17.4-15.14-17.4-24.38c0-9.25 6.17-17.91 17.39-24.38l0.44-0.25l0.44 0.28l42.94 24.82l0.12 0.12l0.07 0.17l12.34 31.81l-0.41 0.69l-0.4 0.06c-4.75 0.68-9.54 1.01-14.27 1.01zm-40.85-57.07c-10.42 6.13-16.18 14.2-16.18 22.75c0 8.64 5.89 16.8 16.58 22.98c13.9 8.02 34.31 11.39 53.5 8.86l-11.73-30.23l-42.17-24.35z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m740.86 413.96l31.5 29.69c0.01 0.01 0 0.03-0.02 0.02l-42.69-24.65c-0.01-0.01-0.01-0.02 0-0.03c3.44-1.98 7.2-3.66 11.19-5.04c0.01 0 0.01 0 0.02 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m772.58 444.76l-0.67-0.39l-43.09-24.87l0.01-0.97l0.42-0.24c3.38-1.95 7.19-3.67 11.29-5.09l0.41-0.16l0.38 0.28l32.09 30.23l-0.85 1.21zm-41.31-25.73l35.56 20.53l-26.18-24.67c-3.36 1.19-6.51 2.58-9.38 4.14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m729.67 419.02l42.7 24.64c0 0 0.01 0.01 0.01 0.01l0.08 61c0 0.01-0.01 0.02-0.02 0.01l-42.78-24.7c0 0-0.01-0.01-0.01-0.01l0-60.94c0-0.01 0.01-0.02 0.02-0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m772.42 505.63l-0.42-0.25l-43.16-24.92l-0.01-0.48v-61.42l0.85-0.48l0.42 0.25l43.08 24.86l0.01 0.48l0.08 61.48l-0.85 0.48zm-41.96-26.11l41.18 23.77l-0.08-59.17l-41.1-23.71v59.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m802.24 450.15l4.45-2.66v15.43l-4.45 2.76v-15.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m801.43 467.13v-17.44l6.08-3.64v17.31l-6.08 3.77zm1.63-16.52v13.6l2.82-1.75v-13.54l-2.82 1.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m825.29 526.19h-1.63v-28.52h1.63v28.52z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m799.25 466.4h-1.63v-13.28h1.63v13.28z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m734.14 482.37h-1.63l0.02-60.95h1.63l-0.02 60.95z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m759.2 496.87h-1.63l0.02-60.95h1.63l-0.02 60.95z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m780.44 523.18h-1.63v-21.4h1.63v21.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m790.54 546.26h-1.63v-31.33h1.63v31.33z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m708.32 506.86h-1.63l0-7.17h1.63l0 7.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m818.25 450.57h-1.63v-6.87c0-1.95-1.08-3.69-2.83-4.56l-6.57-3.26l0.72-1.46l6.57 3.26c2.3 1.14 3.73 3.45 3.73 6.02v6.87z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m706.14 400.59l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m708.7 401.95l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m711.01 403.4l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m713.62 404.74l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m715.77 406.23l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m718.32 407.6l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m720.64 409.05l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m723.25 410.38l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m725.56 411.83l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m728.16 413.19l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m730.48 414.64l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m733.09 415.98l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m735.23 417.47l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m737.79 418.83l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m740.11 420.29l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m742.71 421.62l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m745.03 423.07l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m671.99 381l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m674.6 382.33l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m676.74 383.83l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m679.3 385.19l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m681.62 386.64l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m684.22 387.98l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m686.54 389.43l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m655.97 373.27l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m658.58 374.6l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m660.73 376.09l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m663.28 377.46l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m665.6 378.91l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m668.21 380.24l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m689.14 390.79l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m691.45 392.24l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m694.06 393.57l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m696.21 395.07l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m698.76 396.43l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m701.08 397.88l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m703.69 399.22l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m706.01 400.67l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m779.12 442.71l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m781.67 444.07l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m783.99 445.52l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m786.59 446.86l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m788.74 448.35l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m791.3 449.72l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m793.62 451.17l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m796.22 452.5l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m798.54 453.95l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m801.14 455.31l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m803.45 456.76l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m806.06 458.1l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m808.21 459.59l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m810.76 460.95l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m813.08 462.41l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m815.69 463.74l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m818 465.19l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m747.57 424.45l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m749.72 425.95l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m752.27 427.31l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m754.59 428.76l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m757.2 430.1l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m759.51 431.55l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m762.11 432.91l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m764.43 434.36l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m767.04 435.69l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m769.18 437.19l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m771.74 438.55l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m774.06 440l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m776.66 441.34l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m778.98 442.79l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m852.16 484.75l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m854.71 486.11l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m857.03 487.56l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m859.63 488.9l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m861.78 490.39l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m864.34 491.76l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m866.66 493.21l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m869.26 494.54l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m871.58 495.99l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m874.18 497.35l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m876.5 498.8l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m879.1 500.14l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m881.25 501.63l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m883.8 503l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m886.12 504.45l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m888.73 505.78l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m891.04 507.23l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m820.61 466.5l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m822.76 467.99l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m825.31 469.35l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m827.63 470.81l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m830.24 472.14l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m832.55 473.59l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m835.15 474.95l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m837.47 476.4l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m840.08 477.73l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m842.22 479.23l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m844.78 480.59l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m847.1 482.04l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m849.7 483.38l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m852.02 484.83l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m972.09 243.44v175.08c0 3.21-1 5.53-2.61 6.67c-5.15 4.45-10 7.29-14.55 8.54l-5.57-8.72l7.69-3.8l-220.78-127.46c-4.71-2.72-8.53-10.02-8.53-16.3v-163.17l-10.91-10.64c3.82-3.03 8.49-5.78 14-8.25c0.03-0.01 0.05-0.02 0.08-0.04c0.01-0.01 0.03-0.01 0.04-0.02l0 0c1.46-0.71 3.31-0.58 5.32 0.58l227.29 131.22c4.71 2.72 8.53 10.02 8.53 16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m955.51 434.82l-6.51-10.19l7.06-3.48l-219.26-126.59c-4.96-2.87-9-10.54-9-17.11v-162.77l-11.39-11.11l0.84-0.66c0.24-0.19 5.92-4.66 14.2-8.37c1.89-0.92 4.09-0.7 6.29 0.57l227.29 131.22c4.96 2.87 9 10.54 9 17.11v175.08c0 3.42-1.07 6.06-3 7.44c-7.73 6.68-14.56 8.6-14.85 8.68l-0.67 0.18zm-3.8-9.43l4.62 7.23c1.85-0.64 7.43-2.86 13.54-8.13c1.48-1.06 2.28-3.21 2.28-5.96v-175.08c0-5.97-3.62-12.92-8.06-15.49l-227.29-131.22c-1.67-0.96-3.2-1.15-4.44-0.55l-0.12 0.05c-6.27 2.81-11.1 6.13-12.98 7.5l10.41 10.15v163.56c0 5.97 3.62 12.92 8.06 15.49l222.3 128.34l-8.32 4.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m762.69 110.54l193.33 111.62l-74.14 56.57l-153.05-88.36v-60.28l33.85-19.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m881.95 279.85l-0.54-0.31l-153.51-88.63v-61.36l34.79-20.09l0.47 0.27l194.55 112.32l-75.75 57.8zm-152.18-90.03l152.04 87.78l72.52-55.33l-191.64-110.64l-32.92 19v59.19z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m727.02 106.13l14.04-7.97l11.75 6.78l-24.17 14.61v-5.28l-2.74-2.67l1.12-5.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m727.71 121.22v-6.55l-2.83-2.76l1.31-6.39l14.88-8.44l13.59 7.84l-26.95 16.29zm-0.78-9.93l2.66 2.59v4.01l21.39-12.93l-9.91-5.72l-13.21 7.49l-0.93 4.55z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m905.02 427.12c-6.04 5.95-16.32 9.87-17.55 10.33c-0.08 0.03-0.16 0-0.21-0.06l-8.33-9.77c-0.02-0.02-0.03-0.03-0.06-0.05l-85.03-47.23c-0.01-0.01-0.03-0.02-0.04-0.03l-6.94-6.19c-0.1-0.09-0.09-0.24 0.01-0.32c5.87-4.45 11.61-7.79 17.21-10.02l0.19-0.09c0.62-0.39 1.3-0.26 2.26 0.3l9.2 5.31c9.11 5.26 16.56 0.96 16.56-9.56v-58.13c0-0.16 0.17-0.26 0.31-0.18l8.97 5.18c0.09 0.05 0.13 0.16 0.08 0.26c-0.74 1.54-1.16 3.45-1.16 5.73v42.46c0 5.76 2.63 12.32 6.57 17.44c0.04 0.06 0.12 0.09 0.19 0.08l18.46-2.15c0.11-0.01 0.21 0.07 0.23 0.18l0.91 6.94c0.96-1.63 1.51-3.77 1.51-6.39v-42.46c0-2.2-0.39-4.52-1.09-6.84c-0.05-0.18 0.13-0.33 0.29-0.24l8.89 5.13c0.06 0.04 0.1 0.1 0.1 0.18v58.6c0 10.39 7.36 23.14 16.36 28.33l8.83 5.1c1.92 1.11 3.4 2.92 3.85 5.09c0.3 1.48 0.02 2.52-0.58 3.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m887.41 438.4c-0.32 0-0.63-0.14-0.86-0.4l-8.25-9.68l-85-47.22l-0.11-0.09l-6.94-6.19c-0.26-0.23-0.39-0.55-0.38-0.9c0.01-0.35 0.18-0.66 0.46-0.87c8.81-6.67 17.08-10 17.43-10.14l0.12-0.06c1.09-0.68 2.26-0.19 3.15 0.32l9.2 5.31c4.1 2.37 7.92 2.77 10.76 1.14c2.83-1.64 4.4-5.15 4.4-9.89v-58.13c0-0.41 0.22-0.79 0.57-0.99c0.35-0.2 0.79-0.2 1.14 0l8.97 5.18c0.52 0.29 0.71 0.95 0.45 1.48c-0.7 1.46-1.06 3.26-1.06 5.32v42.46c0 5.26 2.29 11.41 6.13 16.54l18.05-2.1c0.6-0.07 1.18 0.37 1.26 0.99l0.39 2.97c0.11-0.72 0.16-1.49 0.16-2.3v-42.46c0-2.05-0.35-4.25-1.05-6.57c-0.14-0.46 0.02-0.94 0.38-1.23c0.37-0.29 0.87-0.32 1.27-0.09l8.89 5.13c0.35 0.2 0.57 0.58 0.57 0.99v58.6c0 10.12 7.13 22.46 15.89 27.52l8.83 5.1c2.25 1.3 3.82 3.38 4.3 5.71c0.47 2.3-0.33 3.47-0.85 3.96c-6.17 6.07-16.69 10.09-17.86 10.52c-0.13 0.05-0.26 0.07-0.39 0.07zm-93.04-58.84l85.1 47.27l0.16 0.17l8 9.38c2.38-0.92 11.33-4.62 16.73-9.93c0.41-0.39 0.53-1.21 0.32-2.23c-0.37-1.8-1.61-3.43-3.4-4.46l-8.83-5.1c-9.28-5.35-16.83-18.43-16.83-29.14v-58.18l-6.98-4.03c0.44 1.86 0.66 3.66 0.66 5.37v42.46c0 2.71-0.55 5.02-1.64 6.87l-1.39 2.35l-1.16-8.93l-17.74 2.07c-0.41 0.05-0.8-0.12-1.04-0.44c-4.24-5.5-6.77-12.23-6.77-18.01v-42.46c0-2.07 0.33-3.92 0.97-5.51l-7.29-4.21v56.86c0 5.44-1.89 9.52-5.33 11.51c-3.44 1.99-7.93 1.58-12.64-1.14l-9.2-5.31c-0.93-0.54-1.17-0.39-1.29-0.31l-0.27 0.14c-0.15 0.06-8.02 3.23-16.35 9.4l6.21 5.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m905.02 427.35c-6.04 5.95-16.32 9.87-17.55 10.33c-0.08 0.03-0.16 0-0.21-0.06l-4.34-5.09l4.37-0.57c6.02-1.75 11.89-5.01 17.59-9.78c0.67 0.87 0.49 1 0.71 2.09c0.3 1.48 0.02 2.52-0.58 3.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m887.41 438.63c-0.32 0-0.63-0.14-0.86-0.4l-5.46-6.41l6.01-0.79c0.82-0.25 9.27-2.95 17.19-9.58l0.75-0.62l0.6 0.77c0.62 0.79 0.69 1.19 0.78 1.83c0.02 0.17 0.05 0.38 0.11 0.64c0.47 2.3-0.33 3.47-0.85 3.96c-6.17 6.07-16.69 10.09-17.86 10.52c-0.13 0.05-0.26 0.07-0.39 0.07zm-2.65-5.39l2.88 3.38c2.38-0.92 11.33-4.62 16.73-9.93c0.41-0.39 0.53-1.21 0.32-2.23c-0.07-0.32-0.1-0.56-0.13-0.77c0-0.01 0-0.02 0-0.03c-8.31 6.62-16.63 9.09-16.99 9.19l-0.14 0.03l-2.66 0.35z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m868.91 422.15c3.32-1.82 11.48-6.3 19.87-11.08c1.2 1.02 2.45 1.93 3.73 2.67l8.43 4.87l-20.18 11.53l-2.25-2.64c-0.02-0.02-0.03-0.03-0.06-0.05l-9.55-5.31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m880.56 431.34l-2.67-3.13l-10.92-6.07l1.49-0.82c3.15-1.72 11.4-6.25 19.86-11.07l0.57-0.33l0.5 0.43c1.22 1.04 2.43 1.9 3.59 2.58l9.85 5.68l-22.27 12.73zm-1.65-4.71l0.15 0.08l0.17 0.18l1.75 2.05l18.09-10.33l-7.02-4.05c-1.1-0.63-2.23-1.42-3.36-2.35c-7.16 4.08-14.1 7.9-17.83 9.95l8.06 4.48z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m794.74 381.71l-0.9-1.35c-0.01-0.01-0.03-0.02-0.04-0.03l-6.94-6.19c-0.1-0.09-0.09-0.24 0.01-0.32c5.87-4.45 11.61-7.79 17.21-10.02l0.19-0.09c0.62-0.39 1.3-0.26 2.26 0.3l9.2 5.31l-21 12.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m794.45 382.97l-1.32-1.98l-6.89-6.15c-0.26-0.23-0.4-0.56-0.38-0.9c0.01-0.34 0.18-0.66 0.46-0.87c8.81-6.67 17.08-10 17.43-10.14l0.12-0.06c1.08-0.68 2.25-0.19 3.14 0.33l10.59 6.12l-23.15 13.66zm-0.08-3.39l0.12 0.07l0.53 0.8l18.85-11.12l-7.81-4.51c-0.93-0.54-1.17-0.39-1.29-0.32l-0.27 0.14c-0.15 0.06-8.01 3.23-16.35 9.4l6.21 5.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m884.44 406.17c-6.58 4.06-13.13 7.87-19.67 11.45l-1.15 1.47l-7.93-4.4l-0.26-0.35l-9.73-5.88l-2.02-39.62c0.2-0.07 0.47-0.15 0.81-0.27c0.78 1.36 1.64 2.68 2.59 3.9c0.04 0.06 0.12 0.09 0.19 0.08l18.46-2.15c0.11-0.01 0.21 0.07 0.23 0.18l0.91 6.94c0.96-1.63 1.51-3.77 1.51-6.39v-10.22c0.69-0.2 1.14-0.31 1.26-0.31c0.31 0 3.15 0.94 6.94 2.23v22.69c0 6.8 3.17 14.61 7.88 20.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m863.86 420.3l-8.8-4.89l-0.27-0.36l-10.01-6.05l-2.08-40.83l2.22-0.73l0.38 0.67c0.7 1.23 1.46 2.39 2.27 3.47l18.05-2.1c0.6-0.07 1.18 0.37 1.26 0.99l0.39 2.97c0.11-0.72 0.16-1.49 0.16-2.3v-10.93l0.68-0.19c1.13-0.32 1.35-0.35 1.52-0.35c0.27 0 0.56 0 7.24 2.28l0.63 0.22v23.36c0 6.3 2.94 14 7.68 20.08l0.64 0.83l-0.89 0.55c-9.07 5.59-18.19 10.64-19.54 11.38l-1.53 1.95zm-7.55-6.34l7.06 3.92l0.78-0.99l0.17-0.09c0.1-0.05 9.31-5.1 18.75-10.88c-4.67-6.33-7.44-13.88-7.44-20.4v-22.02c-4.36-1.48-5.65-1.87-6.01-1.95c-0.06 0.01-0.16 0.04-0.31 0.08v9.51c0 2.71-0.55 5.02-1.64 6.87l-1.39 2.35l-1.16-8.93l-17.74 2.07c-0.41 0.05-0.8-0.12-1.04-0.44c-0.56-0.73-1.1-1.49-1.62-2.29l1.89 37.16l9.46 5.72l0.25 0.33z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m888.41 435.27c0 2.17-1.52 3.04-3.4 1.96l-95.78-55.3c-1.88-1.08-3.4-3.72-3.4-5.88c0-2.17 1.52-3.04 3.4-1.96l9.51 5.49c8.98 5.18 16.25 0.98 16.25-9.38v-58.84l9.44 5.45c-0.79 1.56-1.24 3.54-1.24 5.89v42.46c0 8.89 6.24 19.69 13.93 24.13c7.7 4.44 13.93 0.84 13.93-8.04v-42.46c0-2.36-0.45-4.85-1.24-7.33l9.44 5.45v58.84c0 10.37 7.28 22.97 16.25 28.15l9.51 5.49c1.88 1.08 3.4 3.72 3.4 5.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m886.54 438.63c-0.63 0-1.31-0.2-1.99-0.59l-95.78-55.3c-2.17-1.25-3.86-4.19-3.86-6.69c0-1.4 0.52-2.47 1.46-3.01c0.94-0.55 2.13-0.46 3.34 0.24l9.51 5.49c4.04 2.33 7.79 2.74 10.55 1.14c2.77-1.6 4.29-5.05 4.29-9.71v-60.46l11.61 6.7l-0.4 0.79c-0.76 1.5-1.14 3.34-1.14 5.47v42.46c0 8.57 6.04 19.04 13.46 23.32c3.42 1.97 6.58 2.32 8.92 0.98c2.33-1.34 3.61-4.26 3.61-8.21v-42.46c0-2.19-0.4-4.56-1.2-7.04l-0.74-2.31l12.01 6.93v59.38c0 10.05 7.08 22.32 15.78 27.34l9.51 5.49c2.17 1.25 3.86 4.19 3.86 6.69c0 1.4-0.52 2.47-1.46 3.01c-0.41 0.24-0.87 0.36-1.35 0.36zm-98.82-64.07c-0.16 0-0.3 0.03-0.42 0.1c-0.33 0.19-0.52 0.7-0.52 1.39c0 1.83 1.34 4.15 2.93 5.07l95.78 55.3c0.59 0.34 1.13 0.43 1.46 0.24c0.33-0.19 0.53-0.7 0.53-1.39c0-1.83-1.34-4.15-2.93-5.07l-9.51-5.49c-9.22-5.32-16.72-18.32-16.72-28.96v-58.3l-6.98-4.03c0.44 1.86 0.66 3.66 0.66 5.37v42.46c0 4.65-1.62 8.14-4.55 9.83c-2.94 1.69-6.77 1.35-10.79-0.98c-7.94-4.58-14.4-15.78-14.4-24.95v-42.46c0-2.07 0.33-3.92 0.97-5.51l-7.29-4.21v57.22c0 5.36-1.86 9.39-5.23 11.34c-3.37 1.95-7.79 1.54-12.43-1.14l-9.51-5.49c-0.39-0.22-0.75-0.34-1.05-0.34z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m823.87 318.2h30.87v16.25l-4.95-2.86c0.79 2.47 1.24 4.97 1.24 7.33v42.46c0 8.89-6.24 12.49-13.93 8.04c-7.7-4.44-13.93-15.25-13.93-24.13v-42.46c0-1.76 0.25-3.31 0.71-4.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m843.32 392.27c-2.07 0-4.35-0.68-6.69-2.04c-7.94-4.58-14.4-15.78-14.4-24.95v-42.46c0-1.82 0.26-3.48 0.76-4.94l0.22-0.63h32.47v18.81l-4.37-2.52c0.44 1.86 0.66 3.66 0.66 5.37v42.46c0 4.65-1.62 8.14-4.55 9.83c-1.23 0.71-2.61 1.06-4.1 1.06zm-18.76-73.13c-0.31 1.11-0.46 2.35-0.46 3.7v42.46c0 8.57 6.04 19.04 13.46 23.32c3.42 1.98 6.59 2.32 8.92 0.98c2.33-1.34 3.61-4.26 3.61-8.21v-42.46c0-2.19-0.4-4.56-1.2-7.04l-0.74-2.31l5.64 3.26v-13.69h-29.24z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m843.68 328.03l-4.95-2.86c0.79 2.47 1.24 4.97 1.24 7.33v42.46c0 6.63-3.48 10.32-8.44 9.91c-4.93-5.32-8.37-12.98-8.37-19.58v-42.46c0-1.76 0.25-3.31 0.71-4.63h19.81v9.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m832.26 385.84c-0.26 0-0.53-0.01-0.81-0.03l-0.36-0.03l-0.25-0.27c-5.24-5.66-8.62-13.6-8.62-20.22v-42.46c0-1.82 0.26-3.48 0.76-4.94l0.22-0.63h21.42v12.4l-4.37-2.52c0.44 1.87 0.66 3.66 0.66 5.37v42.46c0 3.85-1.1 6.9-3.19 8.82c-1.47 1.35-3.34 2.06-5.46 2.06zm-0.29-1.88c1.76 0.07 3.31-0.47 4.48-1.55c1.69-1.56 2.58-4.13 2.58-7.45v-42.46c0-2.19-0.4-4.56-1.2-7.04l-0.74-2.31l5.64 3.26v-7.27h-18.18c-0.31 1.11-0.46 2.35-0.46 3.7v42.46c0 6.07 3.08 13.36 7.87 18.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m828.06 318.2h26.68v11.22l-0.21-0.12c0.08 0.25 0.14 0.5 0.21 0.76v4.4l-4.95-2.86c0.79 2.47 1.24 4.97 1.24 7.33v42.46c0 3.33-0.88 5.92-2.38 7.62c-2.02 0.15-4.34-0.44-6.83-1.87c-7.7-4.44-13.93-15.25-13.93-24.13v-42.46c0-0.83 0.06-1.6 0.17-2.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m848.05 389.95c-2.09 0-4.39-0.69-6.69-2.02c-7.94-4.59-14.4-15.78-14.4-24.95v-42.46c0-0.84 0.06-1.67 0.18-2.47l0.12-0.8h28.43v18.81l-4.37-2.52c0.44 1.86 0.66 3.66 0.66 5.37v42.46c0 3.45-0.9 6.3-2.61 8.24l-0.25 0.29l-0.38 0.03c-0.22 0.02-0.45 0.02-0.67 0.02zm-19.16-70.82c-0.04 0.46-0.06 0.93-0.06 1.4v42.46c0 8.57 6.04 19.04 13.47 23.32c2.07 1.19 4.07 1.8 5.9 1.76c1.24-1.59 1.89-3.89 1.89-6.7v-42.46c0-2.19-0.4-4.56-1.2-7.04l-0.74-2.31l5.64 3.26l-0.05-2.83c-0.04-0.14-0.07-0.28-0.12-0.42l-0.74-2.32l0.91 0.53v-8.66h-24.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m941.11 248.27l28.06-16.13c2.36 3.39 3.93 7.82 3.93 11.84v167.8l-16.21 9.3l-49.96-28.85l2.6-125.96l31.58-18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m956.88 422.16l-50.91-29.39l0.01-0.55l2.61-126.49l32.04-18.27l28.8-16.56l0.49 0.7c2.57 3.68 4.1 8.31 4.1 12.38v168.34l-17.15 9.83zm-49.01-30.46l49.01 28.3l15.27-8.76v-167.26c0-3.44-1.22-7.34-3.29-10.59l-27.3 15.69l-31.12 17.74l-2.58 124.87z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m950.77 433.08l-227.29-131.22c-4.71-2.72-8.53-10.02-8.53-16.3v-175.08c0-6.28 3.82-9.17 8.53-6.45l227.29 131.22c4.71 2.72 8.53 10.02 8.53 16.3v175.08c0 6.28-3.82 9.17-8.53 6.45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m954.16 435.05c-1.22 0-2.54-0.39-3.86-1.15l-227.29-131.22c-4.96-2.87-9-10.54-9-17.11v-175.08c0-3.65 1.25-6.46 3.42-7.71c1.85-1.07 4.17-0.91 6.52 0.45l227.29 131.22c4.96 2.87 9 10.54 9 17.11v175.08c0 3.65-1.25 6.46-3.42 7.71c-0.81 0.47-1.71 0.7-2.66 0.7zm-234.07-331.1c-0.63 0-1.21 0.15-1.72 0.44c-1.58 0.91-2.48 3.13-2.48 6.09v175.08c0 5.97 3.62 12.92 8.06 15.49l227.29 131.22c1.75 1.01 3.4 1.17 4.64 0.45c1.58-0.91 2.48-3.13 2.48-6.09v-175.08c0-5.97-3.62-12.92-8.06-15.49l-227.29-131.22c-1.03-0.59-2.02-0.89-2.92-0.89z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m950 414.49l-225.75-130.34c-1.35-0.78-2.44-2.86-2.44-4.66v-165.4c0-1.79 1.09-2.62 2.44-1.84l225.75 130.34c1.35 0.78 2.44 2.86 2.44 4.66v165.4c0 1.8-1.09 2.62-2.44 1.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m945.14 239.35v150.43c0 1.8-1.09 2.62-2.44 1.84l-221.51-127.89v-150.43c0-1.79 1.09-2.62 2.44-1.84l221.51 127.89z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m950.98 415.71c-0.47 0-0.96-0.14-1.44-0.42l-225.75-130.34c-1.63-0.94-2.91-3.34-2.91-5.47v-165.4c0-1.29 0.48-2.3 1.31-2.78c0.74-0.42 1.66-0.38 2.53 0.13l225.75 130.34c1.63 0.94 2.91 3.34 2.91 5.47v165.4c0 1.29-0.48 2.3-1.31 2.78c-0.33 0.19-0.7 0.29-1.09 0.29zm-0.5-2.04c0.13 0.08 0.46 0.24 0.66 0.13c0.19-0.11 0.37-0.51 0.37-1.16v-165.4c0-1.44-0.92-3.24-1.97-3.85l-225.75-130.34c-0.13-0.08-0.46-0.24-0.66-0.13c-0.19 0.11-0.37 0.51-0.37 1.16v165.4c0 1.44 0.92 3.24 1.97 3.85l225.75 130.34z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m952.41 413.3c-0.24 1.32-1.21 1.85-2.38 1.18l-225.75-130.34c-1.35-0.78-2.44-2.86-2.44-4.66v-165.4c0-1.66 0.94-2.48 2.15-1.97c-0.04 0.2-0.06 0.43-0.06 0.67v165.4c0 1.8 1.09 3.88 2.44 4.66l225.75 130.34c0.1 0.06 0.19 0.09 0.29 0.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m951 415.71c-0.47 0-0.96-0.14-1.44-0.42l-225.75-130.34c-1.63-0.94-2.91-3.34-2.91-5.47v-165.4c0-1.23 0.42-2.18 1.19-2.69c0.65-0.43 1.45-0.48 2.26-0.14l0.7 0.29l-0.14 0.74c-0.03 0.15-0.05 0.32-0.05 0.5v165.4c0 1.44 0.92 3.24 1.97 3.85l225.76 130.34c0.03 0.02 0.06 0.03 0.09 0.04l0.72 0.28l-0.06 0.79c-0.18 0.97-0.68 1.7-1.41 2.04c-0.29 0.13-0.6 0.2-0.92 0.2zm-228.01-302.6c-0.11 0.18-0.21 0.5-0.21 0.98v165.4c0 1.44 0.92 3.24 1.97 3.85l225.75 130.34c0.26 0.15 0.5 0.2 0.63 0.14c0.03-0.01 0.06-0.04 0.09-0.07l-225.33-130.09c-1.63-0.94-2.91-3.34-2.91-5.47v-165.07z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m845.3 364.59l-16.34-9.43c-0.73-0.42-1.32-1.55-1.32-2.52c0-0.97 0.59-1.42 1.32-1l16.34 9.43c0.73 0.42 1.32 1.55 1.32 2.52c0 0.97-0.59 1.42-1.32 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m845.82 365.68c-0.33 0-0.67-0.1-1-0.28l-16.34-9.43c-1.02-0.59-1.79-2.02-1.79-3.34c0-0.86 0.34-1.54 0.93-1.88c0.53-0.31 1.19-0.28 1.8 0.07l16.34 9.43c1.02 0.59 1.79 2.02 1.79 3.34c0 0.86-0.34 1.54-0.93 1.88c-0.25 0.14-0.52 0.21-0.81 0.21zm-17.24-13.19c0 0.04-0.01 0.08-0.01 0.13c0 0.69 0.46 1.48 0.85 1.71l16.25 9.38c0-0.04 0.01-0.08 0.01-0.13c0-0.69-0.46-1.49-0.85-1.71l-16.25-9.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m961.7 247.41l-0.94-1.62l9.85-5.69l0.94 1.62l-9.85 5.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m961.7 411.79l-0.94-1.62l9.85-5.69l0.94 1.62l-9.85 5.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m864.53 408.67l-0.94-1.63l14.47-8.32l0.94 1.63l-14.47 8.32z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m828.36 380.07l-0.94-1.63l3.2-1.84l0.94 1.63l-3.2 1.84z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m980.09 498.46l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m982.65 499.82l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m984.97 501.28l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m987.57 502.61l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m989.72 504.11l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m992.27 505.47l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m994.59 506.92l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m997.2 508.25l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m999.52 509.71l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1002.11 511.06l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1004.43 512.52l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1007.04 513.85l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1009.18 515.34l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1011.74 516.71l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1014.06 518.16l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1016.66 519.49l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1018.98 520.94l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m948.55 480.21l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m950.69 481.7l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m953.25 483.06l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m955.57 484.52l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m958.17 485.85l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m960.49 487.3l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m963.09 488.66l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m965.41 490.11l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m968.01 491.44l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m970.16 492.94l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m972.72 494.3l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m975.03 495.76l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m977.64 497.09l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m979.96 498.54l-0.47-0.81l199.58-115.08l0.47 0.81l-199.58 115.08z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m999.8 466.35c16.64-8.89 122.23-69.06 126.03-166.2c0.05-1.37 1-2.97 2.16-3.62c0.66-0.37 1.23-0.33 1.62 0l10.39 6.16l-3.9 37.16l-6.03 22.23v28.97c0 2.78-1.95 6.17-4.37 7.56l-48.85 28.2l-25.41 23.94l-42.51 27.1l-10.67-6.33c-0.42-0.21-0.68-0.69-0.68-1.4v-0.05c0-1.39 0.99-3.08 2.2-3.72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m997.93 472.22c-0.71-0.35-1.11-1.12-1.11-2.15c0-1.69 1.15-3.63 2.61-4.41c20.32-10.86 121.88-69.86 125.63-165.54c0.06-1.66 1.17-3.49 2.56-4.27c0.89-0.49 1.79-0.48 2.44 0.04l10.77 6.38l-3.95 37.65l-6.02 22.25v28.87c0 3.08-2.09 6.7-4.75 8.23l-48.77 28.16l-25.34 23.88l-43.02 27.44l-11.03-6.55zm78.4-45.97l49-28.31c2.16-1.24 3.98-4.4 3.98-6.89v-28.97l6.04-22.37l3.84-36.6l-9.97-5.91l-0.11-0.08c-0.2-0.18-0.61 0.03-0.73 0.09c-0.91 0.51-1.72 1.87-1.76 2.97c-1.61 41.13-21.27 80.4-58.44 116.72c-28.9 28.25-59.36 45.52-68.01 50.14c-0.95 0.51-1.79 1.93-1.79 3.09c0 0.36 0.1 0.63 0.3 0.73l10.26 6.09l42.04-26.8l25.36-23.89z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1043.47 437.52l13.73 7.8l-6.29 5.93l-1.95 1.25l-14.33-8.24c2.87-2.11 5.83-4.36 8.84-6.73z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1033.21 444.33l0.96-0.71c2.96-2.18 5.93-4.44 8.82-6.72l0.41-0.32l15.1 8.58l-7.06 6.65l-2.46 1.59l-15.77-9.07zm22.69 1.14l-12.36-7.02c-2.46 1.94-4.97 3.85-7.49 5.72l12.89 7.41l1.49-0.95l5.47-5.16z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m998.28 471.65c-0.42-0.21-0.68-0.69-0.68-1.4v-0.05c0-1.39 0.99-3.08 2.2-3.72c3.81-2.03 12.27-6.76 23.11-13.99l13.49 8l-27.44 17.49l-10.67-6.33z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m997.9 472.34c-0.69-0.36-1.08-1.12-1.08-2.13c0-1.69 1.15-3.63 2.61-4.41c4.01-2.14 12.34-6.81 23.04-13.95l0.41-0.27l15 8.89l-28.91 18.43l-11.06-6.56zm25.03-18.93c-10.56 7.03-18.78 11.63-22.77 13.76c-0.95 0.51-1.79 1.93-1.79 3.09c0 0.36 0.09 0.63 0.25 0.71l10.31 6.11l25.98-16.56l-11.98-7.11z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1120.99 330.17l15.08 8.54l-0.02 0.18l-1.96 7.22l-15.3-8.59c0.79-2.42 1.53-4.87 2.2-7.35z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1117.85 338.88l0.2-0.61c0.79-2.4 1.53-4.86 2.19-7.31l0.26-0.97l16.39 9.28l-0.05 0.51l-2.26 8.48l-16.73-9.39zm3.62-6.55c-0.54 1.95-1.13 3.9-1.75 5.82l13.88 7.79l1.58-5.84l-13.71-7.77z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1137.6 325.29l-13.59-7.63c0.83-5.05 1.39-10.22 1.65-15.5l13.56 7.68l-1.62 15.45z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1123.15 318.07l0.09-0.54c0.83-5.05 1.38-10.24 1.64-15.41l0.06-1.26l15.1 8.55l-1.8 17.13l-15.1-8.48zm3.21-14.61c-0.27 4.63-0.78 9.26-1.51 13.79l12.09 6.79l1.44-13.76l-12.03-6.81z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1140.76 304.13v93.27c0 2.78-1.95 6.17-4.37 7.56l-125.99 72.74c-1.17 0.68-2.13 0.13-2.13-1.23v-0.05c0-1.39 0.99-3.08 2.2-3.72c16.64-8.89 122.23-69.06 126.03-166.2c0.05-1.37 1-2.97 2.16-3.62c1.16-0.64 2.09-0.09 2.09 1.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1008.52 478.52c-0.64-0.37-1.01-1.12-1.01-2.1c0-1.69 1.15-3.63 2.61-4.41c20.32-10.86 121.88-69.86 125.63-165.54c0.06-1.66 1.17-3.49 2.56-4.27c0.79-0.44 1.61-0.48 2.24-0.11c0.63 0.37 1 1.12 1 2.04v93.27c0 3.08-2.09 6.7-4.75 8.23l-125.99 72.74c-0.45 0.26-0.91 0.39-1.34 0.39c-0.34 0-0.66-0.08-0.94-0.24zm130.54-174.96c-0.91 0.51-1.72 1.87-1.76 2.97c-1.61 41.13-21.27 80.4-58.44 116.72c-28.9 28.25-59.36 45.52-68.01 50.14c-0.95 0.51-1.79 1.93-1.79 3.09c0 0.35 0.09 0.62 0.23 0.7c0.14 0.09 0.42 0.03 0.73-0.15l125.99-72.74c2.16-1.24 3.98-4.4 3.98-6.89v-93.27c0-0.35-0.09-0.62-0.23-0.7c-0.04-0.03-0.1-0.04-0.17-0.04c-0.14 0-0.33 0.06-0.53 0.17z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1111.53 356.58l0.79-1.34l10.7 6.31l-0.79 1.34l-10.7-6.31z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1064.29 419.5l0.79-1.34l10.7 6.31l-0.79 1.34l-10.7-6.31z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1108.6 361.77l0.79-1.34l10.7 6.31l-0.79 1.34l-10.7-6.31z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1097.9 380.84l0.79-1.34l10.7 6.31l-0.79 1.34l-10.7-6.31z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1048.86 433.55l0.79-1.34l10.7 6.31l-0.79 1.34l-10.7-6.31z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m999.25 467.2l0.79-1.34l10.7 6.31l-0.79 1.34l-10.7-6.31z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1127.11 307.26l0.64-1.01l7.1 4.47l-0.64 1.01l-7.1-4.47z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1122.72 390.93l-3.47-2.01c-0.01 0-0.01-0.02 0-0.02l11.9-6.85c0 0 0.01 0 0.01 0l3.47 2.01c0.01 0 0.01 0.02 0 0.02l-11.9 6.85c0 0-0.01 0-0.01 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1122.71 391.67l-0.31-0.2l-3.78-2.19l-0.01-0.73l0.32-0.19l12.19-7.01l0.31 0.15l3.82 2.21l0.01 0.71l-0.28 0.2l-12.27 7.06zm-2.23-2.76l2.25 1.3l10.67-6.14l-2.25-1.3l-10.67 6.14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1122.74 390.93l11.9-6.85c0.01 0 0.02 0 0.02 0.01v13.86c0 0 0 0.01-0.01 0.01l-11.9 6.85c-0.01 0-0.02 0-0.02-0.01v-13.86c0 0 0-0.01 0.01-0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1122.75 405.53l-0.64-0.36l-0.01-0.37v-14.24l0.35-0.18l12.17-7l0.65 0.34l0.01 0.39v14.19l-0.28 0.2l-12.25 7.05zm0.61-14.23v12.44l10.68-6.14v-12.44l-10.68 6.14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1119.25 388.92l3.47 2.01c0 0 0.01 0.01 0.01 0.01v13.86c0 0.01-0.01 0.02-0.02 0.01l-3.47-2.01c0 0-0.01-0.01-0.01-0.01v-13.86c0-0.01 0.01-0.02 0.02-0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1122.73 405.53l-0.32-0.18l-3.79-2.2l-0.01-0.37v-14.22l0.63-0.37l0.32 0.18l3.79 2.2l0.01 0.37v14.22l-0.63 0.37zm-2.87-3.1l2.25 1.3v-12.44l-2.25-1.3v12.44z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1122.97 405.23l-0.47-0.81l11.69-6.73v-12.67h0.94v13.18l-0.21 0.15l-11.95 6.87z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m993.78 324.58l-74.73-46.49c-2.2-1.27-3.98-4.67-3.98-7.6l-3.08-84.66c0-2.93 4.87-4.73 7.06-3.46l77.45 44.72c2.2 1.27 3.98 4.67 3.98 7.6v85.12c0 2.93-4.51 6.04-6.7 4.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m994.97 325.69c-0.59 0-1.13-0.13-1.6-0.4l-0.02-0.01l-74.73-46.49c-2.43-1.41-4.36-5.05-4.36-8.29l-3.08-84.63c0-1.46 0.91-2.81 2.49-3.72c1.95-1.12 4.33-1.32 5.79-0.47l77.45 44.72c2.46 1.42 4.39 5.07 4.39 8.3v85.12c0 2.08-1.75 4.02-3.49 5.02c-0.99 0.57-1.96 0.86-2.84 0.86zm-0.78-1.81c0.62 0.35 1.69 0.17 2.8-0.47c1.58-0.91 2.67-2.39 2.67-3.61v-85.12c0-2.62-1.64-5.78-3.57-6.9l-77.45-44.72c-0.94-0.54-2.77-0.33-4.17 0.47c-0.5 0.29-1.68 1.1-1.68 2.28l3.08 84.63c0 2.65 1.64 5.81 3.57 6.93l74.74 46.49z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m993.32 324.36l-77.45-44.72c-2.2-1.27-3.98-4.67-3.98-7.6v-85.12c0-2.93 1.78-4.28 3.98-3.01l77.45 44.72c2.2 1.27 3.98 4.67 3.98 7.6v85.12c0 2.93-1.78 4.28-3.98 3.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m994.9 325.65c-0.64 0-1.31-0.2-1.99-0.59l-77.45-44.72c-2.46-1.42-4.38-5.07-4.38-8.3v-85.12c0-1.84 0.65-3.27 1.78-3.92c0.98-0.57 2.2-0.49 3.42 0.21l77.45 44.72c2.46 1.42 4.38 5.07 4.38 8.31v85.12c0 1.84-0.65 3.27-1.78 3.92c-0.44 0.25-0.92 0.38-1.43 0.38zm-80.61-141.4c-0.21 0-0.42 0.05-0.62 0.16c-0.61 0.35-0.97 1.29-0.97 2.51v85.12c0 2.62 1.64 5.78 3.57 6.9l77.45 44.72c0.49 0.28 1.2 0.55 1.79 0.21c0.61-0.35 0.97-1.29 0.97-2.51v-85.12c0-2.62-1.63-5.78-3.57-6.9l-77.45-44.72c-0.33-0.19-0.75-0.37-1.17-0.37z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m996.34 232.14l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m918.23 185.7l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m997.84 320.25l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m923.51 262.12v-52.65c0-5.28 3.21-7.71 7.18-5.42l47.81 27.6c3.96 2.29 7.17 8.43 7.17 13.71v52.65c0 5.28-3.21 7.71-7.17 5.42l-47.81-27.6c-3.96-2.29-7.18-8.43-7.18-13.71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m981.35 304.92c-1 0-2.08-0.32-3.16-0.94l-47.81-27.6c-4.13-2.38-7.49-8.78-7.49-14.25v-52.65c0-3.01 1.02-5.32 2.79-6.34c1.5-0.87 3.39-0.74 5.32 0.38l47.81 27.6c4.13 2.38 7.49 8.78 7.49 14.25v52.65c0 3.01-1.02 5.32-2.79 6.34c-0.65 0.38-1.38 0.57-2.16 0.57zm-50.35-29.63l47.81 27.6c1.52 0.88 2.97 1.01 4.07 0.38c1.38-0.8 2.17-2.71 2.17-5.26v-52.65c0-5.08-3.08-10.98-6.86-13.17l-47.81-27.6c-1.52-0.88-2.97-1.02-4.07-0.38c-1.38 0.8-2.17 2.71-2.17 5.26v52.65c0 5.08 3.08 10.98 6.86 13.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m979.45 299.83c-0.62 0-1.28-0.19-1.94-0.58l-46.46-26.83c-2.47-1.43-4.41-5.1-4.41-8.37v-52.19c0-1.82 0.63-3.22 1.73-3.85c0.95-0.55 2.12-0.47 3.31 0.22l46.46 26.83c2.47 1.43 4.41 5.1 4.41 8.37v52.19c0 1.82-0.63 3.22-1.73 3.85c-0.42 0.24-0.88 0.36-1.36 0.36zm-49.72-90.92c-0.25 0-0.5 0.06-0.74 0.19c-0.7 0.41-1.1 1.42-1.1 2.77v52.19c0 2.81 1.7 6.08 3.78 7.29l46.46 26.83c0.55 0.32 1.36 0.62 2.06 0.22c0.7-0.4 1.1-1.42 1.1-2.77v-52.19c0-2.81-1.7-6.08-3.78-7.29l-46.46-26.83c-0.36-0.21-0.84-0.41-1.31-0.41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m944.55 230.6l-1.99-2.34c0.71-2.65 3.78-2.42 9.22 0.7c5.43 3.12 5.04 4.51-1.16 4.15l-6.06-2.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m951.57 233.76c-0.38 0-0.72-0.01-0.99-0.03l-0.2-0.05l-6.2-2.57l-2.3-2.71l0.08-0.32c0.12-0.43 0.6-1.29 1.68-1.73c1.88-0.78 4.72-0.09 8.45 2.06c2.81 1.62 3.92 2.82 3.61 3.89c-0.37 1.23-2.56 1.46-4.12 1.46zm-0.81-1.27c1.9 0.09 3.6-0.21 3.74-0.54c0 0 0.04-0.68-3.03-2.45c-4.17-2.4-6.28-2.41-7.31-2c-0.46 0.18-0.72 0.46-0.85 0.66l1.63 1.92l5.83 2.41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m958.05 271.89c7.14 1.89 13.05 10.44 17.74 25.64l-44.12-25.47c-1.05-11.69 3.96-14.23 15.04-7.63l9.65 6.7l1.69 0.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m976.86 298.87l-45.78-26.43l-0.03-0.32c-0.03-0.31-0.64-7.71 3.63-10.4c2.8-1.76 6.96-1.03 12.35 2.18l9.69 6.72l1.55 0.69c0.93 0.27 11.24 3.74 18.12 26.05l0.47 1.52zm-44.59-27.19l42.43 24.5c-6.85-20.82-16.71-23.66-16.81-23.69l-0.1-0.03l-1.69-0.77l-9.75-6.75c-4.92-2.93-8.63-3.66-11-2.17c-3.18 2-3.14 7.53-3.08 8.92z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m947.23 249.5c-0.9-6.02 3.92-9.82 14.47-11.41c4.73 7.72 6.81 16.54 5.17 22.74c-0.84 3.17-2.3 6.21-4.81 8.19c-1.57-0.35-3.23-1.31-4.97-2.87c-0.3 2.96 0.12 5.78 1.27 8.46c0.12 2.72-1.63 3.26-5.24 1.62c-3.62-1.64-6.18-5.01-7.69-10.13c2.11-5.05 2.71-10.58 1.81-16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m956.05 277.64c-0.89 0-1.96-0.28-3.2-0.84c-5.62-2.54-7.93-10.2-8.03-10.52l-0.06-0.21l0.08-0.2c0.03-0.07 3.08-7.53 1.77-16.27c-0.6-4 1.85-7.37 7.08-9.75c3.82-1.74 7.74-2.34 7.91-2.37l0.41-0.06l0.22 0.35c4.91 8.01 6.91 16.91 5.24 23.23c-1.01 3.82-2.7 6.69-5.03 8.52l-0.23 0.18l-0.29-0.06c-0.09-0.02-1.97-0.45-4.26-2.2c-0.01 1.56 0.17 4.35 1.27 6.93l0.05 0.22c0 0.07 0.06 1.72-1.21 2.58c-0.47 0.32-1.04 0.48-1.71 0.48zm-9.97-11.52c0.4 1.2 2.66 7.45 7.28 9.54c1.71 0.78 2.99 0.94 3.69 0.47c0.57-0.38 0.65-1.13 0.67-1.4c-1.7-4.09-1.28-8.46-1.26-8.64l0.12-1.22l0.92 0.82c1.94 1.74 3.74 2.43 4.41 2.65c1.98-1.67 3.44-4.24 4.35-7.66c1.56-5.9-0.31-14.26-4.88-21.89c-2.41 0.45-14.67 3.09-13.54 10.62c1.26 8.36-1.24 15.38-1.76 16.72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m963.86 264.2l-0.81-0.25c-0.08-0.02-1.97-0.63-2.81-2.45l1.14-0.53c0.3 0.65 0.8 1.1 1.23 1.37v-3.63h1.25v5.48z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m956.64 266.59c-0.05-0.05-1.32-1.35-2.66-3.34l1.04-0.7c1.27 1.89 2.5 3.15 2.51 3.16l-0.89 0.87z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m955.05 247.67c0.47 2.53 0.03 4.39-1.31 5.57l-1.5-0.86c0.4-3.7-0.22-5.78-1.87-6.24c-1.65-0.46-2.22 0.33-1.72 2.36c0.7 2.31 0.8 4.82 0.3 7.54c-1.3 0.12-2.22-0.41-2.77-1.6c0.13-1.84-0.92-5.32-1.83-7.96c-1.36-3.92-2.2-8.88-1.57-11.92c1.71-8.26 9.58-7.19 16.7-1.29c5.84 4.84 9.24 11.25 10.21 19.23c-5.25-0.01-11.42-3.74-13.88-5.38c-0.5-0.33-0.87-0.04-0.76 0.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m948.66 256.66c-2.11 0-3.01-1.89-3.05-1.98l-0.07-0.15l0.01-0.16c0.1-1.36-0.54-4.1-1.8-7.72c-1.29-3.71-2.28-8.93-1.59-12.25c0.82-3.97 2.95-5.49 4.58-6.06c3.44-1.21 8.34 0.45 13.13 4.42c8.85 7.34 10.37 19.14 10.43 19.64l0.09 0.7l-0.71 0c-5.26-0.01-11.34-3.59-13.97-5.31c0.58 3.97-1.47 5.83-1.56 5.91l-0.34 0.3l-2.24-1.29l0.04-0.4c0.14-1.3 0.18-5.13-1.42-5.57c-0.23-0.06-0.65-0.15-0.83 0.02c-0.29 0.28-0.22 1.17-0.12 1.58c1.07 3.54 0.34 7.62 0.31 7.8l-0.09 0.46l-0.47 0.04c-0.12 0.01-0.24 0.02-0.35 0.02zm-1.85-2.38c0.17 0.29 0.68 1 1.6 1.11c0.15-1.18 0.42-4.15-0.36-6.73c-0.06-0.22-0.45-1.94 0.45-2.81c0.33-0.32 0.95-0.63 2.04-0.33c2.55 0.71 2.46 5.06 2.36 6.5l0.71 0.41c0.47-0.62 1.29-2.12 0.82-4.66c-0.1-0.56 0.06-1.03 0.44-1.28c0.36-0.24 0.84-0.21 1.28 0.09c2.26 1.51 7.86 4.92 12.79 5.25c-0.48-2.67-2.64-12.1-9.88-18.1c-4.45-3.69-8.9-5.26-11.91-4.2c-1.94 0.68-3.2 2.41-3.77 5.14c-0.64 3.08 0.32 8.04 1.55 11.59c1.3 3.73 1.93 6.43 1.88 8.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m960.46 255.47c0 0.77-0.54 1.08-1.2 0.7c-0.67-0.38-1.2-1.32-1.2-2.09c0-0.77 0.54-1.08 1.2-0.7c0.66 0.38 1.2 1.32 1.2 2.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m966.76 259.11c0 0.77-0.54 1.08-1.2 0.7c-0.67-0.38-1.2-1.32-1.2-2.09c0-0.77 0.54-1.08 1.2-0.7c0.66 0.38 1.2 1.32 1.2 2.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m950.26 253.25c-1.81-1.23-1.85-2.9-1.85-2.97l1.25-0.02l-0.63 0.01l0.63-0.02c0 0.05 0.06 1.11 1.31 1.97l-0.7 1.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m950.89 249.73l-1.22-0.27c0.02-0.09 0.22-0.94 0.98-1.3c0.35-0.17 0.94-0.29 1.76 0.11l-0.55 1.12c-0.16-0.08-0.47-0.2-0.66-0.11c-0.18 0.09-0.29 0.36-0.31 0.45z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m964.94 251.94c-0.84-5.86-4.55-10-4.59-10.05l0.93-0.84c0.16 0.18 4.01 4.47 4.9 10.71l-1.24 0.18z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m945.11 241.13c-1.06-4.64 0.77-5.93 0.99-6.07l0.66 1.06l-0.33-0.53l0.35 0.52c-0.01 0.01-1.3 0.99-0.45 4.74l-1.22 0.28z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m950.8 278.54c-0.4-0.34-0.78-0.68-1.15-1.02l0.84-0.92c0.36 0.33 0.73 0.66 1.12 0.98l-0.81 0.95zm-2.08-1.89c-0.63-0.61-1.22-1.22-1.77-1.83l0.93-0.84c0.53 0.59 1.1 1.18 1.71 1.77l-0.87 0.9zm-2.61-2.78c-0.57-0.67-1.1-1.34-1.58-1.99l1-0.75c0.47 0.63 0.98 1.27 1.53 1.92l-0.95 0.81zm-2.33-3.02c-0.48-0.69-0.95-1.41-1.38-2.14l1.07-0.64c0.42 0.7 0.87 1.4 1.33 2.06l-1.03 0.71zm-2.02-3.24c-0.41-0.75-0.8-1.52-1.15-2.27l1.14-0.52c0.33 0.73 0.71 1.47 1.11 2.19l-1.09 0.6zm-1.66-3.45c-0.61-1.5-0.84-2.41-0.85-2.45l1.21-0.3c0 0.01 0.22 0.88 0.79 2.28l-1.16 0.47z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m762.58 276.4l-74.73-46.49c-2.2-1.27-3.98-4.67-3.98-7.6l-3.08-95.92c0-2.93 4.87-4.73 7.06-3.46l77.45 44.72c2.2 1.27 3.98 4.67 3.98 7.6v96.38c0 2.93-4.51 6.04-6.7 4.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m763.77 277.5c-0.59 0-1.13-0.13-1.6-0.4l-0.02-0.01l-74.73-46.49c-2.43-1.4-4.36-5.05-4.36-8.29l-3.08-95.9c0-1.46 0.91-2.8 2.49-3.72c1.95-1.12 4.33-1.32 5.79-0.47l77.45 44.72c2.46 1.42 4.38 5.07 4.38 8.31v96.38c0 2.08-1.75 4.02-3.49 5.02c-0.99 0.57-1.96 0.86-2.84 0.86zm-0.78-1.81c0.62 0.35 1.69 0.17 2.8-0.46c1.58-0.91 2.67-2.39 2.67-3.61v-96.38c0-2.62-1.64-5.78-3.57-6.9l-77.45-44.72c-0.94-0.54-2.77-0.34-4.17 0.47c-0.5 0.29-1.68 1.1-1.68 2.28l3.08 95.9c0 2.65 1.64 5.81 3.57 6.92l74.74 46.49z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m762.12 276.17l-77.45-44.72c-2.2-1.27-3.98-4.67-3.98-7.6v-96.38c0-2.93 1.78-4.28 3.98-3.01l77.45 44.72c2.2 1.27 3.98 4.67 3.98 7.6v96.38c0 2.93-1.78 4.28-3.98 3.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m763.71 277.46c-0.63 0-1.31-0.2-1.99-0.59l-77.45-44.72c-2.46-1.42-4.38-5.07-4.38-8.31v-96.38c0-1.84 0.65-3.27 1.78-3.92c0.98-0.57 2.19-0.49 3.42 0.21l77.45 44.72c2.46 1.42 4.38 5.07 4.38 8.3v96.38c0 1.84-0.65 3.27-1.78 3.92c-0.44 0.25-0.92 0.38-1.43 0.38zm-1.18-2c0.49 0.28 1.2 0.55 1.79 0.21c0.61-0.35 0.97-1.29 0.97-2.51v-96.38c0-2.62-1.64-5.78-3.57-6.9l-77.45-44.72c-0.49-0.28-1.2-0.55-1.79-0.21c-0.61 0.35-0.97 1.29-0.97 2.51v96.38c0 2.62 1.63 5.78 3.57 6.9l77.45 44.72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m765.15 172.69l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m687.04 126.25l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m766.64 272.06l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m747.3 243.98l-47.81-27.6c-3.96-2.29-7.17-8.43-7.17-13.71v-52.65c0-5.28 3.21-7.71 7.17-5.42l47.81 27.6c3.96 2.29 7.17 8.43 7.17 13.71v52.65c0 5.28-3.21 7.71-7.17 5.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m750.16 245.47c-1 0-2.08-0.32-3.16-0.94l-47.81-27.6c-4.13-2.38-7.49-8.78-7.49-14.25v-52.65c0-3.01 1.02-5.32 2.79-6.34c1.5-0.87 3.39-0.73 5.32 0.38l47.81 27.6c4.13 2.38 7.49 8.78 7.49 14.25v52.65c0 3.01-1.02 5.32-2.79 6.34c-0.65 0.38-1.38 0.57-2.16 0.57zm-53.52-101.1c-0.56 0-1.07 0.13-1.53 0.4c-1.38 0.79-2.17 2.71-2.17 5.26v52.65c0 5.08 3.08 10.98 6.86 13.17l47.81 27.6c1.52 0.88 2.97 1.02 4.07 0.38c1.38-0.8 2.17-2.71 2.17-5.26v-52.65c0-5.08-3.08-10.98-6.86-13.17l-47.81-27.6c-0.89-0.51-1.75-0.77-2.54-0.77z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m748.26 240.38c-0.62 0-1.28-0.19-1.94-0.58l-46.46-26.83c-2.47-1.43-4.41-5.1-4.41-8.37v-52.19c0-1.82 0.63-3.22 1.73-3.85c0.94-0.55 2.12-0.47 3.31 0.22l46.46 26.83c2.47 1.43 4.41 5.1 4.41 8.37v52.19c0 1.82-0.63 3.22-1.73 3.86c-0.42 0.24-0.88 0.36-1.36 0.36zm-49.72-90.92c-0.25 0-0.5 0.06-0.74 0.19c-0.7 0.4-1.1 1.42-1.1 2.77v52.19c0 2.81 1.7 6.08 3.78 7.29l46.46 26.82c0.55 0.32 1.36 0.62 2.05 0.22c0.7-0.4 1.1-1.42 1.1-2.77v-52.19c0-2.81-1.7-6.08-3.78-7.28l-46.46-26.83c-0.36-0.21-0.84-0.41-1.31-0.41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m721.63 209.64l9.65 4.45c11.08 6.19 16.09 14.53 15.04 25l-44.12-25.47c4.69-9.79 10.6-11.51 17.74-5.16l1.69 1.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m746.85 240.11l-45.46-26.25l0.25-0.52c2.32-4.84 5.3-7.66 8.85-8.37c5.07-1.02 9.41 2.62 9.84 2.99l1.67 1.17l9.55 4.39c16.82 9.4 15.42 25.47 15.4 25.63l-0.1 0.96zm-43.83-26.75l42.71 24.66c-0.01-3.56-1.1-15.75-14.75-23.39l-9.61-4.42l-1.85-1.29c-0.04-0.04-4.2-3.66-8.8-2.73c-3.02 0.61-5.61 3.02-7.7 7.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m731.96 216.57c-1.42 3.18-3.84 3.58-7.25 1.18c-3.41-2.39-5.06-4.81-4.94-7.24c1.08-1.28 1.48-3.48 1.19-6.6c-1.65-0.43-3.21-1.33-4.69-2.71c-2.36-4.59-3.74-9.06-4.53-12.96c-1.55-7.64 0.41-13.68 4.87-15.81c9.95 12.98 14.49 21.81 13.64 26.5c-0.85 4.69-0.28 10.57 1.7 17.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m728.25 219.72c-1.21 0-2.52-0.49-3.9-1.45c-5.33-3.75-5.22-7.62-5.21-7.78l0.01-0.21l0.14-0.16c1.07-1.27 1.15-4.24 1.08-5.71c-2.41-0.78-4.43-2.65-4.52-2.73l-0.13-0.17c-2.11-4.11-3.66-8.52-4.59-13.12c-1.6-7.88 0.4-14.2 5.22-16.5l0.46-0.22l0.31 0.4c0.62 0.8 15.07 19.77 13.76 27c-1.24 6.82 1.66 17.24 1.69 17.34l0.06 0.22l-0.09 0.21c-0.04 0.09-0.98 2.15-3.12 2.74c-0.38 0.1-0.76 0.16-1.16 0.16zm-7.85-8.99c0.05 0.74 0.52 3.6 4.67 6.52c1.51 1.06 2.86 1.44 4.01 1.11c1.25-0.35 1.97-1.42 2.21-1.86c-0.45-1.66-2.85-11.07-1.65-17.66c1.11-6.14-11.07-22.74-13.21-25.59c-3.94 2.23-5.51 7.87-4.08 14.89c0.9 4.45 2.39 8.72 4.42 12.69c0.4 0.35 2.31 1.96 4.34 2.49l0.43 0.11l0.04 0.44c0.02 0.2 0.41 4.68-1.19 6.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m734.11 204.91c-2.26 1.55-3.37 3.09-3.33 4.62l-0.58-2.14c-2.13-3.13-2.83-5.63-2.08-7.51c1.65-2.07 1.65-4.01 0-5.82c-1.65-1.81-3.01-2.24-4.09-1.27c-5.17-4.76-8.13-9.55-8.87-14.37c-2.61-0.72-3.93 0.36-3.95 3.23c-2.57-4.85-3.05-8.08-3.03-9.85c0.01-1.22 0.36-2.24 1.02-2.83c1.19-1.05 2.72-0.86 4.6 0.58c1.11-3 8.44-3.79 16.8 7.24c5.28 6.97 6.2 14.22 5.39 18.98l0 0c1.01 4.54 0.39 7.59-1.87 9.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m731.41 214.23l-1.78-6.57c-3.28-4.86-2.14-7.88-2.09-8.01l0.09-0.16c0.09-0.11 2.1-2.73 0.03-5.01c-1.99-2.19-3.17-1.25-3.22-1.21l-0.42 0.35l-0.41-0.36c-6.86-6.31-8.62-12.64-8.98-14.32c-0.74-0.14-1.35-0.05-1.78 0.28c-0.97 0.73-1 2.42-1 2.44l-0.02 2.48l-1.16-2.19c-2.6-4.91-3.12-8.23-3.1-10.15c0.01-1.43 0.45-2.6 1.23-3.29c1.6-1.42 3.74-0.47 4.78 0.15c0.58-0.84 1.58-1.4 2.86-1.59c1.6-0.23 7.38-0.26 14.67 9.35c6.58 8.68 5.93 16.85 5.52 19.34c0.2 0.98 1.33 7.29-2.15 9.67c-3.02 2.07-3.05 4.01-3.05 4.1v4.7zm-2.73-14.05c-0.12 0.43-0.64 2.93 2.04 6.86l0.13 0.34c0.51-0.88 1.38-1.94 2.91-2.98c3.01-2.06 1.63-8.42 1.61-8.49l-0.03-0.12l0.02-0.12c0.38-2.21 1.11-10.07-5.27-18.5c-5.46-7.21-10.55-9.31-13.49-8.87c-1.13 0.17-1.94 0.71-2.22 1.47l-0.29 0.79l-0.67-0.51c-0.02-0.02-2.43-1.83-3.8-0.61c-0.51 0.45-0.8 1.31-0.81 2.37c-0.01 1.57 0.37 4.16 2.16 7.96c0.22-0.56 0.57-1.13 1.12-1.55c0.84-0.63 1.93-0.77 3.24-0.41l0.39 0.11l0.06 0.4c0.01 0.07 1.15 6.91 8.34 13.7c0.79-0.35 2.44-0.62 4.46 1.61c2.18 2.4 1.05 5.27 0.1 6.54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m714.54 178.44c-0.06-1.57 0.31-2.68 1.09-3.28c0.95-0.74 2.12-0.4 2.17-0.38l-0.36 1.2c0 0-0.61-0.17-1.05 0.18c-0.43 0.34-0.64 1.12-0.6 2.24l-1.25 0.05z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m735.41 196.03c-0.73-1.65-1.93-1.43-1.94-1.43l-0.25-1.23c0.76-0.15 2.43 0.1 3.33 2.15l-1.14 0.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m727.03 201.17c-1.11 0-2.24-0.82-2.38-0.93l0.75-1c0.36 0.27 1.26 0.78 1.79 0.66c0.11-0.02 0.25-0.08 0.37-0.32l1.11 0.58c-0.27 0.51-0.68 0.84-1.21 0.96c-0.14 0.03-0.29 0.05-0.44 0.05z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m716.43 195.66c-0.62 0-1.25-0.3-1.64-0.58l-0.26-0.19v-4.69h1.25v4.01c0.3 0.15 0.7 0.29 0.88 0.11l0.89 0.88c-0.33 0.33-0.72 0.45-1.12 0.45z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m729.78 223.73c-0.3 0-0.6-0.02-0.91-0.06l0.15-1.24c0.8 0.1 1.55 0.05 2.22-0.16l0.36 1.2c-0.57 0.17-1.18 0.26-1.82 0.26zm-2.23-0.32c-0.8-0.22-1.62-0.56-2.44-1l0.6-1.1c0.73 0.4 1.47 0.7 2.18 0.9l-0.33 1.21zm5.33-0.51l-0.65-1.06c0.45-0.28 0.85-0.64 1.18-1.09c0.07-0.08 0.21-0.23 0.41-0.5l1.01 0.74c-0.18 0.25-0.34 0.44-0.47 0.57c-0.37 0.51-0.89 0.98-1.47 1.34zm-8.89-1.16c-0.69-0.46-1.38-1-2.04-1.6l0.84-0.93c0.61 0.56 1.25 1.05 1.89 1.48l-0.69 1.04zm11.54-1.92l-1.13-0.55c0.34-0.71 0.53-1.43 0.56-2.16l1.25 0.05c-0.04 0.9-0.26 1.79-0.68 2.65zm-14.5-0.58c-0.57-0.59-1.12-1.23-1.64-1.91l0.95-0.82l0.06 0.07c0.48 0.62 0.99 1.23 1.53 1.78l-0.9 0.87zm-2.42-3c-0.5-0.74-0.94-1.49-1.3-2.23l1.12-0.55c0.34 0.69 0.75 1.39 1.21 2.09l-1.04 0.7zm-1.83-3.42c-0.33-0.85-0.57-1.69-0.72-2.52l1.23-0.22c0.13 0.74 0.35 1.51 0.65 2.28l-1.16 0.46zm-0.87-3.84c-0.01-0.17-0.01-0.34-0.01-0.5c0-1.36 0.29-2.15 0.32-2.23l1.17 0.45l-0.58-0.23l0.58 0.22c0 0.01-0.24 0.65-0.24 1.79c0 0.14 0 0.28 0.01 0.43l-1.25 0.07z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m719.76 191.51c-1.66-1.75-3.09-1.57-3.15-1.56l-0.2-1.23c0.09-0.02 2.11-0.32 4.26 1.94l-0.91 0.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m713.34 189.18c-0.53-0.57-0.85-0.62-0.95-0.61c-0.06 0-0.11 0.02-0.15 0.05l-1.01-0.74c0.18-0.24 0.57-0.53 1.09-0.56c0.61-0.04 1.28 0.3 1.94 1l-0.92 0.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m721.55 204.57c-0.39 0-0.64-0.03-0.67-0.04l0.16-1.24c0.01 0 1.07 0.13 2.16-0.23l0.39 1.19c-0.78 0.26-1.53 0.31-2.05 0.31z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m737.96 250.95l-29.12-16.81c-1.09-0.63-1.97-2.31-1.97-3.76c0-1.45 0.88-2.11 1.97-1.49l29.12 16.81c1.09 0.63 1.97 2.31 1.97 3.76c0 1.45-0.88 2.11-1.97 1.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m738.74 251.82c-0.35 0-0.72-0.11-1.09-0.32l-29.12-16.81c-1.28-0.74-2.28-2.63-2.28-4.3c0-0.99 0.36-1.77 0.99-2.13c0.56-0.32 1.24-0.28 1.91 0.1l29.12 16.81c1.28 0.74 2.28 2.63 2.28 4.3c0 0.99-0.36 1.77-0.99 2.13c-0.25 0.15-0.53 0.22-0.82 0.22zm-30.68-22.53c-0.07 0-0.13 0.01-0.19 0.05c-0.18 0.1-0.37 0.43-0.37 1.05c0 1.23 0.76 2.7 1.65 3.22l29.12 16.81c0.16 0.09 0.46 0.22 0.66 0.1c0.18-0.1 0.37-0.43 0.37-1.05c0-1.23-0.76-2.7-1.65-3.22l-29.12-16.81c-0.11-0.07-0.3-0.15-0.47-0.15z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m882.47 259.35l-74.73-46.49c-2.2-1.27-3.98-4.67-3.98-7.6l-3.08-114.69c0-2.93 4.87-4.73 7.06-3.46l77.45 44.72c2.2 1.27 3.98 4.67 3.98 7.6v115.14c0 2.93-4.51 6.04-6.7 4.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m883.67 260.46c-0.59 0-1.13-0.13-1.6-0.4l-0.02-0.01l-74.73-46.49c-2.44-1.4-4.36-5.05-4.36-8.29l-3.08-114.67c0-1.45 0.91-2.8 2.49-3.71c1.94-1.12 4.33-1.32 5.79-0.47l77.45 44.72c2.46 1.42 4.38 5.07 4.38 8.3v115.14c0 2.08-1.75 4.02-3.49 5.02c-0.99 0.57-1.96 0.86-2.83 0.86zm-0.78-1.8c0.62 0.35 1.69 0.17 2.8-0.47c1.58-0.91 2.67-2.39 2.67-3.61v-115.14c0-2.62-1.64-5.78-3.57-6.9l-77.45-44.72c-0.94-0.54-2.77-0.33-4.17 0.47c-0.5 0.29-1.67 1.1-1.67 2.28l3.08 114.67c0 2.64 1.64 5.8 3.57 6.92l74.74 46.49z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m882.02 259.13l-77.45-44.72c-2.2-1.27-3.98-4.67-3.98-7.6v-115.14c0-2.93 1.78-4.28 3.98-3.01l77.45 44.72c2.2 1.27 3.98 4.67 3.98 7.6v115.14c0 2.93-1.78 4.28-3.98 3.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m883.6 260.42c-0.64 0-1.31-0.2-1.99-0.59l-77.45-44.72c-2.46-1.42-4.38-5.07-4.38-8.31v-115.14c0-1.84 0.65-3.27 1.78-3.92c0.99-0.57 2.2-0.49 3.42 0.21l77.45 44.72c2.46 1.42 4.38 5.07 4.38 8.31v115.14c0 1.84-0.65 3.27-1.78 3.92c-0.44 0.25-0.92 0.38-1.43 0.38zm-1.18-2c0.49 0.28 1.2 0.55 1.79 0.21c0.61-0.35 0.97-1.29 0.97-2.51v-115.14c0-2.62-1.63-5.78-3.57-6.9l-77.45-44.72c-0.49-0.28-1.2-0.55-1.79-0.21c-0.61 0.35-0.97 1.29-0.97 2.51v115.14c0 2.62 1.63 5.78 3.57 6.9l77.45 44.72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m885.04 136.88l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m806.93 90.44l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m886.54 255.02l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m817.5 187l1.03 3.02c0.1 0.28 0.29 0.55 0.5 0.71l2.31 1.72c0.55 0.41 0.77 1.32 0.37 1.53l-1.67 0.92c-0.16 0.09-0.23 0.3-0.19 0.57l0.4 2.89c0.09 0.69-0.48 0.84-0.97 0.25l-2.07-2.45c-0.19-0.23-0.43-0.37-0.62-0.36l-2.07 0.06c-0.49 0.01-1.07-0.8-0.97-1.38l0.4-2.43c0.04-0.23-0.03-0.53-0.19-0.8l-1.67-2.85c-0.4-0.68-0.18-1.33 0.37-1.1l2.31 0.95c0.22 0.09 0.41 0.04 0.5-0.13l1.04-1.82c0.25-0.43 0.96-0.02 1.2 0.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m819.89 199.3c-0.28 0-0.59-0.17-0.85-0.47l-2.07-2.45c-0.15-0.17-0.29-0.25-0.37-0.25c0 0 0 0 0 0l-2.07 0.06c-0.01 0-0.02 0-0.02 0c-0.28 0-0.57-0.16-0.82-0.44c-0.33-0.38-0.51-0.89-0.44-1.3l0.4-2.43c0.03-0.15-0.04-0.39-0.15-0.59l-1.67-2.85c-0.31-0.52-0.33-1.08-0.06-1.4c0.2-0.23 0.5-0.28 0.81-0.15l2.32 0.95c0.09 0.04 0.11 0.01 0.11 0l1.03-1.82c0.14-0.24 0.37-0.36 0.64-0.33c0.45 0.04 0.93 0.5 1.13 1.08v0l1.03 3.02c0.08 0.22 0.23 0.44 0.4 0.56l2.31 1.72c0.44 0.33 0.73 0.93 0.7 1.43c-0.02 0.29-0.15 0.51-0.36 0.63l-1.67 0.92c-0.01 0.01-0.06 0.09-0.03 0.26l0.4 2.89c0.06 0.43-0.09 0.77-0.4 0.91c-0.09 0.04-0.18 0.06-0.28 0.06zm-3.29-3.8c0.29 0 0.6 0.17 0.85 0.47l2.07 2.45c0.2 0.23 0.36 0.26 0.39 0.25c0.02-0.01 0.06-0.08 0.03-0.26l-0.4-2.89c-0.06-0.41 0.08-0.74 0.35-0.89l1.67-0.92c0.02-0.01 0.04-0.05 0.04-0.12c0.02-0.25-0.15-0.66-0.45-0.89l-2.31-1.72c-0.27-0.2-0.49-0.52-0.61-0.86l-1.03-3.02c-0.11-0.33-0.34-0.55-0.51-0.63c-0.07-0.03-0.11-0.03-0.12-0.03l-1.05 1.84c-0.18 0.31-0.53 0.42-0.89 0.27l-2.32-0.95c-0.07-0.03-0.09-0.02-0.1-0.02c-0.05 0.03-0.1 0.3 0.12 0.68l1.67 2.85c0.2 0.33 0.28 0.7 0.23 1l-0.4 2.43c-0.04 0.22 0.09 0.55 0.29 0.78c0.15 0.17 0.3 0.25 0.36 0.23l2.07-0.06c0.01 0 0.01 0 0.02 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m830.7 194.62l1.03 3.02c0.1 0.28 0.29 0.55 0.5 0.71l2.31 1.72c0.55 0.41 0.77 1.31 0.37 1.53l-1.67 0.92c-0.16 0.09-0.23 0.3-0.19 0.57l0.4 2.89c0.09 0.69-0.48 0.84-0.97 0.25l-2.07-2.45c-0.19-0.23-0.43-0.37-0.62-0.36l-2.07 0.06c-0.49 0.01-1.07-0.8-0.97-1.38l0.4-2.43c0.04-0.23-0.03-0.53-0.19-0.8l-1.67-2.85c-0.4-0.68-0.18-1.33 0.37-1.1l2.31 0.95c0.22 0.09 0.41 0.04 0.5-0.13l1.03-1.82c0.25-0.43 0.96-0.02 1.2 0.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m833.09 206.92c-0.28 0-0.59-0.17-0.85-0.47l-2.07-2.45c-0.15-0.17-0.27-0.25-0.37-0.25l-2.07 0.06c-0.01 0-0.02 0-0.02 0c-0.28 0-0.57-0.16-0.83-0.44c-0.33-0.38-0.51-0.89-0.44-1.3l0.4-2.43c0.03-0.15-0.04-0.39-0.15-0.59l-1.67-2.85c-0.31-0.52-0.33-1.08-0.06-1.4c0.19-0.23 0.5-0.28 0.81-0.15l2.31 0.95c0.09 0.04 0.11 0.01 0.11 0l1.03-1.82c0.14-0.24 0.36-0.36 0.64-0.33c0.46 0.04 0.93 0.5 1.13 1.08l1.03 3.02c0.08 0.22 0.23 0.44 0.4 0.57l2.31 1.72c0.44 0.33 0.73 0.93 0.7 1.43c-0.02 0.29-0.15 0.51-0.36 0.63l-1.67 0.92c-0.01 0.01-0.06 0.09-0.03 0.26l0.4 2.89c0.06 0.43-0.09 0.77-0.4 0.91c-0.09 0.04-0.18 0.06-0.28 0.06zm-3.29-3.8c0.29 0 0.6 0.17 0.85 0.47l2.07 2.45c0.2 0.23 0.36 0.26 0.39 0.25c0.02-0.01 0.06-0.08 0.03-0.26l-0.4-2.89c-0.05-0.41 0.08-0.74 0.35-0.89l1.67-0.92c0.02-0.01 0.04-0.05 0.04-0.12c0.02-0.25-0.15-0.66-0.45-0.89l-2.31-1.72c-0.27-0.2-0.5-0.52-0.61-0.86l-1.03-3.02c-0.11-0.33-0.33-0.55-0.51-0.63c-0.07-0.03-0.11-0.03-0.12-0.03l-1.05 1.84c-0.18 0.31-0.53 0.41-0.89 0.27l-2.31-0.95c-0.06-0.03-0.1-0.02-0.1-0.02c-0.05 0.03-0.1 0.3 0.12 0.68l1.67 2.85c0.2 0.33 0.28 0.7 0.23 1l-0.4 2.43c-0.04 0.22 0.09 0.55 0.29 0.78c0.15 0.17 0.29 0.22 0.36 0.23l2.07-0.06c0.01 0 0.01 0 0.02 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m843.89 202.24l1.03 3.02c0.1 0.28 0.29 0.55 0.5 0.71l2.31 1.72c0.55 0.41 0.77 1.32 0.37 1.53l-1.67 0.92c-0.16 0.09-0.23 0.3-0.19 0.57l0.4 2.89c0.09 0.69-0.48 0.84-0.97 0.25l-2.07-2.45c-0.2-0.23-0.43-0.37-0.62-0.36l-2.07 0.06c-0.49 0.01-1.07-0.8-0.97-1.38l0.4-2.43c0.04-0.23-0.03-0.53-0.19-0.8l-1.67-2.85c-0.4-0.68-0.18-1.33 0.37-1.1l2.31 0.95c0.22 0.09 0.41 0.04 0.5-0.13l1.04-1.82c0.25-0.43 0.96-0.02 1.2 0.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m846.28 214.54c-0.28 0-0.59-0.17-0.85-0.47l-2.07-2.45c-0.15-0.17-0.29-0.25-0.37-0.25l-2.07 0.06c-0.29 0-0.59-0.15-0.85-0.44c-0.33-0.38-0.51-0.89-0.44-1.3l0.4-2.43c0.03-0.16-0.03-0.39-0.15-0.59l-1.68-2.85c-0.31-0.52-0.33-1.09-0.05-1.4c0.19-0.22 0.5-0.28 0.81-0.15l2.31 0.95c0.09 0.04 0.11 0.01 0.11 0l1.04-1.82c0.14-0.24 0.38-0.36 0.64-0.33c0.46 0.04 0.93 0.5 1.13 1.08l1.04 3.02c0.08 0.22 0.23 0.44 0.39 0.57l2.32 1.72c0.44 0.33 0.73 0.93 0.7 1.43c-0.02 0.29-0.15 0.51-0.36 0.63l-1.68 0.92c-0.01 0.01-0.06 0.09-0.03 0.26l0.4 2.89c0.06 0.43-0.09 0.78-0.4 0.91c-0.09 0.04-0.18 0.06-0.28 0.06zm-3.29-3.8c0.29 0 0.6 0.17 0.85 0.47l2.07 2.45c0.19 0.23 0.35 0.26 0.39 0.25c0.02-0.01 0.06-0.08 0.03-0.26l-0.4-2.89c-0.05-0.41 0.08-0.74 0.35-0.89l1.68-0.92c0.01-0.01 0.03-0.05 0.04-0.12c0.02-0.25-0.15-0.66-0.45-0.89l-2.32-1.72c-0.27-0.2-0.5-0.52-0.61-0.87l-1.04-3.02c-0.11-0.33-0.33-0.55-0.5-0.63c-0.07-0.03-0.11-0.03-0.12-0.03l-1.05 1.84c-0.18 0.31-0.53 0.41-0.89 0.27l-2.31-0.95c-0.06-0.03-0.1-0.02-0.1-0.02c-0.05 0.03-0.1 0.3 0.12 0.68l1.67 2.85c0.2 0.33 0.28 0.7 0.23 1l-0.4 2.43c-0.04 0.22 0.09 0.55 0.3 0.78c0.15 0.17 0.28 0.22 0.36 0.23l2.07-0.06c0.01 0 0.02 0 0.02 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m857.09 209.85l1.03 3.02c0.1 0.28 0.29 0.55 0.5 0.71l2.31 1.72c0.55 0.41 0.77 1.31 0.37 1.53l-1.67 0.92c-0.16 0.09-0.23 0.3-0.19 0.57l0.4 2.89c0.09 0.69-0.48 0.84-0.97 0.25l-2.07-2.45c-0.2-0.23-0.43-0.37-0.62-0.36l-2.07 0.06c-0.49 0.01-1.07-0.8-0.97-1.38l0.4-2.43c0.04-0.23-0.03-0.53-0.19-0.8l-1.67-2.85c-0.4-0.68-0.18-1.33 0.37-1.1l2.31 0.95c0.22 0.09 0.41 0.04 0.5-0.13l1.03-1.82c0.25-0.43 0.96-0.02 1.2 0.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m859.47 222.15c-0.28 0-0.59-0.17-0.85-0.47l-2.07-2.45c-0.15-0.17-0.31-0.25-0.38-0.25l-2.07 0.06c-0.01 0-0.02 0-0.02 0c-0.28 0-0.57-0.16-0.82-0.44c-0.33-0.38-0.51-0.89-0.44-1.3l0.39-2.43c0.03-0.16-0.03-0.38-0.15-0.59l-1.68-2.85c-0.31-0.52-0.33-1.09-0.05-1.4c0.19-0.22 0.5-0.28 0.81-0.15l2.31 0.95c0.1 0.04 0.11 0.01 0.11 0l1.04-1.82c0.14-0.24 0.37-0.36 0.64-0.33c0.46 0.04 0.93 0.5 1.13 1.08l1.04 3.02c0.08 0.22 0.23 0.44 0.4 0.57l2.31 1.72c0.44 0.33 0.73 0.93 0.7 1.43c-0.02 0.29-0.15 0.51-0.36 0.63l-1.68 0.92c-0.01 0.01-0.06 0.09-0.03 0.26l0.39 2.89c0.06 0.43-0.09 0.77-0.4 0.91c-0.09 0.04-0.18 0.06-0.28 0.06zm-3.29-3.8c0.29 0 0.59 0.17 0.85 0.47l2.07 2.45c0.19 0.23 0.36 0.27 0.39 0.25c0.02-0.01 0.06-0.08 0.03-0.26l-0.39-2.89c-0.06-0.4 0.08-0.74 0.35-0.89l1.68-0.92c0.01-0.01 0.03-0.05 0.04-0.12c0.02-0.25-0.15-0.66-0.45-0.89l-2.31-1.72c-0.27-0.2-0.49-0.52-0.61-0.86l-1.04-3.02c-0.11-0.33-0.33-0.55-0.5-0.63c-0.07-0.03-0.11-0.03-0.12-0.03l-1.05 1.84c-0.18 0.31-0.52 0.42-0.89 0.27l-2.31-0.95c-0.06-0.03-0.1-0.02-0.1-0.02c-0.05 0.03-0.1 0.3 0.12 0.68l1.68 2.85c0.2 0.34 0.28 0.7 0.23 1l-0.39 2.43c-0.04 0.22 0.09 0.55 0.29 0.78c0.15 0.17 0.31 0.24 0.36 0.23l2.07-0.06c0.01 0 0.02 0 0.02 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m870.28 217.47l1.03 3.02c0.1 0.28 0.29 0.55 0.5 0.71l2.31 1.72c0.55 0.41 0.77 1.32 0.37 1.53l-1.67 0.92c-0.16 0.09-0.23 0.3-0.19 0.57l0.4 2.89c0.09 0.69-0.48 0.84-0.97 0.25l-2.07-2.45c-0.2-0.23-0.43-0.37-0.62-0.36l-2.07 0.06c-0.49 0.01-1.07-0.8-0.97-1.38l0.4-2.43c0.04-0.23-0.03-0.53-0.19-0.8l-1.67-2.85c-0.4-0.68-0.18-1.33 0.37-1.1l2.31 0.95c0.22 0.09 0.41 0.04 0.5-0.13l1.03-1.82c0.25-0.43 0.96-0.02 1.2 0.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m872.67 229.77c-0.28 0-0.59-0.17-0.85-0.47l-2.07-2.45c-0.15-0.17-0.33-0.25-0.37-0.25l-2.07 0.06c-0.32 0.01-0.59-0.15-0.85-0.44c-0.33-0.38-0.51-0.89-0.44-1.3l0.4-2.43c0.03-0.15-0.04-0.39-0.15-0.59l-1.67-2.85c-0.31-0.52-0.33-1.08-0.06-1.4c0.19-0.22 0.5-0.28 0.81-0.15l2.32 0.95c0.1 0.04 0.11 0.01 0.11 0l1.03-1.82c0.14-0.24 0.37-0.36 0.64-0.33c0.45 0.04 0.93 0.5 1.13 1.08v0l1.03 3.02c0.08 0.22 0.23 0.44 0.4 0.56l2.31 1.72c0.44 0.33 0.73 0.93 0.7 1.43c-0.02 0.29-0.15 0.51-0.36 0.63l-1.67 0.92c-0.01 0.01-0.06 0.09-0.03 0.26l0.4 2.89c0.06 0.43-0.09 0.77-0.4 0.91c-0.09 0.04-0.18 0.06-0.28 0.06zm-3.29-3.8c0.29 0 0.6 0.17 0.85 0.47l2.07 2.45c0.2 0.23 0.36 0.26 0.39 0.25c0.02-0.01 0.06-0.08 0.03-0.26l-0.4-2.89c-0.06-0.41 0.08-0.74 0.35-0.89l1.67-0.92c0.02-0.01 0.04-0.05 0.04-0.12c0.02-0.25-0.15-0.66-0.45-0.89l-2.31-1.72c-0.27-0.2-0.49-0.52-0.61-0.86l-1.03-3.02c-0.11-0.33-0.34-0.55-0.51-0.63c-0.07-0.03-0.11-0.03-0.12-0.03l-1.05 1.84c-0.18 0.31-0.53 0.41-0.89 0.27l-2.32-0.95c-0.06-0.02-0.1-0.02-0.1-0.02c-0.05 0.03-0.1 0.3 0.12 0.68l1.67 2.85c0.2 0.33 0.28 0.7 0.23 1l-0.4 2.43c-0.04 0.22 0.09 0.55 0.29 0.78c0.15 0.17 0.3 0.22 0.36 0.23l2.07-0.06c0.01 0 0.01 0 0.02 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m857.85 233.91l-29.12-16.81c-1.09-0.63-1.97-2.31-1.97-3.76c0-1.45 0.88-2.11 1.97-1.49l29.12 16.81c1.09 0.63 1.97 2.31 1.97 3.76c0 1.45-0.88 2.11-1.97 1.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m858.63 234.77c-0.35 0-0.72-0.11-1.09-0.32l-29.12-16.81c-1.28-0.74-2.28-2.63-2.28-4.3c0-0.99 0.36-1.77 0.99-2.13c0.56-0.32 1.24-0.28 1.91 0.1l29.12 16.81c1.28 0.74 2.28 2.63 2.28 4.3c0 0.99-0.36 1.77-0.99 2.13c-0.25 0.15-0.53 0.22-0.82 0.22zm-30.68-22.53c-0.07 0-0.14 0.01-0.2 0.05c-0.18 0.1-0.37 0.43-0.37 1.05c0 1.23 0.76 2.7 1.65 3.22l29.12 16.81c0.16 0.09 0.45 0.22 0.66 0.1c0.18-0.1 0.37-0.43 0.37-1.05c0-1.23-0.76-2.7-1.65-3.22l-29.12-16.81c-0.11-0.07-0.3-0.15-0.47-0.15z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m812.21 165.59v-52.65c0-5.28 3.21-7.71 7.17-5.42l47.81 27.6c3.96 2.29 7.18 8.43 7.18 13.71v52.65c0 5.28-3.21 7.71-7.18 5.42l-47.81-27.6c-3.96-2.29-7.17-8.43-7.17-13.71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m870.05 208.39c-1 0-2.08-0.32-3.17-0.94l-47.81-27.6c-4.13-2.38-7.49-8.78-7.49-14.25v-52.65c0-3.01 1.02-5.32 2.79-6.34c1.51-0.87 3.39-0.73 5.32 0.38l47.81 27.6c4.13 2.38 7.49 8.78 7.49 14.25v52.65c0 3.01-1.02 5.32-2.79 6.34c-0.65 0.38-1.38 0.57-2.16 0.57zm-50.35-29.63l47.81 27.6c1.53 0.88 2.97 1.01 4.07 0.38c1.38-0.8 2.17-2.71 2.17-5.26v-52.65c0-5.08-3.08-10.98-6.86-13.17l-47.81-27.6c-1.52-0.88-2.97-1.01-4.07-0.38c-1.38 0.8-2.17 2.71-2.17 5.26v52.65c0 5.08 3.08 10.98 6.86 13.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m868.15 203.3c-0.62 0-1.28-0.19-1.94-0.58l-46.46-26.83c-2.47-1.43-4.41-5.1-4.41-8.37v-52.19c0-1.82 0.63-3.22 1.73-3.85c0.94-0.55 2.12-0.47 3.31 0.22l46.46 26.82c2.47 1.43 4.41 5.1 4.41 8.37v52.19c0 1.82-0.63 3.22-1.73 3.85c-0.42 0.24-0.88 0.36-1.36 0.36zm-49.72-90.92c-0.25 0-0.5 0.06-0.74 0.19c-0.7 0.4-1.1 1.41-1.1 2.77v52.19c0 2.81 1.7 6.08 3.78 7.28l46.46 26.83c0.55 0.32 1.36 0.62 2.06 0.22c0.7-0.4 1.1-1.41 1.1-2.77v-52.19c0-2.81-1.7-6.08-3.78-7.29l-46.46-26.82c-0.36-0.21-0.84-0.41-1.31-0.41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m846.75 175.37c7.14 1.89 13.05 10.44 17.74 25.64l-44.12-25.47c-1.05-11.69 3.96-14.23 15.04-7.63l9.65 6.7l1.69 0.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m865.55 202.34l-45.78-26.43l-0.03-0.32c-0.03-0.31-0.64-7.71 3.64-10.4c2.8-1.77 6.96-1.03 12.35 2.18l9.69 6.72l1.55 0.69c0.93 0.27 11.24 3.75 18.12 26.05l0.47 1.52zm-44.59-27.19l42.43 24.5c-6.85-20.82-16.71-23.66-16.81-23.69l-0.1-0.04l-1.69-0.77l-9.75-6.75c-4.92-2.93-8.63-3.67-11-2.17c-3.18 2-3.14 7.53-3.07 8.92z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m835.93 152.97c-0.68-4.55 3-7.41 6.82-9.13c4.75-2.14 12.41 5.51 13.23 13.26c0.28 2.61 0.15 5.07-0.41 7.21c-0.84 3.17-2.3 6.21-4.81 8.19c-1.57-0.35-3.23-1.31-4.97-2.87c-0.3 2.96 0.12 5.78 1.27 8.46c0.12 2.72-1.63 3.26-5.24 1.62c-3.62-1.64-6.18-5.01-7.69-10.13c2.11-5.05 2.71-10.58 1.81-16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m844.75 181.11c-0.9 0-1.96-0.28-3.2-0.84c-5.62-2.54-7.93-10.2-8.03-10.52l-0.06-0.21l0.09-0.21c0.03-0.07 3.08-7.53 1.77-16.27c-0.6-4.02 1.88-7.41 7.18-9.79c1.67-0.75 3.68-0.5 5.81 0.73c3.66 2.1 7.68 7.25 8.3 13.03c0.29 2.75 0.15 5.25-0.43 7.43c-1.01 3.82-2.7 6.69-5.03 8.52l-0.23 0.18l-0.29-0.06c-0.09-0.02-1.97-0.45-4.26-2.2c-0.01 1.56 0.17 4.35 1.27 6.93l0.05 0.22c0 0.07 0.06 1.72-1.21 2.58c-0.47 0.32-1.04 0.48-1.71 0.48zm-9.97-11.52c0.4 1.2 2.66 7.45 7.28 9.54c1.72 0.78 2.99 0.94 3.69 0.47c0.57-0.38 0.65-1.13 0.67-1.4c-1.7-4.09-1.28-8.46-1.26-8.64l0.12-1.22l0.91 0.82c1.94 1.74 3.74 2.43 4.41 2.65c1.98-1.67 3.44-4.24 4.35-7.66c0.54-2.03 0.67-4.38 0.4-6.98c-0.56-5.31-4.37-10.19-7.68-12.08c-1.24-0.71-3.06-1.4-4.68-0.67c-4.8 2.16-6.98 5.01-6.46 8.47c1.26 8.36-1.24 15.39-1.76 16.72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m852.56 167.67l-0.81-0.25c-0.08-0.02-1.97-0.63-2.81-2.45l1.14-0.53c0.3 0.65 0.8 1.1 1.23 1.37v-3.63h1.25v5.48z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m845.34 170.06c-0.05-0.05-1.32-1.35-2.65-3.34l1.04-0.7c1.27 1.89 2.5 3.15 2.51 3.16l-0.89 0.88z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m848.92 158.8c0 1.03-0.43 1.61-0.96 1.31c-0.53-0.31-0.96-1.39-0.96-2.42c0-1.03 0.43-1.61 0.96-1.31c0.53 0.31 0.96 1.39 0.96 2.42z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m855.49 162.6c0 1.03-0.43 1.61-0.96 1.31c-0.53-0.31-0.96-1.39-0.96-2.42c0-1.03 0.43-1.61 0.96-1.31c0.53 0.31 0.96 1.39 0.96 2.42z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m839.5 182.01c-0.4-0.34-0.78-0.68-1.15-1.02l0.84-0.92c0.36 0.33 0.73 0.66 1.12 0.98l-0.81 0.95zm-2.08-1.89c-0.63-0.61-1.22-1.22-1.77-1.83l0.93-0.84c0.53 0.59 1.1 1.18 1.71 1.77l-0.87 0.9zm-2.61-2.78c-0.57-0.67-1.1-1.34-1.58-1.99l1-0.75c0.47 0.63 0.98 1.27 1.53 1.92l-0.95 0.81zm-2.33-3.02c-0.48-0.69-0.95-1.41-1.38-2.14l1.07-0.64c0.42 0.7 0.87 1.4 1.33 2.06l-1.03 0.71zm-2.02-3.24c-0.42-0.75-0.8-1.52-1.15-2.27l1.14-0.52c0.33 0.73 0.71 1.47 1.11 2.19l-1.09 0.6zm-1.66-3.45c-0.61-1.5-0.84-2.41-0.85-2.45l1.21-0.3c0 0.01 0.22 0.88 0.79 2.28l-1.16 0.47z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m842.06 152.37c-1.31-2.9-2.55-4.18-3.71-3.83c-0.87 0.26-0.99 1.56-0.88 2.81c0.18 2.08-0.07 3.93-0.6 5.51l-0.65 1.95c-1.68-1.6-2.7-4.15-2.4-5.99c0.1-0.62 0.01-1.37-0.25-2.14c-0.76-2.25-2.17-7.46-0.72-12.09c1.9-6.09 11.2-3.59 16.92 2.33c3.81 3.95 6.03 3.85 6.65-0.3c2.99 4.14 4.37 8.12 4.12 11.92c-0.24 3.81-1.79 5.14-4.62 4c-4.77-5.21-9.38-6.6-13.86-4.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m836.49 159.94l-0.71-0.68c-1.84-1.75-2.92-4.5-2.59-6.54c0.08-0.51 0-1.16-0.22-1.84c-0.72-2.14-2.24-7.62-0.73-12.47c0.62-1.98 2.01-3.28 4.01-3.76c3.93-0.93 9.8 1.52 13.96 5.84c1.72 1.78 3.2 2.6 4.13 2.3c0.95-0.3 1.37-1.74 1.45-2.27l0.23-1.5l0.89 1.23c0.19 0.26 4.62 6.46 4.24 12.33c-0.14 2.11-0.8 3.56-1.97 4.3c-1.58 0.99-3.43 0.27-3.51 0.24l-0.23-0.16c-6.74-7.37-13.03-4.07-13.1-4.04l-0.59 0.32l-0.28-0.61c-0.73-1.61-2.15-3.72-2.97-3.49c-0.37 0.11-0.54 0.93-0.43 2.15c0.18 2.05-0.04 3.99-0.63 5.77l-0.96 2.88zm1.53-24.23c-0.53 0-1.03 0.05-1.49 0.16c-1.57 0.37-2.61 1.35-3.1 2.91c-1.41 4.5 0.03 9.68 0.72 11.7c0.3 0.88 0.39 1.73 0.27 2.44c-0.23 1.38 0.41 3.25 1.53 4.67l0.31-0.94c0.54-1.62 0.73-3.39 0.57-5.26c-0.17-1.99 0.28-3.15 1.33-3.46c1.84-0.54 3.51 2.27 4.19 3.63c1.87-0.7 7.79-2.16 13.9 4.44c0.35 0.11 1.41 0.36 2.26-0.18c0.81-0.52 1.27-1.63 1.38-3.32c0.26-4.04-2.08-8.43-3.3-10.42c-0.33 0.75-0.91 1.59-1.89 1.9c-1.47 0.47-3.28-0.42-5.41-2.62c-3.3-3.42-7.87-5.65-11.28-5.65z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m849.73 169.64c-0.05-0.02-1.34-0.6-2.04-1.9l1.1-0.59c0.49 0.91 1.43 1.34 1.44 1.35l-0.51 1.14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m839.64 157.26c-0.09-0.04-2.22-1.08-2.75-4.96l1.24-0.17c0.43 3.15 1.98 3.97 2.04 4l-0.54 1.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m838.14 153.04l-1.25-0.01c0.01-0.99 0.31-1.64 0.9-1.92c1.01-0.48 2.26 0.43 2.5 0.62l-0.77 0.99c-0.42-0.33-1.01-0.56-1.19-0.48c-0.07 0.03-0.19 0.24-0.2 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m858.01 150.88c-0.6 0-1.31-0.17-2.13-0.52c-5.51-2.33-15.59-11.97-16.01-12.38l0.87-0.9c0.1 0.1 10.33 9.89 15.63 12.13c1.12 0.47 1.93 0.55 2.28 0.22c0.63-0.61 0.22-2.72-0.27-4.02l1.17-0.45c0.15 0.4 1.45 3.95-0.02 5.37c-0.38 0.37-0.88 0.55-1.5 0.55z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m833.17 151.68c-0.45-4.96 0.17-8.03 1.83-9.15c1.33-0.89 2.74-0.17 2.8-0.13l-0.58 1.11l0.29-0.55l-0.29 0.56c-0.03-0.02-0.83-0.41-1.54 0.07c-0.7 0.48-1.8 2.15-1.27 7.99l-1.25 0.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m846.43 185.22l-0.08-1.25c0.41-0.03 0.8-0.08 1.17-0.16l0.27 1.22c-0.44 0.1-0.9 0.16-1.37 0.19zm2.66-0.59l-0.48-1.16c0.7-0.29 1.34-0.7 1.89-1.23l0.86 0.9c-0.66 0.64-1.43 1.13-2.28 1.48zm3.17-2.51l-1.01-0.74c0.76-1.04 1.01-2.01 1.01-2.02l1.21 0.3c-0.01 0.05-0.31 1.21-1.21 2.45z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m740.6 135.4l-34.06-23.15c-2.2-1.27-3.98-4.67-3.98-7.6l-3.04-39.05c0-2.93 4.87-4.73 7.06-3.46l36.78 21.38c2.2 1.27 3.98 4.67 3.98 7.6l-0.05 39.5c0 2.93-4.51 6.04-6.7 4.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m741.79 136.5c-0.59 0-1.13-0.13-1.6-0.4l-0.05-0.03l-34.06-23.15c-2.41-1.39-4.33-5.04-4.33-8.27l-3.03-38.99c0-1.5 0.9-2.84 2.49-3.75c1.95-1.12 4.33-1.32 5.79-0.47l36.78 21.38c2.46 1.42 4.38 5.07 4.38 8.3l-0.05 39.5c0 2.08-1.75 4.02-3.49 5.02c-0.99 0.57-1.97 0.86-2.84 0.86zm-0.76-1.8c0.62 0.34 1.69 0.16 2.79-0.47c1.58-0.91 2.67-2.4 2.67-3.61l0.05-39.5c0-2.62-1.64-5.78-3.57-6.9l-36.78-21.38c-0.94-0.54-2.77-0.33-4.17 0.47c-0.5 0.29-1.68 1.1-1.68 2.28l3.03 38.99c0 2.68 1.64 5.84 3.57 6.96l34.08 23.16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m740.15 135.17l-36.78-21.38c-2.2-1.27-3.98-4.67-3.98-7.6l0.05-39.5c0-2.93 1.78-4.28 3.98-3.01l36.78 21.38c2.2 1.27 3.98 4.67 3.98 7.6l-0.05 39.5c0 2.93-1.78 4.28-3.98 3.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m741.73 136.46c-0.64 0-1.31-0.2-1.99-0.59l0 0l-36.78-21.38c-2.46-1.42-4.38-5.07-4.38-8.3l0.05-39.5c0-1.84 0.65-3.27 1.78-3.92c0.99-0.57 2.2-0.49 3.42 0.21l36.78 21.38c2.46 1.42 4.38 5.06 4.38 8.3l-0.05 39.5c0 1.84-0.65 3.27-1.78 3.92c-0.44 0.25-0.92 0.38-1.43 0.38zm-1.18-2c0.49 0.28 1.21 0.55 1.79 0.21c0.61-0.35 0.97-1.29 0.97-2.51l0.05-39.5c0-2.62-1.63-5.78-3.57-6.9l-36.78-21.38c-0.49-0.28-1.2-0.55-1.79-0.21c-0.61 0.35-0.97 1.29-0.97 2.51l-0.05 39.5c0 2.62 1.64 5.78 3.57 6.9l36.78 21.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m743.22 88.57l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m705.78 65.47l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m744.67 131.06l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m748.23 108.03h-0.94v-5.78h0.94v5.78z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m730.5 115.77l-17.45-10.07c-0.84-0.49-1.53-1.79-1.53-2.92v-19.6c0-1.12 0.68-1.64 1.53-1.15l17.45 10.07c0.84 0.49 1.53 1.79 1.53 2.92v19.6c0 1.12-0.68 1.64-1.53 1.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m731.11 116.58c-0.3 0-0.62-0.09-0.92-0.27l-17.44-10.07c-1.03-0.6-1.84-2.11-1.84-3.46v-19.6c0-0.82 0.31-1.47 0.84-1.78c0.47-0.27 1.06-0.24 1.62 0.08l17.44 10.07c1.03 0.6 1.84 2.11 1.84 3.46v19.6c0 0.82-0.31 1.47-0.84 1.78c-0.22 0.12-0.45 0.19-0.7 0.19zm-18.66-34.1c-0.03 0-0.06 0.01-0.08 0.02c-0.08 0.05-0.22 0.24-0.22 0.69v19.6c0 0.89 0.57 2 1.21 2.37l17.44 10.07c0.16 0.09 0.3 0.12 0.37 0.08c0.08-0.05 0.21-0.24 0.21-0.69v-19.6c0-0.89-0.57-2-1.21-2.37l-17.44-10.07c-0.11-0.07-0.22-0.1-0.29-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m723.1 93.41l-1.36 5.74c0 0 0 0 0 0v-6.72c0 0 0 0 0 0c0.47 0.27 0.92 0.6 1.36 0.98l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m721.74 99.61h-0.47l0-7.48l0.47-0.23l0.21 0.1c0.51 0.29 0.99 0.64 1.45 1.04l0.13 0.18l0.05 0.14l-1.48 6.24l-0.37 0zm0.47-6.32v1.85l0.37-1.56c-0.12-0.1-0.25-0.19-0.37-0.29z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m721.74 99.15l1.36-5.75l0 0c1.08 0.93 2.03 2.16 2.76 3.5c0 0 0 0 0 0l-4.12 2.25c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m721.73 99.69l-0.46-0.28l0-0.27l1.46-6.22h0.55l0.13 0.11c1.1 0.96 2.09 2.21 2.86 3.62l0.17 0.31l-0.35 0.33l-4.36 2.38zm1.64-5.4l-0.93 3.94l2.78-1.52c-0.54-0.91-1.17-1.73-1.85-2.42z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m721.74 99.15l4.12-2.25c0 0 0 0 0 0c0.94 1.73 1.5 3.64 1.46 5.36c0 0 0 0 0 0l-5.58-3.1c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m727.77 103.04l-6.5-3.69l0-0.48l4.77-2.61l0.22 0.41c1.02 1.87 1.56 3.86 1.52 5.59l-0.02 0.78zm-5.06-3.89l4.12 2.29c-0.1-1.24-0.5-2.59-1.16-3.91l-2.96 1.62z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m724.24 106.57c-0.85 0-1.78-0.28-2.73-0.83c-1.07-0.62-2.11-1.55-3.01-2.7l-0.13-0.16l0.05-0.33l3.2-3.99l6.17 3.43l0 0.28c-0.04 1.84-0.72 3.21-1.9 3.87c-0.5 0.28-1.06 0.42-1.66 0.42zm-4.77-3.82c0.79 0.94 1.64 1.68 2.51 2.18c1.33 0.77 2.56 0.91 3.46 0.4c0.83-0.47 1.32-1.45 1.41-2.79l-4.98-2.77l-2.39 2.98z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m718.86 102.74c-1.62-2.06-2.71-4.74-2.71-7.09c0-3.56 2.5-5.01 5.59-3.23c0 0 0 0 0 0v6.73l0 0l-2.88 3.58c0 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m718.75 103.29l-0.22-0.22c-1.79-2.28-2.84-5.04-2.84-7.42c0-1.9 0.66-3.33 1.87-4.02c1.21-0.7 2.78-0.56 4.42 0.39l0.23 0.14l0 7.17l-3.17 3.85l-0.29 0.12zm0.49-11.16c-0.45 0-0.86 0.1-1.22 0.31c-0.9 0.52-1.4 1.66-1.4 3.21c0 1.98 0.85 4.36 2.25 6.33l2.4-2.98v-6.29c-0.73-0.38-1.41-0.57-2.03-0.57z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m984.63 387.44l-34.06-23.15c-2.2-1.27-3.98-4.67-3.98-7.6l-3.04-39.05c0-2.93 4.87-4.73 7.06-3.46l36.78 21.38c2.2 1.27 3.98 4.67 3.98 7.6l-0.05 39.5c0 2.93-4.51 6.04-6.7 4.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m985.82 388.55c-0.59 0-1.13-0.13-1.6-0.4l-0.05-0.03l-34.06-23.15c-2.41-1.39-4.33-5.03-4.33-8.27l-3.03-38.98c0-1.5 0.9-2.84 2.49-3.75c1.95-1.12 4.33-1.32 5.79-0.47l36.78 21.38c2.46 1.42 4.38 5.07 4.38 8.3l-0.05 39.5c0 2.07-1.75 4.01-3.49 5.02c-0.99 0.57-1.97 0.86-2.84 0.86zm-0.76-1.8c0.62 0.34 1.69 0.16 2.79-0.47c1.57-0.91 2.67-2.39 2.67-3.61l0.05-39.5c0-2.62-1.63-5.78-3.57-6.9l-36.78-21.38c-0.94-0.54-2.77-0.33-4.17 0.47c-0.5 0.29-1.68 1.1-1.68 2.28l3.03 38.98c0 2.69 1.64 5.84 3.57 6.96l34.08 23.16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m984.17 387.21l-36.78-21.38c-2.2-1.27-3.98-4.67-3.98-7.6l0.05-39.5c0-2.93 1.78-4.28 3.98-3.01l36.78 21.38c2.2 1.27 3.98 4.67 3.98 7.6l-0.05 39.5c0 2.93-1.78 4.28-3.98 3.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m985.75 388.51c-0.63 0-1.31-0.2-1.99-0.59l0 0l-36.78-21.38c-2.46-1.42-4.38-5.06-4.38-8.3l0.05-39.5c0-1.84 0.65-3.27 1.78-3.92c0.99-0.57 2.2-0.49 3.42 0.21l36.78 21.38c2.46 1.42 4.38 5.07 4.38 8.3l-0.05 39.5c0 1.84-0.65 3.27-1.78 3.92c-0.44 0.25-0.92 0.38-1.43 0.38zm-1.17-1.99c0.49 0.28 1.2 0.55 1.79 0.21c0.61-0.35 0.97-1.29 0.97-2.51l0.05-39.5c0-2.62-1.63-5.78-3.57-6.9l-36.78-21.38c-0.49-0.28-1.2-0.55-1.79-0.21c-0.61 0.35-0.97 1.29-0.97 2.51l-0.05 39.5c0 2.62 1.63 5.78 3.57 6.9l36.78 21.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m987.24 340.61l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m949.8 317.51l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m988.69 383.1l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m972.43 327.4l-13.36-7.77l0.47-0.81l13.36 7.77l-0.47 0.81z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m974.53 368.34l-17.44-10.07c-0.84-0.49-1.53-1.79-1.53-2.92v-19.6c0-1.12 0.68-1.64 1.53-1.15l17.44 10.07c0.84 0.49 1.53 1.79 1.53 2.92v19.6c0 1.12-0.68 1.64-1.53 1.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m975.13 369.15c-0.3 0-0.61-0.09-0.92-0.26v0l-17.44-10.07c-1.03-0.59-1.84-2.11-1.84-3.46v-19.6c0-0.82 0.31-1.47 0.84-1.78c0.47-0.27 1.06-0.24 1.62 0.08l17.44 10.07c1.03 0.6 1.84 2.11 1.84 3.46v19.6c0 0.82-0.31 1.47-0.84 1.78c-0.21 0.12-0.45 0.19-0.7 0.19zm-0.3-1.35c0.16 0.09 0.3 0.12 0.37 0.08c0.08-0.05 0.22-0.24 0.22-0.69v-19.6c0-0.89-0.57-2-1.21-2.37l-17.44-10.07c-0.16-0.09-0.3-0.12-0.37-0.08c-0.08 0.05-0.22 0.24-0.22 0.69v19.6c0 0.89 0.57 2 1.21 2.38l17.44 10.07z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m971.43 354.54c0 2.56-1.8 3.6-4.02 2.32l-1.06-0.61c-0.04 1.3-0.76 1.55-2.17 0.74v-1.99c-2.22-1.28-4.02-4.4-4.02-6.96c0-2.56 1.8-3.6 4.02-2.32l3.22 1.86c2.22 1.28 4.02 4.4 4.02 6.96z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m969.21 357.88c-0.63 0-1.32-0.21-2.03-0.61l-0.49-0.28c-0.14 0.36-0.36 0.56-0.56 0.67c-0.84 0.47-2.04-0.18-2.17-0.26l-0.24-0.14v-2c-2.24-1.43-4.02-4.61-4.02-7.22c0-1.41 0.5-2.48 1.41-3.01c0.91-0.52 2.08-0.42 3.31 0.28l3.22 1.86c2.34 1.35 4.25 4.66 4.25 7.36c0 1.41-0.5 2.48-1.41 3.01c-0.38 0.22-0.82 0.33-1.28 0.33zm-3.3-2.43l1.74 1c0.92 0.53 1.76 0.63 2.37 0.28c0.61-0.35 0.94-1.13 0.94-2.19c0-2.41-1.7-5.35-3.78-6.55l-3.22-1.86c-0.92-0.53-1.76-0.63-2.37-0.28c-0.61 0.35-0.94 1.13-0.94 2.19c0 2.41 1.7 5.35 3.78 6.55l0.23 0.14v1.97c0.35 0.15 0.8 0.26 1.01 0.14c0.17-0.09 0.21-0.38 0.21-0.6l0.02-0.79z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m779.96 358.43l-34.06-23.15c-2.2-1.27-3.98-4.67-3.98-7.6l-3.04-39.05c0-2.93 4.87-4.73 7.06-3.46l36.78 21.38c2.2 1.27 3.98 4.67 3.98 7.6l-0.05 39.5c0 2.93-4.51 6.04-6.7 4.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m781.16 359.53c-0.59 0-1.13-0.13-1.6-0.4l-0.05-0.03l-34.06-23.15c-2.41-1.39-4.33-5.04-4.33-8.27l-3.03-38.99c0-1.5 0.9-2.84 2.49-3.75c1.95-1.12 4.33-1.32 5.79-0.47l36.78 21.38c2.46 1.42 4.38 5.07 4.38 8.3l-0.05 39.5c0 2.08-1.75 4.02-3.49 5.02c-0.99 0.57-1.96 0.86-2.83 0.86zm-0.76-1.8c0.62 0.34 1.69 0.16 2.79-0.47c1.58-0.91 2.67-2.4 2.67-3.61l0.05-39.5c0-2.62-1.63-5.78-3.57-6.9l-36.78-21.38c-0.94-0.54-2.77-0.33-4.17 0.47c-0.5 0.29-1.68 1.1-1.68 2.28l3.03 38.99c0 2.68 1.64 5.84 3.57 6.96l34.08 23.16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m779.51 358.2l-36.78-21.38c-2.2-1.27-3.98-4.67-3.98-7.6l0.05-39.5c0-2.93 1.78-4.28 3.98-3.01l36.78 21.38c2.2 1.27 3.98 4.67 3.98 7.6l-0.05 39.5c0 2.93-1.78 4.28-3.98 3.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m781.09 359.49c-0.64 0-1.31-0.2-1.99-0.59l0 0l-36.78-21.38c-2.46-1.42-4.38-5.07-4.38-8.3l0.05-39.5c0-1.84 0.65-3.27 1.78-3.92c0.98-0.57 2.2-0.5 3.42 0.21l36.78 21.38c2.46 1.42 4.38 5.07 4.38 8.3l-0.05 39.5c0 1.84-0.65 3.27-1.78 3.92c-0.44 0.25-0.92 0.38-1.43 0.38zm-1.18-2c0.49 0.28 1.2 0.55 1.79 0.21c0.61-0.35 0.97-1.29 0.97-2.51l0.05-39.5c0-2.62-1.63-5.78-3.57-6.9l-36.78-21.38c-0.49-0.28-1.2-0.55-1.79-0.21c-0.61 0.35-0.97 1.29-0.97 2.51l-0.05 39.5c0 2.62 1.63 5.78 3.57 6.9l36.78 21.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m782.58 311.6l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m745.14 288.5l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m784.03 354.09l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m787.48 321.22h-0.94v-3.37h0.94v3.37z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m769.34 339.33l-17.44-10.07c-0.84-0.49-1.53-1.79-1.53-2.92v-19.6c0-1.12 0.68-1.64 1.53-1.15l17.44 10.07c0.84 0.49 1.53 1.79 1.53 2.92v19.6c0 1.12-0.68 1.64-1.53 1.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m769.95 340.13c-0.3 0-0.62-0.09-0.92-0.27l-17.44-10.07c-1.03-0.59-1.84-2.11-1.84-3.46v-19.6c0-0.82 0.31-1.47 0.84-1.78c0.47-0.27 1.06-0.24 1.62 0.08l17.44 10.07c1.03 0.6 1.84 2.11 1.84 3.46v19.6c0 0.82-0.31 1.47-0.84 1.78c-0.21 0.12-0.45 0.19-0.7 0.19zm-18.66-34.1c-0.03 0-0.06 0.01-0.08 0.02c-0.08 0.05-0.22 0.24-0.22 0.69v19.6c0 0.89 0.57 2 1.21 2.37l17.44 10.07c0.16 0.09 0.3 0.13 0.37 0.08c0.08-0.05 0.22-0.24 0.22-0.69v-19.6c0-0.89-0.57-2-1.21-2.37l-17.44-10.07c-0.11-0.07-0.21-0.1-0.29-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m763.81 324.71l1.07 0.62c0.22 0.13 0.34 0.5 0.2 0.61l-4.26 3.58c-0.11 0.09-0.3-0.03-0.41-0.24l-4.26-8.51c-0.14-0.28-0.02-0.51 0.2-0.38l1.07 0.62c0.15 0.08 0.26 0.02 0.26-0.15v-5.76c0-0.17 0.12-0.24 0.26-0.15l5.34 3.08c0.14 0.08 0.26 0.29 0.26 0.45v5.76c0 0.17 0.12 0.37 0.26 0.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m760.73 330.02c-0.04 0-0.09 0-0.13-0.01c-0.25-0.05-0.48-0.24-0.61-0.51l-4.26-8.5c-0.17-0.35-0.14-0.71 0.09-0.93c0.2-0.19 0.5-0.22 0.76-0.06l0.63 0.36v-5.26c0-0.25 0.12-0.46 0.31-0.58c0.19-0.11 0.44-0.11 0.65 0.02l5.34 3.08c0.29 0.17 0.5 0.53 0.5 0.86v5.75l1.1 0.67c0.27 0.15 0.47 0.47 0.49 0.79c0.02 0.24-0.06 0.45-0.22 0.59l-4.26 3.58c-0.11 0.09-0.25 0.14-0.39 0.14zm-3.81-8.75l3.85 7.68l3.82-3.21l-1.01-0.63c-0.29-0.17-0.5-0.53-0.5-0.86v-5.76l-4.93-2.88v5.25c0 0.25-0.12 0.46-0.31 0.58c-0.19 0.11-0.44 0.1-0.65-0.02l-0.26-0.15z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m887.77 294.55l-5.71-6.7c-2.2-1.27-3.98-4.67-3.98-7.6l-3.08-9.36c0-2.93 4.87-4.73 7.06-3.46l8.43 4.93c2.2 1.27 3.98 4.67 3.98 7.6l0 9.82c0 2.93-4.51 6.04-6.7 4.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m888.97 295.65c-0.59 0-1.13-0.13-1.6-0.4l-0.21-0.18l-5.62-6.6c-2.37-1.45-4.21-4.95-4.26-8.1l-3.08-9.5c0-1.43 0.91-2.78 2.49-3.69c1.94-1.13 4.33-1.32 5.79-0.47l8.43 4.94c2.45 1.42 4.38 5.07 4.38 8.3l0 9.82c0 2.08-1.75 4.02-3.49 5.02c-0.99 0.57-1.96 0.86-2.84 0.86zm-0.68-1.76c0.63 0.28 1.65 0.09 2.7-0.51c1.58-0.91 2.67-2.39 2.67-3.61l0-9.82c0-2.62-1.63-5.78-3.57-6.9l-8.43-4.94c-0.93-0.54-2.77-0.33-4.17 0.48c-0.49 0.28-1.6 1.04-1.67 2.16l3.08 9.48c0 2.62 1.64 5.78 3.57 6.9l0.21 0.18l5.6 6.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m887.32 294.32l-8.43-4.93c-2.2-1.27-3.98-4.67-3.98-7.6l0-9.82c0-2.93 1.78-4.28 3.98-3.01l8.43 4.93c2.2 1.27 3.98 4.67 3.98 7.6l0 9.82c0 2.93-1.78 4.28-3.98 3.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m888.9 295.61c-0.64 0-1.31-0.2-1.99-0.59l0 0l-8.43-4.93c-2.45-1.42-4.38-5.06-4.38-8.3l0-9.82c0-1.84 0.65-3.27 1.78-3.92c0.99-0.57 2.2-0.49 3.42 0.21l8.43 4.94c2.45 1.42 4.38 5.06 4.38 8.3l0 9.82c0 1.84-0.65 3.27-1.78 3.92c-0.44 0.25-0.92 0.38-1.43 0.38zm-1.17-1.99c0.49 0.28 1.2 0.55 1.79 0.21c0.61-0.35 0.97-1.29 0.97-2.51l0-9.82c0-2.62-1.63-5.78-3.57-6.9l-8.43-4.94c-0.49-0.28-1.2-0.55-1.79-0.21c-0.61 0.35-0.97 1.29-0.97 2.51l0 9.82c0 2.62 1.63 5.78 3.57 6.9l8.43 4.93z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m890.35 277.4l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m881.26 270.75l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m891.84 290.21l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m659.26 186.07l-5.71-6.7c-2.2-1.27-3.98-4.67-3.98-7.6l-3.08-9.36c0-2.93 4.87-4.73 7.06-3.46l8.43 4.93c2.2 1.27 3.98 4.67 3.98 7.6l0 9.82c0 2.93-4.51 6.04-6.7 4.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m660.45 187.17c-0.59 0-1.13-0.13-1.6-0.4l-0.21-0.18l-5.62-6.6c-2.36-1.45-4.21-4.95-4.26-8.1l-3.08-9.5c0-1.43 0.91-2.78 2.49-3.69c1.95-1.12 4.33-1.32 5.79-0.47l8.43 4.93c2.45 1.42 4.38 5.07 4.38 8.3l0 9.82c0 2.08-1.75 4.02-3.49 5.02c-0.99 0.57-1.96 0.86-2.83 0.86zm-0.68-1.76c0.63 0.28 1.65 0.09 2.7-0.51c1.58-0.91 2.67-2.39 2.67-3.61l0-9.82c0-2.62-1.64-5.78-3.57-6.9l-8.43-4.94c-0.93-0.54-2.77-0.33-4.16 0.47c-0.49 0.28-1.6 1.04-1.67 2.17l3.08 9.48c0 2.62 1.64 5.78 3.57 6.9l0.21 0.18l5.6 6.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m658.8 185.84l-8.43-4.93c-2.2-1.27-3.98-4.67-3.98-7.6l0-9.82c0-2.93 1.78-4.28 3.98-3.01l8.43 4.93c2.2 1.27 3.98 4.67 3.98 7.6l0 9.82c0 2.93-1.78 4.28-3.98 3.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m660.39 187.13c-0.64 0-1.31-0.2-1.99-0.59l0 0l-8.43-4.93c-2.46-1.42-4.38-5.07-4.38-8.3l0-9.82c0-1.84 0.65-3.27 1.78-3.92c0.98-0.57 2.2-0.49 3.42 0.21l8.43 4.94c2.45 1.42 4.38 5.07 4.38 8.3l0 9.82c0 1.84-0.65 3.27-1.78 3.92c-0.44 0.25-0.92 0.38-1.43 0.38zm-1.17-1.99c0.49 0.28 1.21 0.55 1.79 0.21c0.61-0.35 0.97-1.29 0.97-2.51l0-9.82c0-2.62-1.63-5.78-3.57-6.9l-8.43-4.93c-0.49-0.28-1.2-0.55-1.79-0.21c-0.61 0.35-0.97 1.29-0.97 2.51l0 9.82c0 2.62 1.64 5.78 3.57 6.9l8.43 4.93z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m661.83 168.92l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m652.74 162.27l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m663.32 181.73l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1023.89 271.45l-5.71-6.7c-2.2-1.27-3.98-4.67-3.98-7.6l-3.08-9.36c0-2.93 4.87-4.73 7.06-3.46l8.43 4.93c2.2 1.27 3.98 4.67 3.98 7.6l0 9.82c0 2.93-4.51 6.04-6.7 4.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1025.09 272.55c-0.59 0-1.13-0.13-1.6-0.4l-0.21-0.18l-5.62-6.6c-2.37-1.45-4.21-4.95-4.26-8.1l-3.08-9.5c0-1.43 0.91-2.78 2.49-3.69c1.95-1.12 4.33-1.32 5.79-0.47l8.43 4.94c2.45 1.42 4.38 5.07 4.38 8.3l0 9.82c0 2.08-1.75 4.02-3.49 5.02c-0.99 0.57-1.96 0.86-2.83 0.86zm-0.68-1.76c0.63 0.28 1.65 0.09 2.7-0.51c1.58-0.91 2.67-2.39 2.67-3.61l0.01-9.82c0-2.62-1.64-5.78-3.57-6.9l-8.43-4.94c-0.93-0.54-2.76-0.33-4.16 0.48c-0.49 0.28-1.6 1.04-1.67 2.17l3.08 9.48c0 2.62 1.64 5.78 3.57 6.9l0.21 0.18l5.6 6.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1023.44 271.22l-8.43-4.93c-2.2-1.27-3.98-4.67-3.98-7.6l0-9.82c0-2.93 1.78-4.28 3.98-3.01l8.43 4.93c2.2 1.27 3.98 4.67 3.98 7.6l0 9.82c0 2.93-1.78 4.28-3.98 3.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1025.02 272.51c-0.63 0-1.31-0.2-1.99-0.59l0 0l-8.43-4.93c-2.45-1.42-4.38-5.06-4.38-8.3l0-9.82c0-1.84 0.65-3.27 1.78-3.92c0.98-0.57 2.2-0.49 3.42 0.21l8.43 4.93c2.45 1.42 4.38 5.06 4.38 8.3l0 9.82c0 1.84-0.65 3.27-1.78 3.92c-0.44 0.25-0.92 0.38-1.43 0.38zm-1.17-1.99c0.49 0.28 1.2 0.55 1.79 0.21c0.61-0.35 0.97-1.29 0.97-2.51l0-9.82c0-2.62-1.64-5.78-3.57-6.9l-8.43-4.94c-0.49-0.28-1.2-0.55-1.79-0.21c-0.61 0.35-0.97 1.29-0.97 2.51l0 9.82c0 2.62 1.63 5.78 3.57 6.9l8.43 4.93z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1026.47 254.3l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1017.38 247.65l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1027.96 267.11l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m779.33 154.21l-5.71-6.7c-2.2-1.27-3.98-4.67-3.98-7.6l-3.08-9.36c0-2.93 4.87-4.73 7.06-3.46l8.43 4.93c2.2 1.27 3.98 4.67 3.98 7.6l0 9.82c0 2.93-4.51 6.04-6.7 4.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m780.52 155.32c-0.59 0-1.13-0.13-1.6-0.4l-0.21-0.18l-5.62-6.6c-2.37-1.45-4.21-4.95-4.26-8.1l-3.08-9.5c0-1.43 0.91-2.78 2.49-3.69c1.95-1.12 4.33-1.32 5.79-0.47l8.43 4.94c2.45 1.42 4.38 5.06 4.38 8.3l0 9.82c0 2.08-1.75 4.02-3.49 5.02c-0.99 0.57-1.96 0.86-2.84 0.86zm-0.68-1.76c0.63 0.28 1.65 0.09 2.7-0.52c1.58-0.91 2.67-2.39 2.67-3.61l0-9.82c0-2.62-1.63-5.78-3.57-6.9l-8.43-4.94c-0.93-0.54-2.76-0.33-4.16 0.47c-0.49 0.28-1.6 1.04-1.67 2.17l3.08 9.48c0 2.62 1.64 5.78 3.57 6.9l0.21 0.18l5.6 6.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m778.87 153.98l-8.43-4.93c-2.2-1.27-3.98-4.67-3.98-7.6l0-9.82c0-2.93 1.78-4.28 3.98-3.01l8.43 4.93c2.2 1.27 3.98 4.67 3.98 7.6l0 9.82c0 2.93-1.78 4.28-3.98 3.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m780.46 155.28c-0.64 0-1.31-0.2-1.99-0.59l0 0l-8.43-4.93c-2.45-1.42-4.38-5.07-4.38-8.3l0-9.82c0-1.84 0.65-3.27 1.78-3.92c0.99-0.57 2.2-0.49 3.42 0.21l8.43 4.93c2.45 1.42 4.38 5.07 4.38 8.3l0 9.82c0 1.84-0.65 3.27-1.78 3.92c-0.44 0.25-0.92 0.38-1.43 0.38zm-1.17-1.99c0.49 0.28 1.2 0.55 1.79 0.21c0.61-0.35 0.97-1.29 0.97-2.51l0-9.82c0-2.62-1.63-5.78-3.57-6.9l-8.43-4.94c-0.49-0.28-1.2-0.55-1.79-0.21c-0.61 0.35-0.97 1.29-0.97 2.51l0 9.82c0 2.62 1.63 5.78 3.57 6.9l8.43 4.93z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m781.9 137.07l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m772.81 130.41l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m783.39 149.87l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m945.93 182.28l-34.06-23.15c-2.2-1.27-3.98-4.67-3.98-7.6l-3.04-39.05c0-2.93 4.87-4.73 7.06-3.46l36.78 21.38c2.2 1.27 3.98 4.67 3.98 7.6l-0.05 39.5c0 2.93-4.51 6.04-6.7 4.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m947.12 183.39c-0.59 0-1.13-0.13-1.6-0.4l-0.05-0.03l-34.06-23.15c-2.41-1.39-4.33-5.04-4.33-8.27l-3.03-38.99c0-1.5 0.9-2.84 2.49-3.75c1.95-1.12 4.33-1.32 5.79-0.47l36.78 21.38c2.46 1.42 4.38 5.07 4.38 8.3l-0.05 39.5c0 2.08-1.75 4.02-3.49 5.02c-0.99 0.57-1.96 0.86-2.84 0.86zm-0.76-1.8c0.62 0.34 1.69 0.16 2.79-0.47c1.58-0.91 2.67-2.39 2.67-3.61l0.05-39.5c0-2.62-1.63-5.78-3.57-6.9l-36.78-21.38c-0.94-0.54-2.77-0.33-4.17 0.47c-0.5 0.29-1.68 1.1-1.68 2.28l3.03 38.99c0 2.68 1.64 5.84 3.57 6.96l34.08 23.16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m945.47 182.05l-36.78-21.38c-2.2-1.27-3.98-4.67-3.98-7.6l0.05-39.5c0-2.93 1.78-4.28 3.98-3.01l36.78 21.38c2.2 1.27 3.98 4.67 3.98 7.6l-0.05 39.5c0 2.93-1.78 4.28-3.98 3.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m947.05 183.35c-0.64 0-1.31-0.2-1.99-0.59l0 0l-36.78-21.38c-2.46-1.42-4.38-5.06-4.38-8.3l0.05-39.5c0-1.84 0.65-3.27 1.78-3.92c0.98-0.57 2.2-0.49 3.42 0.21l36.78 21.38c2.46 1.42 4.38 5.07 4.38 8.3l-0.05 39.5c0 1.84-0.65 3.27-1.78 3.92c-0.44 0.25-0.92 0.38-1.43 0.38zm-1.18-2c0.49 0.28 1.21 0.55 1.79 0.21c0.61-0.35 0.97-1.29 0.97-2.51l0.05-39.5c0-2.62-1.63-5.78-3.57-6.9l-36.78-21.38c-0.49-0.28-1.2-0.55-1.79-0.21c-0.61 0.35-0.97 1.29-0.97 2.51l-0.05 39.5c0 2.62 1.63 5.78 3.57 6.9l36.78 21.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m948.54 135.45l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m911.1 112.35l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m949.99 177.94l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m935.83 162.46l-17.44-10.07c-0.84-0.49-1.53-1.79-1.53-2.92v-19.6c0-1.12 0.68-1.64 1.53-1.15l17.44 10.07c0.84 0.49 1.53 1.79 1.53 2.92v19.6c0 1.12-0.68 1.64-1.53 1.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m936.44 163.27c-0.3 0-0.61-0.09-0.92-0.27l-17.44-10.07c-1.03-0.6-1.84-2.11-1.84-3.46v-19.6c0-0.82 0.31-1.47 0.84-1.78c0.47-0.27 1.06-0.24 1.62 0.08l17.44 10.07c1.03 0.6 1.84 2.11 1.84 3.46v19.6c0 0.82-0.31 1.47-0.84 1.78c-0.21 0.12-0.45 0.19-0.7 0.19zm-18.66-34.1c-0.03 0-0.06 0.01-0.08 0.02c-0.08 0.05-0.22 0.24-0.22 0.69v19.6c0 0.89 0.57 2 1.21 2.37l17.44 10.07c0.16 0.09 0.3 0.13 0.37 0.08c0.08-0.05 0.22-0.24 0.22-0.69v-19.6c0-0.89-0.57-2-1.21-2.37l-17.44-10.07c-0.11-0.07-0.21-0.1-0.29-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m932.67 148.8c0 3.55-2.49 4.99-5.57 3.21c-3.07-1.78-5.57-6.09-5.57-9.64c0-3.55 2.49-4.99 5.57-3.21c3.07 1.78 5.57 6.09 5.57 9.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m929.59 153.25c-0.85 0-1.77-0.28-2.72-0.83c-3.2-1.85-5.8-6.35-5.8-10.05c0-1.89 0.66-3.32 1.86-4.01c1.2-0.69 2.77-0.56 4.41 0.39c3.2 1.85 5.8 6.35 5.8 10.05c0 1.89-0.66 3.32-1.86 4.01c-0.5 0.29-1.07 0.44-1.68 0.44zm-4.97-14.38c-0.45 0-0.86 0.1-1.22 0.31c-0.9 0.52-1.4 1.66-1.4 3.2c0 3.4 2.39 7.54 5.33 9.24c1.34 0.77 2.57 0.91 3.47 0.39c0.9-0.52 1.4-1.66 1.4-3.2c0-3.39-2.39-7.54-5.33-9.24c-0.8-0.46-1.57-0.7-2.25-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m931.28 148c0 2.66-1.87 3.74-4.17 2.41c-2.3-1.33-4.17-4.56-4.17-7.22c0-2.66 1.87-3.74 4.17-2.41c2.3 1.33 4.17 4.56 4.17 7.22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m928.97 151.45c-0.65 0-1.37-0.21-2.1-0.64c-2.43-1.4-4.4-4.82-4.4-7.63c0-1.46 0.52-2.56 1.46-3.11c0.94-0.54 2.15-0.44 3.42 0.29c2.43 1.4 4.4 4.82 4.4 7.63c0 1.46-0.52 2.56-1.46 3.11c-0.4 0.23-0.84 0.34-1.32 0.34zm-3.72-10.77c-0.32 0-0.6 0.07-0.85 0.22c-0.64 0.37-0.99 1.18-0.99 2.29c0 2.51 1.77 5.56 3.94 6.82c0.96 0.56 1.84 0.66 2.48 0.29c0.64-0.37 0.99-1.18 0.99-2.29c0-2.51-1.77-5.56-3.94-6.82c-0.58-0.34-1.14-0.51-1.63-0.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m928.98 149.05l-2.35-3.31v-2.95h0.94v2.66l2.17 3.06l-0.76 0.54z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m859.19 333.76l-66.71-44.84c-2.2-1.27-5.91-2.97-5.91-5.9l-3.08-52.13c0-2.93 4.87-4.73 7.06-3.46l71.36 41.38c2.2 1.27 3.98 4.67 3.98 7.6v52.59c0 2.93-4.51 6.04-6.7 4.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m860.38 334.87c-0.59 0-1.13-0.13-1.6-0.4l-0.05-0.03l-66.71-44.84c-0.19-0.11-0.45-0.25-0.71-0.4c-2.34-1.31-5.55-3.09-5.55-6.18l-3.08-52.08c0-1.48 0.9-2.83 2.49-3.74c1.94-1.12 4.33-1.32 5.79-0.47l71.36 41.38c2.46 1.42 4.38 5.07 4.38 8.3v52.58c0 2.08-1.75 4.02-3.49 5.02c-0.99 0.57-1.97 0.86-2.84 0.86zm-0.76-1.8c0.62 0.34 1.69 0.16 2.79-0.47c1.58-0.91 2.67-2.39 2.67-3.61v-52.58c0-2.62-1.64-5.78-3.57-6.9l-71.36-41.38c-0.94-0.54-2.77-0.33-4.17 0.47c-0.5 0.29-1.67 1.1-1.67 2.28l3.08 52.08c0 2.18 2.73 3.7 4.72 4.81c0.27 0.15 0.54 0.3 0.78 0.44l66.73 44.85z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m858.74 329.54l-71.36-41.38c-2.2-1.27-3.98-4.67-3.98-7.6v-52.59c0-2.93 1.78-4.28 3.98-3.01l71.36 41.38c2.2 1.27 3.98 4.67 3.98 7.6v52.59c0 2.93-1.78 4.28-3.98 3.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m860.32 334.83c-0.63 0-1.31-0.2-1.99-0.59l0 0l-71.36-41.38c-2.46-1.42-4.38-5.07-4.38-8.3v-52.59c0-1.84 0.65-3.27 1.78-3.92c0.98-0.57 2.2-0.49 3.42 0.21l71.36 41.38c2.46 1.42 4.38 5.07 4.38 8.3v52.59c0 1.84-0.65 3.27-1.78 3.92c-0.44 0.25-0.92 0.38-1.43 0.38zm-1.17-2c0.49 0.28 1.2 0.55 1.79 0.21c0.61-0.35 0.97-1.29 0.97-2.51v-52.59c0-2.62-1.63-5.78-3.57-6.9l-71.36-41.38c-0.49-0.28-1.2-0.55-1.79-0.21c-0.61 0.35-0.97 1.29-0.97 2.51v52.59c0 2.62 1.63 5.78 3.57 6.9l71.36 41.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m861.76 273.85l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m789.74 230.75l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m863.25 329.43l-0.5-0.8l2.99-1.86l0.5 0.8l-2.99 1.86z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m807.57 260.41c0-1.56 0.95-2.28 2.12-1.61l35.05 20.23c1.17 0.68 2.12 2.49 2.12 4.06c0 1.56-0.95 2.28-2.12 1.61l-35.05-20.23c-1.17-0.68-2.12-2.49-2.12-4.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m845.58 285.58c-0.37 0-0.77-0.11-1.16-0.34l-35.05-20.23c-1.37-0.79-2.44-2.81-2.44-4.6c0-1.05 0.38-1.87 1.05-2.26c0.59-0.34 1.3-0.3 2.02 0.11l35.05 20.23c1.37 0.79 2.44 2.81 2.44 4.6c0 1.05-0.38 1.88-1.05 2.26c-0.26 0.15-0.55 0.23-0.86 0.23zm-35.58-21.65l35.05 20.23c0.18 0.1 0.52 0.26 0.77 0.11c0.26-0.15 0.42-0.6 0.42-1.18c0-1.34-0.83-2.95-1.81-3.52l-35.05-20.23c-0.18-0.1-0.52-0.26-0.77-0.11c-0.26 0.15-0.42 0.6-0.42 1.18c0 1.34 0.83 2.95 1.81 3.52z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m800.74 253.76c1.38 0.8 2.5 2.74 2.5 4.33c0 1.59-1.12 2.24-2.5 1.44c-1.38-0.8-2.5-2.74-2.5-4.33c0-1.59 1.12-2.24 2.5-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m801.86 260.5c-0.45 0-0.94-0.14-1.43-0.43c-1.58-0.91-2.81-3.05-2.81-4.87c0-1 0.37-1.77 1.05-2.16c0.67-0.39 1.52-0.33 2.39 0.18c1.58 0.91 2.81 3.05 2.81 4.87c0 1-0.37 1.77-1.04 2.16c-0.29 0.17-0.62 0.25-0.96 0.25zm-2.23-6.46c-0.13 0-0.24 0.03-0.34 0.08c-0.27 0.15-0.42 0.55-0.42 1.08c0 1.37 1 3.1 2.19 3.79c0.46 0.26 0.87 0.33 1.14 0.18c0.27-0.15 0.42-0.55 0.42-1.08c0-1.37-1-3.1-2.19-3.79c-0.29-0.17-0.57-0.26-0.8-0.26z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m807.57 272.84c0-1.56 0.95-2.28 2.12-1.61l35.05 20.23c1.17 0.68 2.12 2.49 2.12 4.06c0 1.56-0.95 2.28-2.12 1.61l-35.05-20.23c-1.17-0.68-2.12-2.49-2.12-4.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m845.58 298.01c-0.37 0-0.77-0.11-1.16-0.34l-35.05-20.23c-1.37-0.79-2.44-2.81-2.44-4.6c0-1.05 0.38-1.88 1.05-2.26c0.59-0.34 1.3-0.3 2.02 0.11l35.05 20.23c1.37 0.79 2.44 2.81 2.44 4.6c0 1.05-0.38 1.88-1.05 2.26c-0.26 0.15-0.55 0.23-0.86 0.23zm-36.74-26.4c-0.08 0-0.16 0.02-0.24 0.06c-0.26 0.15-0.42 0.6-0.42 1.18c0 1.34 0.83 2.95 1.81 3.52l35.05 20.23c0.18 0.1 0.51 0.26 0.77 0.11c0.26-0.15 0.42-0.6 0.42-1.18c0-1.34-0.83-2.95-1.81-3.52l-35.05-20.23c-0.13-0.07-0.33-0.17-0.53-0.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m800.74 266.19c1.38 0.8 2.5 2.74 2.5 4.33c0 1.59-1.12 2.24-2.5 1.44c-1.38-0.8-2.5-2.74-2.5-4.33c0-1.59 1.12-2.24 2.5-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m801.86 272.93c-0.45 0-0.94-0.14-1.43-0.43c-1.58-0.91-2.81-3.05-2.81-4.87c0-1 0.37-1.77 1.05-2.16c0.67-0.39 1.52-0.33 2.39 0.17c1.58 0.91 2.81 3.05 2.81 4.87c0 1-0.37 1.77-1.04 2.16c-0.29 0.17-0.62 0.25-0.96 0.25zm-2.23-6.46c-0.13 0-0.24 0.03-0.34 0.08c-0.27 0.15-0.42 0.55-0.42 1.08c0 1.37 1 3.1 2.19 3.79c0.46 0.27 0.88 0.33 1.14 0.18c0.27-0.15 0.42-0.55 0.42-1.08c0-1.37-1-3.1-2.19-3.79c-0.29-0.17-0.57-0.26-0.8-0.26z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m807.57 285.27c0-1.56 0.95-2.28 2.12-1.61l35.05 20.23c1.17 0.68 2.12 2.49 2.12 4.06c0 1.56-0.95 2.28-2.12 1.61l-35.05-20.23c-1.17-0.68-2.12-2.49-2.12-4.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m845.58 309.43c-0.37 0-0.77-0.11-1.16-0.34l-35.05-20.23c-1.37-0.79-2.44-2.81-2.44-4.6c0-1.05 0.38-1.88 1.05-2.26c0.59-0.34 1.3-0.3 2.02 0.11l35.05 20.23c1.37 0.79 2.44 2.81 2.44 4.6c0 1.05-0.38 1.88-1.05 2.26c-0.26 0.15-0.55 0.23-0.86 0.23zm-36.74-26.4c-0.08 0-0.16 0.02-0.23 0.06c-0.26 0.15-0.42 0.6-0.42 1.18c0 1.34 0.83 2.95 1.81 3.52l35.05 20.23c0.18 0.1 0.52 0.26 0.77 0.11c0.26-0.15 0.42-0.6 0.42-1.18c0-1.34-0.83-2.95-1.81-3.52l-35.05-20.23c-0.13-0.07-0.33-0.17-0.53-0.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m800.74 278.61c1.38 0.8 2.5 2.74 2.5 4.33c0 1.59-1.12 2.24-2.5 1.44c-1.38-0.8-2.5-2.74-2.5-4.33c0-1.59 1.12-2.24 2.5-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m801.86 285.36c-0.45 0-0.94-0.14-1.43-0.43c-1.58-0.91-2.81-3.05-2.81-4.87c0-1 0.37-1.77 1.05-2.16c0.67-0.39 1.52-0.33 2.39 0.17c1.58 0.91 2.81 3.05 2.81 4.87c0 1-0.37 1.77-1.04 2.16c-0.29 0.17-0.62 0.25-0.96 0.25zm-2.23-6.46c-0.13 0-0.24 0.03-0.34 0.08c-0.27 0.15-0.42 0.55-0.42 1.08c0 1.37 1 3.1 2.19 3.79c0.46 0.26 0.87 0.33 1.14 0.18c0.27-0.15 0.42-0.55 0.42-1.08c0-1.37-1-3.1-2.19-3.79c-0.29-0.17-0.57-0.26-0.8-0.26z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m992.92 424.57l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m995.48 425.93l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m997.79 427.38l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1000.4 428.72l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1002.55 430.21l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1005.1 431.57l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1007.42 433.03l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1010.03 434.36l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1012.34 435.81l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1014.94 437.17l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1017.26 438.62l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1019.87 439.95l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1022.01 441.45l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1024.57 442.81l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1026.89 444.26l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1029.49 445.6l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1031.81 447.05l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m982.99 419.05l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m985.54 420.41l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m987.86 421.86l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m990.47 423.19l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m992.79 424.65l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1013.28 403.47l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1015.84 404.83l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1018.15 406.29l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1020.76 407.62l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1022.91 409.12l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1025.46 410.48l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1027.78 411.93l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1030.39 413.26l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1032.7 414.72l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1035.3 416.07l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1037.62 417.52l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1040.23 418.86l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1042.37 420.35l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1044.93 421.72l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1047.25 423.17l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1049.85 424.5l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1052.17 425.95l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1003.35 397.95l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1005.9 399.31l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1008.22 400.76l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1010.83 402.1l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1013.15 403.55l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1061.94 322.08v58.78h-0.01c0.06 0.8-0.38 1.58-1.37 2.15l-9.71 5.61c-2.05 1.19-5.64 1.04-8.01-0.33l-8.56-4.94c-1.23-0.71-1.88-1.61-1.94-2.48h-0.01l-0.01-58.74c0-0.32 0.26-0.59 0.58-0.59l28.45-0.04c0.32 0 0.59 0.26 0.59 0.59z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1047.36 390.3c-1.72 0-3.53-0.42-4.96-1.25l-8.56-4.94c-1.12-0.64-1.87-1.46-2.2-2.36h-0.18l-0.01-0.88l-0.01-58.74c0-0.8 0.65-1.46 1.46-1.47l28.46-0.04c0.81 0 1.46 0.66 1.46 1.46v59.66h-0.1c-0.23 0.8-0.82 1.51-1.71 2.03l-9.71 5.61c-1.07 0.62-2.47 0.92-3.93 0.92zm-14.16-9.57l0.01 0.07c0.04 0.61 0.59 1.25 1.51 1.78l8.56 4.94c2.09 1.21 5.36 1.36 7.13 0.33l9.71-5.61c0.45-0.26 0.98-0.7 0.93-1.32l-0.07-0.94h0.07v-57.61l-27.87 0.04l0.01 58.32z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1061.94 322.1v58.78h-0.01c0.06 0.8-0.38 1.58-1.37 2.15l-9.71 5.61c-0.72 0.41-1.62 0.65-2.59 0.75v-67.85l13.1-0.02c0.32 0 0.59 0.26 0.59 0.59z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1060.56 323.68l-9.71 5.61c-2.05 1.19-5.64 1.04-8.01-0.33l-8.56-4.94c-2.37-1.37-2.63-3.44-0.58-4.63l9.71-5.61c2.05-1.19 5.64-1.04 8.01 0.33l8.56 4.94c2.37 1.37 2.63 3.44 0.58 4.63z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1047.36 330.97c-1.72 0-3.52-0.42-4.96-1.25l-8.56-4.94c-1.52-0.88-2.4-2.11-2.4-3.38c0-1.11 0.65-2.09 1.82-2.77l9.71-5.61c2.33-1.35 6.24-1.2 8.89 0.33l8.56 4.94c1.52 0.88 2.4 2.11 2.4 3.38c0 1.11-0.65 2.09-1.82 2.77l-9.71 5.61c-1.07 0.62-2.47 0.92-3.93 0.92zm-0.48-17.11c-1.15 0-2.24 0.22-3.03 0.68l-9.71 5.61c-0.43 0.25-0.95 0.67-0.95 1.25c0 0.61 0.57 1.31 1.52 1.86l8.56 4.94c2.09 1.21 5.35 1.36 7.13 0.33l9.71-5.61c0.43-0.25 0.95-0.67 0.95-1.25c0-0.61-0.57-1.31-1.52-1.86l-8.56-4.94c-1.16-0.67-2.68-1.01-4.1-1.01z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1044.63 388.7h-1.76v-59.28h1.76v59.28z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1059.28 381.59h-1.35v-54.54h1.35v54.54z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1042.04 372.74v29.08h-0.01c0.06 0.8-0.38 1.58-1.37 2.15l-9.71 5.61c-2.05 1.19-5.64 1.04-8.01-0.33l-8.56-4.94c-1.23-0.71-1.88-1.61-1.94-2.48h-0.01l-0.01-29.03c0-0.32 0.26-0.59 0.58-0.59l28.45-0.04c0.32 0 0.59 0.26 0.59 0.59z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1027.46 411.26c-1.72 0-3.53-0.42-4.96-1.25l-8.56-4.94c-1.12-0.64-1.87-1.46-2.2-2.36h-0.18l-0.01-0.88l-0.01-29.03c0-0.81 0.66-1.46 1.46-1.46l28.45-0.04c0 0 0 0 0.01 0c0.39 0 0.76 0.15 1.03 0.43c0.28 0.28 0.43 0.64 0.43 1.04v29.96h-0.1c-0.23 0.8-0.82 1.51-1.71 2.03l-9.71 5.61c-1.07 0.62-2.47 0.92-3.93 0.92zm-14.16-9.57l0.01 0.07c0.04 0.61 0.59 1.25 1.51 1.78l8.56 4.94c2.09 1.2 5.36 1.36 7.13 0.33l9.71-5.61c0.45-0.26 0.98-0.7 0.93-1.32l-0.07-0.94h0.07v-27.91l-27.87 0.04l0.01 28.61z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1042.04 372.77v29.08h-0.01c0.06 0.8-0.38 1.58-1.37 2.15l-9.71 5.61c-0.72 0.41-1.62 0.65-2.59 0.75v-38.15l13.1-0.02c0.32 0 0.59 0.26 0.59 0.59z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1040.66 374.35l-9.71 5.61c-2.05 1.19-5.64 1.04-8.01-0.33l-8.56-4.94c-2.37-1.37-2.63-3.44-0.58-4.63l9.71-5.61c2.05-1.19 5.64-1.04 8.01 0.33l8.56 4.94c2.37 1.37 2.63 3.44 0.58 4.63z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1027.46 381.64c-1.72 0-3.53-0.42-4.96-1.25l-8.56-4.94c-1.52-0.88-2.4-2.11-2.4-3.38c0-1.11 0.65-2.09 1.83-2.77l9.71-5.61c2.33-1.35 6.24-1.2 8.89 0.33l8.56 4.94c1.53 0.88 2.4 2.11 2.4 3.38c0 1.11-0.65 2.09-1.82 2.77l-9.71 5.61c-1.07 0.62-2.47 0.92-3.93 0.92zm-0.48-17.11c-1.15 0-2.24 0.22-3.03 0.68l-9.71 5.61c-0.43 0.25-0.95 0.67-0.95 1.25c0 0.61 0.57 1.31 1.52 1.86l8.56 4.94c2.09 1.2 5.36 1.36 7.13 0.33l9.71-5.61c0.43-0.25 0.95-0.67 0.95-1.25c0-0.61-0.57-1.31-1.52-1.86l-8.56-4.94c-1.16-0.67-2.68-1.01-4.1-1.01z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1024.73 409.65h-1.76v-29.58h1.76v29.58z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1039.38 402.55h-1.35v-24.83h1.35v24.83z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1061.58 289.41c0.1 0.05 0.14 0.17 0.09 0.27l-1.6 3.2l-11.75 22.61l-0.88 7.07c-0.01 0.05-0.06 0.08-0.11 0.05l-4.53-2.45l-9.93-14.49c-0.16-0.24 0.22-0.79 0.45-0.65l4.87 2.48l0.76 0.91l3.48 2.1l1.07-0.11l12.9-23.13c0.16-0.28 0.37-0.3 0.45-0.17l4.73 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1047.4 323.33l-0.36-0.16l-4.66-2.52l-10.02-14.61c-0.29-0.42-0.12-0.99 0.2-1.33c0.32-0.33 0.74-0.42 1.09-0.21l5.02 2.61l0.69 0.83l3.22 1.94l0.54-0.06l12.74-22.85c0.2-0.35 0.5-0.56 0.84-0.57c0.21-0.04 0.39 0.07 0.53 0.19l4.62 2.25c0.19 0.09 0.35 0.27 0.42 0.47c0.07 0.21 0.05 0.44-0.05 0.64l-1.6 3.2l-11.7 22.52l-0.9 7.29l-0.63 0.36zm-4.16-3.63l3.69 1.99l0.84-6.48l13.16-25.42l-4.09-1.99l-12.94 23.2l-1.6 0.16l-3.82-2.34l-0.68-0.81l-3.94-2.01l9.38 13.69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1038.19 307.51l9.81 5.91c0.03 0.02 0.09-0.01 0.12-0.07l13.15-23.59c0.24-0.43 0.63-0.29 0.44 0.15l-13.9 32.66c-0.04 0.08-0.12 0.13-0.15 0.08l-9.93-14.49c-0.16-0.24 0.22-0.79 0.45-0.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1047.41 323.33l-0.25-0.33l-9.93-14.49c-0.29-0.42-0.12-0.99 0.2-1.33c0.32-0.33 0.74-0.42 1.09-0.21l9.32 5.61l12.9-23.13c0.32-0.57 0.85-0.68 1.22-0.5c0.34 0.17 0.59 0.61 0.34 1.2l-13.9 32.66c-0.11 0.26-0.35 0.45-0.62 0.47l-0.37 0.04zm-8.6-14.71l8.8 12.84l10.62-24.96l-9.69 17.38l-0.34 0.14c-0.17 0.05-0.36 0.02-0.52-0.07l-8.86-5.34z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m929.48 524.2l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m932.03 525.56l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m934.35 527.01l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m936.95 528.34l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m939.1 529.84l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m941.66 531.2l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m943.98 532.65l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m946.58 533.99l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m948.9 535.44l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m951.5 536.8l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m953.81 538.25l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m956.42 539.58l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m958.57 541.08l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m961.12 542.44l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m963.44 543.89l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m966.05 545.23l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m968.37 546.68l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m919.54 518.68l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m922.1 520.04l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m924.42 521.49l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m927.02 522.82l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m929.34 524.27l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m979.72 492.76v8.82h-0.01c0.06 0.8-0.38 1.58-1.37 2.15l-9.71 5.61c-2.05 1.19-5.64 1.04-8.01-0.33l-8.56-4.94c-1.23-0.71-1.88-1.61-1.94-2.48h-0.01l-0.01-8.78c0-0.32 0.26-0.59 0.58-0.59l28.45-0.04c0.32 0 0.59 0.26 0.59 0.59z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m965.14 511.02c-1.72 0-3.53-0.42-4.96-1.25l-8.56-4.94c-1.12-0.64-1.87-1.46-2.2-2.36h-0.18l-0.01-0.88l-0.01-8.78c0-0.39 0.15-0.76 0.43-1.03c0.28-0.28 0.64-0.43 1.03-0.43l28.45-0.04h0c0.37-0.04 0.76 0.15 1.04 0.43c0.28 0.28 0.43 0.64 0.43 1.04v9.7h-0.1c-0.22 0.8-0.82 1.51-1.71 2.03l-9.71 5.61c-1.07 0.62-2.47 0.92-3.93 0.92zm-14.16-9.58l0.01 0.08c0.04 0.61 0.59 1.26 1.51 1.78l8.56 4.94c2.09 1.2 5.36 1.36 7.13 0.33l9.71-5.61c0.45-0.26 0.98-0.7 0.93-1.32l-0.07-0.94h0.08v-7.65l-27.87 0.04l0.01 8.35z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m979.72 492.78v8.82h-0.01c0.06 0.8-0.38 1.58-1.37 2.15l-9.71 5.61c-0.72 0.41-1.62 0.65-2.59 0.75v-17.89l13.1-0.02c0.32 0 0.59 0.26 0.59 0.59z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m978.34 494.36l-9.71 5.61c-2.05 1.19-5.64 1.04-8.01-0.33l-8.56-4.94c-2.37-1.37-2.63-3.44-0.58-4.63l9.71-5.61c2.05-1.19 5.64-1.04 8.01 0.33l8.56 4.94c2.37 1.37 2.63 3.44 0.58 4.63z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m965.14 501.65c-1.72 0-3.53-0.42-4.96-1.25l-8.56-4.94c-1.53-0.88-2.4-2.11-2.4-3.38c0-1.11 0.65-2.09 1.83-2.77l9.71-5.61c2.33-1.35 6.23-1.2 8.89 0.33l8.56 4.94c1.52 0.88 2.4 2.11 2.4 3.38c0 1.11-0.65 2.09-1.83 2.77h0l-9.71 5.61c-1.07 0.62-2.47 0.92-3.93 0.92zm-0.48-17.11c-1.15 0-2.24 0.22-3.03 0.68l-9.71 5.61c-0.43 0.25-0.95 0.67-0.95 1.25c0 0.61 0.57 1.31 1.52 1.86l8.56 4.94c2.09 1.2 5.36 1.36 7.13 0.33l9.71-5.61c0.43-0.25 0.95-0.67 0.95-1.25c0-0.61-0.57-1.31-1.52-1.86l-8.56-4.94c-1.16-0.67-2.68-1.01-4.1-1.01z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m962.41 509.41h-1.75v-9.32h1.75v9.32z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m977.06 502.31h-1.35v-4.58h1.35v4.58z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1092.95 479.75l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1095.51 481.11l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1097.83 482.56l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1100.43 483.9l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1102.58 485.39l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1105.13 486.76l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1107.45 488.21l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1110.06 489.54l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1112.38 490.99l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1114.97 492.35l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1117.29 493.8l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1119.9 495.14l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1122.05 496.63l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1124.6 498l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1126.92 499.45l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1129.52 500.78l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1131.84 502.23l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1083.02 474.23l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1085.58 475.59l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1087.89 477.04l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1090.5 478.38l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1092.82 479.83l-0.47-0.81l55.86-32.2l0.47 0.81l-55.86 32.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1143.19 448.31v8.82h-0.01c0.06 0.8-0.38 1.58-1.37 2.15l-9.71 5.61c-2.05 1.19-5.64 1.04-8.01-0.33l-8.56-4.94c-1.23-0.71-1.88-1.61-1.94-2.48h-0.01l-0.01-8.78c0-0.32 0.26-0.59 0.58-0.59l28.45-0.04c0.32 0 0.59 0.26 0.59 0.59z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1128.62 466.57c-1.72 0-3.53-0.42-4.96-1.25l-8.56-4.94c-1.12-0.64-1.87-1.46-2.2-2.36h-0.18l-0.01-0.88l-0.01-8.78c0-0.39 0.15-0.76 0.43-1.03c0.28-0.28 0.64-0.43 1.03-0.43l28.45-0.04h0c0.37-0.04 0.76 0.15 1.04 0.43c0.28 0.28 0.43 0.64 0.43 1.04v9.7h-0.11c-0.22 0.8-0.82 1.51-1.71 2.03l-9.71 5.61c-1.07 0.62-2.47 0.92-3.93 0.92zm-14.16-9.58l0.01 0.08c0.04 0.61 0.59 1.26 1.51 1.78l8.56 4.94c2.09 1.2 5.36 1.36 7.13 0.33l9.71-5.61c0.45-0.26 0.98-0.7 0.93-1.32l-0.07-0.94h0.08v-7.65l-27.87 0.04l0.01 8.35z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1143.19 448.34v8.82h-0.01c0.06 0.8-0.38 1.58-1.37 2.15l-9.71 5.61c-0.72 0.41-1.62 0.65-2.59 0.75v-17.89l13.1-0.02c0.32 0 0.59 0.26 0.59 0.59z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1141.82 449.92l-9.71 5.61c-2.05 1.19-5.64 1.04-8.01-0.33l-8.56-4.94c-2.37-1.37-2.63-3.44-0.57-4.63l9.71-5.61c2.05-1.19 5.64-1.04 8.01 0.33l8.56 4.94c2.37 1.37 2.63 3.44 0.58 4.63z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m1128.62 457.2c-1.72 0-3.53-0.42-4.96-1.25l-8.56-4.94c-1.52-0.88-2.4-2.11-2.4-3.38c0-1.11 0.65-2.09 1.83-2.77l9.71-5.61c2.33-1.35 6.23-1.2 8.89 0.33l8.56 4.94c1.52 0.88 2.4 2.11 2.4 3.38c0 1.11-0.65 2.09-1.83 2.77h0l-9.71 5.61c-1.07 0.62-2.47 0.92-3.93 0.92zm-0.48-17.11c-1.15 0-2.24 0.22-3.03 0.68l-9.71 5.61c-0.43 0.25-0.95 0.67-0.95 1.25c0 0.61 0.57 1.31 1.52 1.86l8.56 4.94c2.09 1.2 5.36 1.36 7.13 0.33l9.71-5.61c0.43-0.25 0.95-0.67 0.95-1.25c0-0.61-0.57-1.31-1.52-1.86l-8.56-4.94c-1.16-0.67-2.68-1.01-4.1-1.01z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1125.89 464.97h-1.76v-9.32h1.76v9.32z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1140.54 457.86h-1.35v-4.58h1.35v4.58z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalization);
export default __webpack_public_path__ + "static/media/digitalization.f749b78e4b84a5649602776648b6d34b.svg";
export { ForwardRef as ReactComponent };